var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNnIconFlagsMxDelivery = function SvgNnIconFlagsMxDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nn-icon-flags-MX-delivery_svg__Lager_62",
    "data-name": "Lager 62",
    viewBox: "0 0 50.47 33.81"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".nn-icon-flags-MX-delivery_svg__cls-1{fill:#fff}.nn-icon-flags-MX-delivery_svg__cls-5{fill:#a6ac56}.nn-icon-flags-MX-delivery_svg__cls-7{fill:#6a7311}.nn-icon-flags-MX-delivery_svg__cls-10{fill:#ffad1a}.nn-icon-flags-MX-delivery_svg__cls-11{fill:#8f5e36}.nn-icon-flags-MX-delivery_svg__cls-12{fill:#af7029}.nn-icon-flags-MX-delivery_svg__cls-13{fill:#816c2a}.nn-icon-flags-MX-delivery_svg__cls-16{fill:#016848}.nn-icon-flags-MX-delivery_svg__cls-17{fill:#e92736}.nn-icon-flags-MX-delivery_svg__cls-19{fill:#0872a7}.nn-icon-flags-MX-delivery_svg__cls-20{fill:#f9aa51}.nn-icon-flags-MX-delivery_svg__cls-21{fill:#953220}.nn-icon-flags-MX-delivery_svg__cls-22{fill:#04534e}.nn-icon-flags-MX-delivery_svg__cls-23{fill:#8cbebf}.nn-icon-flags-MX-delivery_svg__cls-24{fill:#0c8489}.nn-icon-flags-MX-delivery_svg__cls-26{fill:#a64d21}.nn-icon-flags-MX-delivery_svg__cls-27{fill:#c8731e}.nn-icon-flags-MX-delivery_svg__cls-28{fill:#8c380e}.nn-icon-flags-MX-delivery_svg__cls-29{fill:#d2a567}.nn-icon-flags-MX-delivery_svg__cls-30{fill:#59270e}.nn-icon-flags-MX-delivery_svg__cls-31{fill:#4b4139}.nn-icon-flags-MX-delivery_svg__cls-33{fill:#5c3a1d}.nn-icon-flags-MX-delivery_svg__cls-35{fill:#dbad6c}.nn-icon-flags-MX-delivery_svg__cls-39{fill:#6c4119}"))), /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-MX-delivery_svg__rect3678"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-MX-delivery_svg__rect3678-2",
    "data-name": "rect3678"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.12.13h50.22v33.56H.12z",
    className: "nn-icon-flags-MX-delivery_svg__cls-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75 33.34v33.32H25V33.34zm.25-.25H24.77v33.82h50.46V33.09Z",
    style: {
      fill: "#87888a"
    },
    transform: "translate(-24.77 -33.09)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__rect4649",
    d: "M.25.25h16.66v33.31H.25z",
    style: {
      fill: "#00804b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__rect4651",
    d: "M33.56.25h16.66v33.31H33.56z",
    style: {
      fill: "#e6001b"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path21",
    d: "M46.89 46.2a3 3 0 0 1-.6 0c-.24 0-.19-.66-.19-.68s-.1-.18-.1-.32.48-.5.54-.52a.3.3 0 0 1 .13 0s.11-.12.14-.12.09.07.07.1-.16.11-.18.18 0 .14 0 .21a1 1 0 0 0-.14.21v.13a.57.57 0 0 0 .31-.05c.13-.06.18-.14.2-.13s-.07.16-.21.22-.23.12-.3.11-.08.19.16.2a.8.8 0 0 0 .37-.06l-.14.49Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path23",
    d: "M45.52 47.65a.3.3 0 0 1 .19.28c0 .2-.21.37-.2.73s.06.37.54.75a.65.65 0 0 1 .14.23c0 .12.11.81.57.81s.52-.3.52-.3l-.19-.28a.7.7 0 0 1-.25 0 .3.3 0 0 1-.21-.19c-.05-.11-.07-.37-.14-.49-.2-.29-.54-.33-.54-.64s.21-.33.15-.69-.49-.54-.49-.54l-.17-.07-.06.36h.14Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path25",
    d: "M46.78 45.13c.16 0 .07-.43.07-.43l-.11.09a.3.3 0 0 1 .07.17.5.5 0 0 1 0 .17Z",
    style: {
      fill: "#f1a720"
    },
    transform: "translate(-24.77 -33.09)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path27",
    d: "m47.07 49.13-.07-.06c-.06 0-.3-.23-.26-.81s1-1 1.06-1.26.28-.41-.48-1l-.17.21.31.24h.07c.01 0-.08.17-.11.24a5 5 0 0 1-.52.42l-.27.22a1.2 1.2 0 0 0-.24.37 1.1 1.1 0 0 0-.06.58.87.87 0 0 0 .75.82Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path29",
    d: "M46.6 49.5v.24l-.15.06h-.06l-.12.11v-.07a1 1 0 0 0 0-.13l.14.06h.08l.07-.14.1-.13Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7",
    transform: "translate(-24.77 -33.09)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path31",
    d: "m46.16 49.54-.07-.09a.3.3 0 0 0-.08-.08l.1-.06h.11v.14l-.05.09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7",
    transform: "translate(-24.77 -33.09)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path33",
    d: "M46.41 49.15a.2.2 0 0 1 .09.08l.06.12h-.18l-.13-.05.09-.12h.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7",
    transform: "translate(-24.77 -33.09)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path35",
    d: "M46.34 50.23a.16.16 0 0 1-.05-.08 1 1 0 0 1 0-.14h.12l.13.06v.07l-.14.12Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7",
    transform: "translate(-24.77 -33.09)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path37",
    d: "M46.81 49.86s-.1 0-.12-.08 0-.05 0-.05V50h.1l.08-.08v-.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7",
    transform: "translate(-24.77 -33.09)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path39",
    d: "m46.38 50.29.12.08a.3.3 0 0 0 .12 0l.05-.06.06-.11h-.35Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7",
    transform: "translate(-24.77 -33.09)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path41",
    d: "M46.78 50.19 47 50v-.12h-.14l-.06.12v.15Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7",
    transform: "translate(-24.77 -33.09)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path43",
    d: "M46.61 50.41a.67.67 0 0 0 .45 0 .3.3 0 0 0 .16-.11l-.12-.05-.11.1-.38.09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7",
    transform: "translate(-24.77 -33.09)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path45",
    d: "M46.38 48.56v-.12a.4.4 0 0 1 0-.1h.09l.12.09-.09.07h-.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7",
    transform: "translate(-24.77 -33.09)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path47",
    d: "m46.58 48.9-.08-.09v-.11h.09l.1.05v.14Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7",
    transform: "translate(-24.77 -33.09)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path49",
    d: "M46.05 45.08v.19c0 .02.22 0 .41-.23a.34.34 0 0 0 .1-.21v-.12a.17.17 0 0 0-.2 0 3 3 0 0 0-.39.35Z",
    style: {
      fill: "#c6c7a6"
    },
    transform: "translate(-24.77 -33.09)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__ellipse51",
    d: "M46.58 44.73v.08s-.02-.08 0-.08",
    style: {
      fill: "#1c242f"
    },
    transform: "translate(-24.77 -33.09)"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path53",
    d: "M46.33 44.81a1.3 1.3 0 0 0-.16.15.7.7 0 0 0 .24-.14.36.36 0 0 1 .24-.06s-.13 0-.15 0Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path55",
    d: "M46.73 48.49a1 1 0 0 0 0-.09.5.5 0 0 1 0-.11l-.08.07-.08.11h.12Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7",
    transform: "translate(-24.77 -33.09)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path57",
    d: "M46.32 48.26a1.3 1.3 0 0 1 0-.21v-.29l.05.13.14.22-.13.09h-.12Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7",
    transform: "translate(-24.77 -33.09)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.97 15.12a.4.4 0 0 1 0-.09.4.4 0 0 1 0-.11l-.13.1h-.05l.07.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path61",
    d: "M46.4 47.67a.5.5 0 0 1 .09-.14l.12-.17.06.22v.18h-.07a.6.6 0 0 1-.17 0l-.07-.12Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7",
    transform: "translate(-24.77 -33.09)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path63",
    d: "m46.84 47.93.07-.08a.6.6 0 0 0 .09-.1l-.29.06v.1h.09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7",
    transform: "translate(-24.77 -33.09)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path65",
    d: "m46.66 47.32.1-.09c.1-.09.12-.07.12-.07v.32h-.15l-.1-.11Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7",
    transform: "translate(-24.77 -33.09)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon67",
    d: "m22.26 14.64.17-.18-.29-.08.05.2z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path69",
    d: "M47.15 47.26V47a.7.7 0 0 0-.13.09l-.11.08v.06l.11.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7",
    transform: "translate(-24.77 -33.09)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path71",
    d: "M47.41 47v-.24l-.1.1-.07.07.08.05Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7",
    transform: "translate(-24.77 -33.09)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path73",
    d: "m47.51 47.29.15-.12a.5.5 0 0 0 .13-.15h-.38v.16l.08.14Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7",
    transform: "translate(-24.77 -33.09)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon75",
    d: "m21.91 12.85-.04.09-.01.17h.31L22.1 13l-.1-.06z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path77",
    d: "m47.24 47.51.14-.11.11-.09h-.3v.2Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7",
    transform: "translate(-24.77 -33.09)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path79",
    d: "M47.82 47a.8.8 0 0 0 0-.23.5.5 0 0 0 0-.17l-.22.15v.12l.09.09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7",
    transform: "translate(-24.77 -33.09)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path81",
    d: "M47.43 46.7s.07-.08.07-.13h.29l-.08.09-.11.07h-.14Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7",
    transform: "translate(-24.77 -33.09)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path83",
    d: "m47.79 46.52-.11-.19a.4.4 0 0 0-.08-.09l-.08.25Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7",
    transform: "translate(-24.77 -33.09)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path85",
    d: "M45.59 48.28v.08a.43.43 0 0 1 .21-.06c.09 0 .19.12.19.12v-.09s-.12-.12-.2-.12a.4.4 0 0 0-.2.07m.06-.53a.19.19 0 0 1 .12-.14.23.23 0 0 1 .19 0s0-.07-.08-.08-.1 0-.17 0a.5.5 0 0 0-.1.15Zm.41.4S46 48 45.91 48a.4.4 0 0 0-.22.05v.06a.33.33 0 0 1 .23 0 .28.28 0 0 1 .14.15v-.09Zm-.46-.46v.05a.32.32 0 0 1 0-.2l.1-.09h-.05a.5.5 0 0 0-.11.11.6.6 0 0 0 0 .16Zm-.05-.21a.18.18 0 0 1 .11-.09.2.2 0 0 0-.09.1.6.6 0 0 0 0 .18h.05a.5.5 0 0 1 0-.19Zm.72-1.74a.2.2 0 0 1 .13 0 .27.27 0 0 0-.06.26 1 1 0 0 0-.08.21h.06v-.17a.5.5 0 0 0 .17.2h.09a.6.6 0 0 1 .05-.22.44.44 0 0 0 .18.12.7.7 0 0 1-.16-.14.4.4 0 0 1 .17-.15h.06v-.06a1.4 1.4 0 0 0-.16.15 1 1 0 0 1-.08-.14.27.27 0 0 0-.18.15c0-.1.11-.21.11-.21h-.22a.34.34 0 0 0-.15.12v.06a.7.7 0 0 1 .16-.13Zm.13.19a.43.43 0 0 1 .18-.13.3.3 0 0 0 .07.15.7.7 0 0 0-.07.2.8.8 0 0 1-.18-.15Zm-.69 1.93v.07a.34.34 0 0 1 .18-.09.37.37 0 0 1 .21.09s0-.1 0-.11a.36.36 0 0 0-.18-.06.35.35 0 0 0-.19.1Zm1.95-1v-.09h.05a1 1 0 0 0 .15-.14h-.27a1 1 0 0 1 0-.16v-.12l-.07.06a.7.7 0 0 1-.26-.08 2 2 0 0 0 .23.06.12.12 0 0 0 .11 0v.13a1 1 0 0 0 0 .08v.08h.28a.7.7 0 0 1-.16.13s-.09-.15-.09-.15v.05l.07.11a.4.4 0 0 1-.14 0 1.4 1.4 0 0 0 0 .22l-.17-.05a1.1 1.1 0 0 0 0 .29.43.43 0 0 1-.22-.13 1 1 0 0 0 0 .3.6.6 0 0 1-.23-.14s0 .26.06.4h-.07a.3.3 0 0 1-.21-.13v.09a.75.75 0 0 0 .18.36.5.5 0 0 1-.27.11v.08l.17.12a.4.4 0 0 1-.15.08 1 1 0 0 0 .16-.12h.17a.5.5 0 0 1-.13 0 1.4 1.4 0 0 0 .12-.17v.07a.15.15 0 0 1-.1-.05c.17-.11.17-.16.17-.16v-.06a.25.25 0 0 1-.1-.11l.26-.07a1 1 0 0 1-.09-.24 2 2 0 0 0 .27.06 1.5 1.5 0 0 1 0-.22h.29a.9.9 0 0 1-.08-.27h.36v-.05a.6.6 0 0 1-.15-.14Zm-1 1.42a1 1 0 0 1-.13.18.34.34 0 0 1-.13-.12l.23-.14.09.08Zm.08-.29-.17.17c-.08-.1-.18-.19-.17-.34a.2.2 0 0 0 .2.09h.09a.4.4 0 0 0 .09.13Zm.18-.23a2 2 0 0 1-.24.06 1.4 1.4 0 0 1-.05-.36 1 1 0 0 0 .24.1c0 .17.06.24.06.24Zm0-.27a.9.9 0 0 1 0-.27.36.36 0 0 0 .21.1v.19h-.24Zm.53-.2a.6.6 0 0 1-.25 0v-.33l.2.07a.9.9 0 0 0 .05.24Zm0-.29v-.24a.4.4 0 0 0 .14 0 1 1 0 0 0 .05.12.6.6 0 0 0 .1.11 1.4 1.4 0 0 1-.29 0Zm-.69 1.7v-.05a.3.3 0 0 0-.1.12l-.18-.07a.7.7 0 0 0 .17.07l-.05.12a1 1 0 0 1 0-.15h.11v.21h.18-.16v-.25h-.1l.08-.08Zm-1-.12a.4.4 0 0 1 .21.08v-.06s-.09-.12-.19-.12a.43.43 0 0 0-.22.11v.11a.3.3 0 0 1 .21-.12Zm1.21 1.77a.7.7 0 0 1-.25 0 .5.5 0 0 0 .07-.14A.4.4 0 0 0 47 50a.43.43 0 0 1-.24.22 2 2 0 0 0 .07-.29h-.06a.4.4 0 0 1-.18.14.7.7 0 0 0 .07-.24.34.34 0 0 1-.16.08h-.05c.05-.08.16-.3.16-.3a1.6 1.6 0 0 1-.16.29l-.2-.1a.5.5 0 0 0 .16.08l-.13.12h.27a.6.6 0 0 1-.18.18v.06a1.6 1.6 0 0 0 .34 0 1 1 0 0 1-.1.17.8.8 0 0 0 .33-.06.43.43 0 0 0 .18-.14.26.26 0 0 1-.15.15Zm-.63-.38a1 1 0 0 0 .11-.13h.17a.26.26 0 0 1-.05.21.7.7 0 0 1-.24-.07Zm.13.28.12-.14a.32.32 0 0 0 .22-.12.24.24 0 0 1-.36.29Zm-.17-.89a1.4 1.4 0 0 1 .3.07v-.07h-.26a.32.32 0 0 1 .14-.15s-.05 0-.12.13a.43.43 0 0 0-.22.07.6.6 0 0 1 .21 0 2 2 0 0 0-.07.22v.06s0-.17.09-.28Zm-.3-.59v-.07a.38.38 0 0 0-.25 0 .54.54 0 0 0-.19.17v.09s.07-.14.17-.17a.8.8 0 0 1 .24 0Zm.27.21h-.09a.7.7 0 0 0-.2.1c0 .06-.1.19-.08.23a.14.14 0 0 0 .06.07.4.4 0 0 1 .1-.22.8.8 0 0 1 .21-.13Zm-.35 0a.4.4 0 0 1 .18-.08h-.06a.44.44 0 0 0-.21.07 2 2 0 0 0-.16.2l.08.08a2 2 0 0 1 .17-.22Zm.47-4.08a.19.19 0 0 1 .16-.09h.06a1 1 0 0 0-.07.21.5.5 0 0 1-.09.18.56.56 0 0 0-.11.26v.15c0 .02.06 0 .06-.06v-.09a.8.8 0 0 1 .09-.25.45.45 0 0 0 .1-.18 2 2 0 0 1 .06-.24h-.12a.25.25 0 0 0-.17.11.5.5 0 0 1-.15.1.26.26 0 0 0 .19-.09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-1",
    transform: "translate(-24.77 -33.09)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon87",
    d: "M22.07 12.67h-.23l.06.17z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path89",
    d: "M46.56 45.75h-.05l-.09.05v.17l.18-.18Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7",
    transform: "translate(-24.77 -33.09)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path91",
    d: "m46.53 46.21-.16-.21-.1.21h.11Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7",
    transform: "translate(-24.77 -33.09)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path93",
    d: "M47.21 50.28a.9.9 0 0 1-.43.13.53.53 0 0 1-.31-.09.3.3 0 0 1-.14-.16 1.3 1.3 0 0 1-.09-.36 1.4 1.4 0 0 0-.1-.33 2 2 0 0 0-.34-.3.65.65 0 0 1-.26-.48.2.2 0 0 1 0-.07 1 1 0 0 1 .1-.41 1 1 0 0 0 .11-.32c0-.07-.08-.13-.13-.18l-.11-.07h-.09.09l.12.08a.33.33 0 0 1 .11.15 1 1 0 0 1-.1.31 1.1 1.1 0 0 0-.11.42s0 0 0 .08a.68.68 0 0 0 .27.49c.13.11.27.18.33.29a1.4 1.4 0 0 1 .12.45 1.4 1.4 0 0 0 .07.24.44.44 0 0 0 .15.18.71.71 0 0 0 .78-.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7",
    transform: "translate(-24.77 -33.09)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path95",
    d: "M47 49.83a.2.2 0 0 1-.12 0 .24.24 0 0 1-.16-.08.4.4 0 0 1-.1-.21 2 2 0 0 0-.08-.3 1 1 0 0 0-.33-.33c-.12-.1-.24-.2-.26-.31a.13.13 0 0 1 0-.06.9.9 0 0 1 .08-.29 1 1 0 0 0 .08-.36v-.07a.6.6 0 0 0-.29-.41 1 1 0 0 0-.26-.13 1 1 0 0 1 .28.16.52.52 0 0 1 .23.35v.07a1 1 0 0 1-.08.35.8.8 0 0 0-.08.3.2.2 0 0 0 0 .07.7.7 0 0 0 .28.32 1 1 0 0 1 .31.33 1.6 1.6 0 0 1 .08.29.43.43 0 0 0 .12.23.22.22 0 0 0 .17.07.4.4 0 0 0 .14 0Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7",
    transform: "translate(-24.77 -33.09)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path97",
    d: "M47.85 49.14s.16 0 .15.17a1.4 1.4 0 0 1-.08.3l-.22-.19.13-.11v-.17Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path99",
    d: "M45.11 47.59h-.19c-.04 0 0-.12 0-.14s-.09 0-.08-.11.12-.08.15-.08 0-.14.11-.13.11.1.11.1l-.08.38Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path101",
    d: "M45.11 47.59H45a.2.2 0 0 1 0-.1.06.06 0 0 1 0-.05.06.06 0 0 1 .05-.06H45v-.06c0-.01 0 0 0 0a.1.1 0 0 1 .08.05l-.08.38.08-.38v-.05a.2.2 0 0 0-.09-.06.3.3 0 0 0 0 .07h-.1a.09.09 0 0 0-.06.08.1.1 0 0 0 0 .09.23.23 0 0 0 0 .11h.12Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-11",
    transform: "translate(-24.77 -33.09)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path103",
    d: "M45.29 47.63s-.13.07-.18 0 0-.15 0-.16-.1 0-.08-.12.1-.06.13-.07.05-.13.13-.11a.14.14 0 0 1 .1.08s-.07.32-.09.38Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path105",
    d: "M45.29 47.63h-.09a.06.06 0 0 1-.06 0 .13.13 0 0 1 0-.06v-.1h.1v-.06a.1.1 0 0 1 .07 0v.37s0-.12.05-.21 0-.16 0-.16a.15.15 0 0 0-.09-.05.2.2 0 0 0 0 .06h-.1a.07.07 0 0 0 0 .06.08.08 0 0 0 0 .07 1 1 0 0 0 0 .08.3.3 0 0 0 0 .08.1.1 0 0 0 .08 0 .3.3 0 0 0 .11 0Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-11",
    transform: "translate(-24.77 -33.09)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path107",
    d: "M45.51 47.66a.12.12 0 0 1-.13.06c-.09 0-.06-.15-.08-.18s-.08 0-.07-.12.1-.08.13-.09.07-.15.13-.13.12.1.11.14-.13 0-.15.13a.27.27 0 0 0 .06.19",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path109",
    d: "M45.51 47.66a.15.15 0 0 1-.07 0 .2.2 0 0 1 0-.08.07.07 0 0 1 0-.06.05.05 0 0 1 .05 0v-.06a.2.2 0 0 1 .07.06.1.1 0 0 1 0 .06h-.08a.2.2 0 0 0-.08.11.34.34 0 0 0 .07.17.4.4 0 0 1-.06-.15.14.14 0 0 1 .08-.09.13.13 0 0 0 0-.08.2.2 0 0 0-.09-.06v.07h-.07a.1.1 0 0 0 0 .07.1.1 0 0 0 0 .08.3.3 0 0 0 0 .09v.06h.05a.13.13 0 0 0 .09 0Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-11",
    transform: "translate(-24.77 -33.09)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path111",
    d: "M47.61 49.11a2.4 2.4 0 0 1-.2-.25c-.09-.11-.22-.24-.22-.24l-.2-.1-.13-.22v-.39l.08-.12s-.42.15-.21 1a.49.49 0 0 0 .33.39h.38Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-12",
    transform: "translate(-24.77 -33.09)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path113",
    d: "M47.41 46.42h.07a.07.07 0 0 1 0 .06 1.83 1.83 0 0 1-.7.65 1.2 1.2 0 0 0-.35.35 1.1 1.1 0 0 0-.15.59 1 1 0 0 0 .38.84.87.87 0 0 0 .48.14h.68a.17.17 0 0 1-.06.11l-.08.06a.24.24 0 0 0 .09-.07.17.17 0 0 0 .07-.13.1.1 0 0 0 0-.06.11.11 0 0 0-.1 0h-.17a4 4 0 0 0-.4 0 .85.85 0 0 1-.47.04.94.94 0 0 1-.37-.82 1.2 1.2 0 0 1 .14-.58 1.9 1.9 0 0 1 .54-.48 1.2 1.2 0 0 0 .51-.52.3.3 0 0 0 0-.08.13.13 0 0 0-.1 0Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-13",
    transform: "translate(-24.77 -33.09)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path115",
    d: "M48 49.24s-.1.18-.13.18a.26.26 0 0 1 .12.08.4.4 0 0 0-.18-.08v-.07l.1-.06a.34.34 0 0 0 .08-.16v.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-1",
    transform: "translate(-24.77 -33.09)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path117",
    d: "m48.37 49.36-.25.07-.12-.08v-.15a.4.4 0 0 0-.15-.08 1.2 1.2 0 0 0-.22 0l-.45-.48h.95l.07.06.07.06.08.13.05.14v.33Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path119",
    d: "M48.38 49.34a.7.7 0 0 1-.2 0 .8.8 0 0 1-.19 0s0 0 0 .08v.41h.36l.07-.32v-.18Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-12",
    transform: "translate(-24.77 -33.09)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon121",
    d: "m23.55 16.13.01.11.04.01v-.1z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path123",
    d: "M48.09 46.49v-.2l-.09-.13-.1-.13-.1-.12h-.32l-.18.09a1.8 1.8 0 0 1 .49.53.6.6 0 0 1 .25.15v-.16Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path125",
    d: "M47.84 46.71a.76.76 0 0 1-.07.35l.16-.18.11-.21a.6.6 0 0 0-.25-.15.45.45 0 0 1 .05.19",
    className: "nn-icon-flags-MX-delivery_svg__cls-12",
    transform: "translate(-24.77 -33.09)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path127",
    d: "m48.2 49.71-.12-.14-.08-.08a.4.4 0 0 1 .11.07l.08.09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-13",
    transform: "translate(-24.77 -33.09)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path129",
    d: "M48.36 49.5a.45.45 0 0 1-.12.16 1.2 1.2 0 0 1-.2.14l.26.09.17-.16z",
    style: {
      fill: "#6f5b24"
    },
    transform: "translate(-24.77 -33.09)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon131",
    d: "m23.61 16.64-.04.05-.04.04.06-.27.05.08v.05l-.01.02z",
    style: {
      fill: "#404118"
    }
  }), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon133",
    d: "m28.49 21.31.02.41.16-.1-.12-.33z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon135",
    d: "m28.56 21.27-.08.04v.01l.01-.01.01.02.04-.03.11.32-.13.08-.01-.39h-.02l.01.02-.01-.02-.01.01.02.42.18-.11z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path137",
    d: "M53.38 54.3a.13.13 0 0 1-.14.13.13.13 0 1 1 0-.26.13.13 0 0 1 .14.13",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path139",
    d: "M53.38 54.3a.14.14 0 0 1-.13.12.12.12 0 0 1-.12-.12.12.12 0 0 1 .12-.12.13.13 0 0 1 .13.12.15.15 0 0 0-.15-.14.14.14 0 1 0 0 .28.15.15 0 0 0 .15-.14",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path141",
    d: "M53.33 54.44v.08-.13Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path143",
    d: "M53.35 54.36a.1.1 0 0 1-.1 0c-.07 0-.11 0-.12-.07a.12.12 0 0 1 0-.11v.09l.06.06h.14Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon145",
    d: "m28.98 21.95-.3-.29-.13.11.4.24z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon147",
    d: "m28.96 22.03.04-.08-.01-.01-.01.01h-.01l-.02.04-.38-.22.11-.09.3.28v-.01h-.01.01l.01-.01-.31-.29-.15.12z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path149",
    d: "M53.72 55.21a.14.14 0 0 1 0-.19.15.15 0 0 1 .19 0 .15.15 0 0 1 0 .19.15.15 0 0 1-.19 0",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path151",
    d: "M53.72 55.21a.08.08 0 0 1 0-.07.14.14 0 0 1 0-.1.1.1 0 0 1 .08 0 .12.12 0 0 1 .09 0 .14.14 0 0 1 0 .07.16.16 0 0 1-.05.1.14.14 0 0 1-.17 0 .14.14 0 0 0 .11.06.2.2 0 0 0 .09 0 .13.13 0 0 0 .06-.11.1.1 0 0 0 0-.08.11.11 0 0 0-.1-.06.12.12 0 0 0-.09 0 .16.16 0 0 0-.06.12.2.2 0 0 0 0 .08Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path153",
    d: "M53.74 55a.1.1 0 0 1-.07 0 1.2 1.2 0 0 1-.31-.17l.34.22v-.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path155",
    d: "M54 55.12a.11.11 0 0 1-.07.1.11.11 0 0 1-.14 0 .15.15 0 0 1 0-.1c0-.05 0 0 0 0v.08h.08Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon157",
    d: "m31.27 17.68.31.31.04-.15-.28-.19z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon159",
    d: "m31.34 17.63-.08.05.01.01v-.01l.01.02.06-.04.26.18-.03.13-.29-.29h-.01l.01.02-.01-.02v.01l.32.32.04-.18z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path161",
    d: "M56.13 50.7a.13.13 0 1 1-.13-.13.13.13 0 0 1 .13.13",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path163",
    d: "M56.13 50.7a.12.12 0 0 1-.24 0 .12.12 0 1 1 .24 0 .14.14 0 1 0-.14.14.14.14 0 0 0 .14-.14",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path165",
    d: "M56.16 50.79v.06l-.07-.08v-.05Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path167",
    d: "M56.12 50.68c0 .06-.08.15-.15.12s-.11-.09-.07-.16v.1l.06.06h.1v-.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon169",
    d: "m32.08 17.86-.47.14.04-.16.4-.04z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon171",
    d: "m32.05 17.82.02.05.01-.01v-.01.01h.01l-.03-.07-.42.04-.04.19.5-.15-.01-.01h-.01v-.01l-.45.13.03-.12z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path173",
    d: "M57.05 50.89a.13.13 0 0 1-.13.13.12.12 0 0 1-.12-.13.12.12 0 0 1 .12-.12.13.13 0 0 1 .13.12",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path175",
    d: "M57.05 50.89a.12.12 0 0 1-.12.12.11.11 0 0 1-.11-.12.11.11 0 0 1 .11-.11.12.12 0 0 1 .12.11.13.13 0 0 0-.14-.13.13.13 0 0 0-.13.13.13.13 0 0 0 .13.14.14.14 0 0 0 .14-.14",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path177",
    d: "M57 50.84s0 .16-.09.16a.11.11 0 0 1-.1-.13V51H57v-.14Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path179",
    d: "M56.72 50.91a.07.07 0 0 1 0 .06l-.12.07.26-.08v-.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon181",
    d: "m30.51 20.17-.28-.45.04-.02.32.38z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon183",
    d: "m30.58 20.08-.08.08.01.01.01-.01-.01.01.01.01.09-.1-.34-.39-.06.03.3.47.01-.01-.01-.01.01-.01-.28-.43.03-.01z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__circle185",
    d: "M55 52.58a.13.13 0 0 1 .13.13.13.13 0 0 1-.13.14.13.13 0 0 1-.13-.14.13.13 0 0 1 .13-.13",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path187",
    d: "M55.1 52.72a.14.14 0 0 1-.13.12.13.13 0 0 1-.12-.12.13.13 0 0 1 .12-.13.14.14 0 0 1 .13.13.15.15 0 0 0-.15-.15.15.15 0 0 0-.14.15.14.14 0 0 0 .14.14.15.15 0 0 0 .15-.14",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path189",
    d: "M55.17 53a.4.4 0 0 0 0 .07l-.17-.23h.05l.11.13Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path191",
    d: "M55.09 52.74a.15.15 0 0 1-.18.07s-.1-.14 0-.19v.13h.12s0-.11 0 0Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon193",
    d: "m30.53 20.18.36.07.01-.05-.3-.12z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon195",
    d: "m30.6 20.06-.09.13h.02v-.01l.01.01.07-.1.28.11-.01.03-.35-.06v.01l.01.01-.01-.01v.01l.37.07.02-.07z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path197",
    d: "M55.9 53.34a.13.13 0 1 1-.26 0 .13.13 0 0 1 .26 0",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path199",
    d: "M55.9 53.34a.12.12 0 0 1-.12.12.12.12 0 0 1-.12-.12.12.12 0 0 1 .12-.12.13.13 0 0 1 .12.12.14.14 0 0 0-.28 0 .14.14 0 1 0 .28 0",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path201",
    d: "M55.59 53.26h-.19l.24.05v-.05h-.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path203",
    d: "M55.89 53.32a.11.11 0 0 1-.14.13.13.13 0 0 1-.09-.17v.13l.06.05h.12l.06-.06v-.08Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path205",
    d: "M57.27 49.92c0 .35-.37.53-.55.66a1 1 0 0 0-.27.29l-.06.21v.13a2 2 0 0 1 0 .19v.39l.24-.17.17-.07h.06a1.2 1.2 0 0 0-.27.4c-.08.21-.22.66-.49.8s-.43.09-.52.17-.09.09-.09.09l-.11.16-.09.12h-.09v.05a1 1 0 0 1 0 .15c0 .1-.07.21-.07.21a.5.5 0 0 1 .12 0h.12a.6.6 0 0 0-.06.12.77.77 0 0 1-.33.63 3 3 0 0 1-1.22.19l-.16.06-.16.12-.14.15v.05a1.1 1.1 0 0 1-.19.18l-.25.17a.7.7 0 0 1 .2 0l.32.14a1 1 0 0 0-.33 0 3.5 3.5 0 0 1-1 .39c-.3 0-.72-.44-.72-.44l-.33-.04-.32-.07h-.39v-.11a1.4 1.4 0 0 1 .35 0c.18 0 .24.08.4.1a.7.7 0 0 0 .32 0c.06 0 .53-.43.53-.43l.53-.19h.38l-.09.1a.35.35 0 0 1-.13.09h.07L53 55h.11a.4.4 0 0 1 0-.12 2.2 2.2 0 0 1 .32-.26c.08 0 .1-.06.12-.09a3 3 0 0 0 .14-.31v-.14l.38-.36.25-.27.11-.3v-.07a.42.42 0 0 1 .08.29.7.7 0 0 1-.06.25 3 3 0 0 1 .39-.23.5.5 0 0 1 .22 0 .8.8 0 0 0 .19-.16c.08-.11.1-.14.1-.19v-.89l.22-.49.32-.28h.06a.4.4 0 0 0 0 .12 1 1 0 0 0 0 .12 1.4 1.4 0 0 1 .25-.26.6.6 0 0 0 .07-.18v-.76l-.15-.4v-.52l-.12-.26s.11 0 .24.18a1.3 1.3 0 0 1 .17.45l.3-.92a1 1 0 0 1 .14.29 1.4 1.4 0 0 1 .07.3l.12-.25a.4.4 0 0 0 0 .09.77.77 0 0 1 .17.54Zm-6.13 5.92s0-.14-.34-.28a1.5 1.5 0 0 0-.51-.17v.1l.45.2.23.19Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path207",
    d: "M53.22 55a2.6 2.6 0 0 1 .4-.32 1 1 0 0 1 .29-.07 1.4 1.4 0 0 0 .6-.23 1.8 1.8 0 0 0 .57-.54.5.5 0 0 1 .21-.07l-.31.35a2.4 2.4 0 0 1-.53.42 1.6 1.6 0 0 1-.69.16.65.65 0 0 0-.37.19 1 1 0 0 0-.18.2.1.1 0 0 1 0-.09Zm1.1-1.15a1.85 1.85 0 0 0-.49.65s.33-.28.5-.45.4-.24.51-.34.11-.18.18-.24a.4.4 0 0 1 .12-.09s-.16-.13-.82.47m-.78.78a.47.47 0 0 0 .22-.21c.05-.11 0-.14.09-.26s.38-.37.52-.53a.5.5 0 0 0 .13-.52.31.31 0 0 1-.07.25c-.1.13-.6.46-.66.66a2 2 0 0 0-.05.31.44.44 0 0 1-.18.3m-.25 1a.76.76 0 0 0-.41-.12c-.44 0-.82.3-1.11.31s-.4-.14-.63-.29a1.8 1.8 0 0 0-.84-.14 3 3 0 0 1 .58 0c.33.09.51.44.89.42a8 8 0 0 0 1.1-.33c.34 0 .42.07.42.07Zm-2.19-.23a.9.9 0 0 0 .61-.13 2.3 2.3 0 0 1 .75-.47 1.5 1.5 0 0 1 .36 0 1 1 0 0 0-.4-.09 1 1 0 0 0-.52.12c-.17.1-.25.28-.43.39a1 1 0 0 1-.37.15Zm-.06.46a1 1 0 0 0-.12 0s-.12-.11-.27-.19a1.4 1.4 0 0 0-.36-.12l.34.13a.8.8 0 0 1 .25.2.14.14 0 0 0 .13.07c.09 0 .12 0 .11-.09s-.06-.05-.1-.05Zm.24-.33a.7.7 0 0 0 .36.07c.48 0 .78-.34 1.09-.46a.54.54 0 0 1 .48 0 .7.7 0 0 0-.35-.11 3.2 3.2 0 0 0-1.24.43 1.6 1.6 0 0 1-.34.11Zm5.09-3.63c-.16.17-.4.7-.51.85a1.2 1.2 0 0 1-.29.24l-.29.38c-.05.06-.06 0-.09.07s.07 0 .15-.14a2 2 0 0 1 .2-.24 6 6 0 0 0 .48-.39c.11-.14.34-.68.46-.81a1.3 1.3 0 0 1 .37-.23s-.18 0-.48.25Zm-.82 1a.45.45 0 0 1 .12-.24c.11-.14.16-.12.25-.33a6 6 0 0 0 .21-.62 3 3 0 0 1 .21-.44s-.12 0-.25.19a3 3 0 0 0-.43.78 2.7 2.7 0 0 0-.11.66m-.15.2s.05 0 .05-.29a3.5 3.5 0 0 1 .06-.83 4.4 4.4 0 0 1 .49-.63 1.2 1.2 0 0 0-.41.23.79.79 0 0 0-.32.61c0 .18.11.38.12.56s0 .35 0 .35Zm1-1.83s.1-.37.14-.46a1.5 1.5 0 0 1 .25-.36c.12-.14.24-.22.29-.4a5 5 0 0 0 0-.7.4.4 0 0 0-.09.13c-.05.1 0 .43-.09.58a3.3 3.3 0 0 1-.34.6 3 3 0 0 1 0-.52 3.3 3.3 0 0 1 .16-.52 3.5 3.5 0 0 0 0-.61 1.1 1.1 0 0 0-.21.31 2 2 0 0 0-.11.68 5 5 0 0 0 .06.54.7.7 0 0 1 0 .32.7.7 0 0 0-.05.19 2 2 0 0 1-.07.23Zm-.32-2a.5.5 0 0 1 .11.33 1.3 1.3 0 0 0 0 .59c.07.19.17.21.2.31a1.6 1.6 0 0 1 0 .31 2 2 0 0 0 0-.5c0-.11 0-.06-.11-.17s0-.42 0-.61a.42.42 0 0 0-.18-.26Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7",
    transform: "translate(-24.77 -33.09)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path209",
    d: "M46.78 54.28a.1.1 0 0 1-.1.11s-.08 0-.08-.11 0-.12.08-.12a.12.12 0 0 1 .1.12",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path211",
    d: "M46.78 54.28a.08.08 0 0 1 0 .07h-.06a.14.14 0 0 1 0-.07.2.2 0 0 1 0-.08s0 0 .06 0a.1.1 0 0 1 0 .07.16.16 0 0 0 0-.09.12.12 0 0 0-.08 0 .13.13 0 0 0-.07 0 .2.2 0 0 0 0 .09.2.2 0 0 0 0 .08.1.1 0 0 0 .07 0 .11.11 0 0 0 .11-.12Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon213",
    d: "m22.01 21.39.08.46-.11-.05-.04-.39z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon215",
    d: "m21.96 21.42.05-.01v-.02l-.01.01.01-.01v-.01l-.08.02.04.41.14.06-.09-.49h-.01v.01l-.01.01.08.43-.09-.03z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path217",
    d: "M46.88 54.33c0 .07 0 .18-.14.2s-.21 0-.21-.1.14 0 .18-.06.11-.11.17 0Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path219",
    d: "M46.88 54.33a.09.09 0 0 1 0 .08.2.2 0 0 1-.1.06h-.05a.15.15 0 0 1-.1 0s-.05 0-.05-.07h.22a.07.07 0 0 0-.06 0 .15.15 0 0 0-.07 0h-.16a.06.06 0 0 0 0 .06.11.11 0 0 0 0 .09h.18a.24.24 0 0 0 .11-.06.2.2 0 0 0 0-.1.07.07 0 0 0 0-.05Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path221",
    d: "M46.87 54.33s0 .14-.12.18a.15.15 0 0 1-.18 0 .1.1 0 0 1 0-.08v.06h.27v-.13Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path223",
    d: "M46.78 54.56a.3.3 0 0 0 0 .08v-.13h.05Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path225",
    d: "M46.22 55c0 .06-.06.1-.14.1s-.14 0-.14-.1.06-.1.14-.1.14.1.14.1",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path227",
    d: "M46.22 55a.07.07 0 0 1 0 .06.17.17 0 0 1-.1 0 .14.14 0 0 1-.09 0A.06.06 0 0 1 46 55a.14.14 0 0 1 .09 0 .17.17 0 0 1 .1 0 .07.07 0 0 1 0 .06.1.1 0 0 0-.05-.08.2.2 0 0 0-.11 0 .15.15 0 0 0-.1 0 .09.09 0 0 0 0 .16.15.15 0 0 0 .1 0 .2.2 0 0 0 .11 0 .1.1 0 0 0 .05-.08Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon229",
    d: "m21.56 21.91.44-.02-.08-.09-.36.04z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon231",
    d: "M21.55 21.83v.1h.01v-.02h.01v-.06l.35-.03.05.06-.41.02v.01h.01-.01v.02l.46-.03-.09-.11z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path233",
    d: "M46.36 55c0 .11 0 .26-.08.24s-.1-.13-.11-.17-.09-.15 0-.22.17 0 .21.15Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path235",
    d: "M46.36 55a.5.5 0 0 1 0 .12.1.1 0 0 1 0 .08.06.06 0 0 1-.06 0h-.07V55a.7.7 0 0 1 0-.15.06.06 0 0 1 0-.06.14.14 0 0 1 .09.05.5.5 0 0 1 .06.12.3.3 0 0 0-.07-.12.15.15 0 0 0-.1-.06h-.06a.13.13 0 0 0 0 .08.4.4 0 0 0 0 .15.4.4 0 0 0 0 .1.1.1 0 0 0 .07 0h.08c.01 0 0-.05 0-.09a.6.6 0 0 0 0-.13Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path237",
    d: "M46.43 54.93h.09-.16v-.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path239",
    d: "M46.38 55a.1.1 0 0 1 0 .05s0 .09-.09.08a.12.12 0 0 1-.1-.1.1.1 0 0 0 0-.06v.15h.12V55Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path241",
    d: "M46 55a.11.11 0 0 0 .1.08h.11H46v-.05Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__ellipse243",
    d: "M44.93 52.43s.09.06.09.13 0 .14-.09.14-.08-.06-.08-.14.04-.13.08-.13",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path245",
    d: "M45 52.57a.2.2 0 0 1 0 .08.1.1 0 0 1-.06 0 .2.2 0 0 1 0-.08.2.2 0 0 1 0-.09H45a.2.2 0 0 1 0 .09.15.15 0 0 0 0-.1.08.08 0 0 0-.07 0 .07.07 0 0 0-.06 0 .15.15 0 0 0 0 .1.14.14 0 0 0 0 .09.07.07 0 0 0 .06.05.08.08 0 0 0 .07-.05.14.14 0 0 0 0-.09",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon247",
    d: "m20.17 19.76.01.42-.11-.1.01-.33z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon249",
    d: "m20.09 19.76.08.01v-.01h-.01.01v-.01l-.1-.02-.01.36.13.12-.01-.46h-.01v.01h-.01l.01.4-.09-.08z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path251",
    d: "M45.1 52.72c0 .1-.12.16-.22.14s-.17-.07-.16-.16.14-.07.18 0 .17-.07.2.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path253",
    d: "M45.1 52.72a.09.09 0 0 1-.05.08.3.3 0 0 1-.12 0 .2.2 0 0 1-.11-.05.1.1 0 0 1 0-.08h.06a.1.1 0 0 1 .08 0h.16v.06a.2.2 0 0 0 0-.07h-.16a.14.14 0 0 0-.09 0h-.07a.1.1 0 0 0 0 .06.12.12 0 0 0 0 .1.2.2 0 0 0 .12 0 .3.3 0 0 0 .13 0 .1.1 0 0 0 .06-.1Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path255",
    d: "M45.09 52.71a.18.18 0 0 1-.16.09.21.21 0 0 1-.17-.06.13.13 0 0 1 0-.08v.06h.33v-.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path257",
    d: "M44.93 52.92v-.12h.08v.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path259",
    d: "M44.33 53.23s-.06.06-.14.06-.15 0-.15-.06.06-.07.15-.07.14.03.14.07",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path261",
    d: "M44.33 53.23h-.12a.15.15 0 0 1-.1 0 .2.2 0 0 1 .13 0h.1a.26.26 0 0 0-.14 0h-.11a.2.2 0 0 0 .15 0 .15.15 0 0 0 .1 0Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon263",
    d: "m19.69 20.13.33-.02.14.11-.48-.02z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon265",
    d: "m19.69 20.19.01-.05-.01-.01v.02-.02h-.01l-.01.08.53.02-.18-.13-.34.02v.01h.01v.02l.33-.03.1.09z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path267",
    d: "M44.33 53.05c.09 0 .15.1.14.2s-.09.2-.18.18a.07.07 0 0 1-.07-.1s.05-.06.05-.09v-.15c0-.04 0 0 .07 0Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path269",
    d: "M44.33 53.05a.11.11 0 0 1 .09 0 .16.16 0 0 1 0 .12.17.17 0 0 1-.15.17s0-.09 0-.12v.17a.07.07 0 0 0 .07 0 .19.19 0 0 0 .17-.18.18.18 0 0 0 0-.13.13.13 0 0 0-.11-.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path271",
    d: "M44.51 53.23a3 3 0 0 0 .29.05h-.38v-.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path273",
    d: "M44.46 53.24s-.06.14-.14.12-.07-.07-.07-.08v.07h.11Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path275",
    d: "M44.26 53.25h-.06a.6.6 0 0 1-.15 0h.16Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path277",
    d: "M44.06 50.47c0 .06-.11.1-.14.08s0-.11 0-.17.1-.08.13-.06 0 .09 0 .15Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path279",
    d: "M44.06 50.47a.1.1 0 0 1 0 .06.07.07 0 0 1-.06 0 .2.2 0 0 1 0-.11.15.15 0 0 1 .1-.07.06.06 0 0 1 0 .05.16.16 0 0 1 0 .08.16.16 0 0 0 0-.09.08.08 0 0 0 0-.07.15.15 0 0 0-.12.08.3.3 0 0 0 0 .12.07.07 0 0 0 0 .06h.07l.06-.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon281",
    d: "m18.92 18.04.19-.44-.03-.02-.21.31z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon283",
    d: "m18.86 17.89.06.18.02-.02-.02-.01h.02l-.05-.15.2-.29.01.01-.19.43h.03-.02l.02.01.18-.45-.04-.04z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path285",
    d: "M43.84 50.7c-.09-.07-.11-.14-.08-.21s.1 0 .1 0a.3.3 0 0 0 .08.07s.08 0 .12.05a.08.08 0 0 1 0 .12.22.22 0 0 1-.21 0Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path287",
    d: "M43.84 50.7a.18.18 0 0 1-.09-.14.3.3 0 0 0 .08.07H44a.07.07 0 0 1 0 .06v.05h-.09a.2.2 0 0 1-.1 0 .23.23 0 0 0 .11 0h.1a.07.07 0 0 0 0-.07.1.1 0 0 0 0-.07.1.1 0 0 0-.07 0h-.06a.07.07 0 0 0-.06.05.13.13 0 0 0 0 .06.21.21 0 0 0 .1.16Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path289",
    d: "M44.07 50.61a.08.08 0 0 1 0 .07.15.15 0 0 1-.16 0 .7.7 0 0 1-.14-.11v.07l.07.06H44v-.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path291",
    d: "M43.81 50.74v.1l.08-.18v.05Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path293",
    d: "M43.07 50.64c.07 0 .1.1.08.14s-.1 0-.16 0-.1-.1-.08-.14.09 0 .16 0",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path295",
    d: "M43.07 50.64a.14.14 0 0 1 .08.1h-.06a.15.15 0 0 1-.09 0 .14.14 0 0 1-.08-.11.06.06 0 0 1 .06 0 .13.13 0 0 1 .08 0 .16.16 0 0 0-.09 0h-.08a.17.17 0 0 0 .09.13.2.2 0 0 0 .1 0 .12.12 0 0 0 .08 0 .16.16 0 0 0-.1-.12Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon297",
    d: "m18.5 17.74.34.2-.01.17-.37-.32z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon299",
    d: "m18.48 17.79.03-.04-.01-.01-.01.01.01-.01-.01-.01-.05.06.4.34.01-.19-.36-.22v.01l.01.01-.01.01.34.2-.01.13z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path301",
    d: "M43.26 50.87c-.08.09-.15.1-.21.06a.07.07 0 0 1 0-.1.4.4 0 0 0 .07-.07s0-.09.07-.12.11 0 .12 0a.23.23 0 0 1 0 .2Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path303",
    d: "M43.26 50.87a.17.17 0 0 1-.13.08h-.06a.3.3 0 0 0 .08-.08.14.14 0 0 0 0-.06.1.1 0 0 1 0-.05.07.07 0 0 1 .06 0s0 0 0 .06a.18.18 0 0 1 0 .13.23.23 0 0 0 0-.15v-.07a.08.08 0 0 0-.08 0h-.06l-.05.06a.4.4 0 0 1 0 .06.13.13 0 0 0 0 .06.1.1 0 0 0 0 .06h.08a.22.22 0 0 0 .15-.08Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path305",
    d: "M43.32 50.87a2 2 0 0 0 .22.24l-.31-.26Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path307",
    d: "M43.22 50.9a.16.16 0 0 1-.08 0s-.09 0-.1 0 0-.05 0-.05v.05h.12Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path309",
    d: "M43.09 50.77H43a.24.24 0 0 1-.13-.07l.05.07h.09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path311",
    d: "M48.79 55.81s0-.1.28-.22a3.4 3.4 0 0 1 .66-.27s0 .16 0 .16l-.24.07-.19.12-.23.14Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path313",
    d: "M49.42 55.16a2 2 0 0 0-.55.1s-.07 0-.11 0a.5.5 0 0 1-.13-.14l-.07-.06v.23l-.46-.4v.27l-.1.14-.46-.44v.34h-.12l-.34-.2H47l.11.19h-.41a.2.2 0 0 0-.09.07.4.4 0 0 0-.09.1.5.5 0 0 0 .17 0s0-.06.06 0 0 .11.08.1.25-.15.39-.09-.2.17-.16.28.28.06.35 0 .25-.27.33-.18-.23.22-.16.35.25.09.34 0 .3-.38.35-.31-.18.24-.12.34.22 0 .31-.08.14-.22.27-.3.12 0 .16 0 .14-.11.14-.11l.31-.13h.39v-.13a1 1 0 0 0-.31-.08Zm-2.5 0L47 55a.9.9 0 0 1-.21-.17.5.5 0 0 0-.19-.14l-.2-.13-.07-.26v-.07l-.12.05-.21-.57v-.1h-.06l-.13.33-.14-.21v-.45l-.09.1-.12.11-.2-.41a.6.6 0 0 0 0 .24 1.5 1.5 0 0 1-.28-.2 1.1 1.1 0 0 1-.26-.28l-.1-.22.09-.19v-.23l-.2.08v-.69l-.41.41a1 1 0 0 1-.09-.15v-.33h-.06l-.1.19a2 2 0 0 0-.14-.23 1 1 0 0 0 0-.41c0-.19-.12-.28-.1-.44s.09-.16.08-.23-.11 0-.07 0 .35-.29.28-.4-.37.17-.3 0 .37-.18.38-.43-.28.09-.3 0 .18-.24.17-.34 0-.12 0-.17-.23.21-.23.21l-.19-.07-.07.28-.05.23-.31-.25.06.28.06.28-.23-.02.14.23.16.17.11.14h.08l.1.1v.15l.06.17v.52s-.12-.07-.15 0 .14.18.11.21-.29 0-.3 0a.19.19 0 0 0 .17.23c.14 0 .48.12.42.18s-.42-.2-.41 0a.37.37 0 0 0 .24.31c.1 0 .47 0 .44.08s-.3 0-.32.1.19.14.24.14a.6.6 0 0 1 .26 0c.06.05.27.27.4.38l.41.31h-.24c-.03 0 .56.27.39.34s-.35-.18-.4 0 .11.27.21.32.6 0 .5.13-.47-.08-.48.06.25.36.38.36.28-.22.34-.11-.11.16 0 .19.21-.12.36-.1a1.2 1.2 0 0 1 .5.24l.26.25Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path315",
    d: "M48.94 55.75a.13.13 0 0 1 .11 0 3 3 0 0 1 .31-.21 1.6 1.6 0 0 1 .35-.13 1.5 1.5 0 0 0-.38.16 2 2 0 0 0-.29.19s-.06.06-.15.06-.12 0-.12-.08.06-.06.15-.06Zm.77-.39a.2.2 0 0 1-.11 0 .4.4 0 0 0-.24-.08.56.56 0 0 0-.36.17.5.5 0 0 1-.13.12.4.4 0 0 0 .18-.1.7.7 0 0 1 .33-.13.27.27 0 0 1 .2.07.3.3 0 0 0 .13 0Zm-4.59-1.88v-.06l-.2-.11c-.15-.09-.46-.34-.46-.34l.25.24a4 4 0 0 0 .37.26Zm3.24 2.3.13-.2a1 1 0 0 1 .18-.2s0-.08-.06-.13a.3.3 0 0 1 0-.11.35.35 0 0 0 .09.13l.1.08h.13v-.05c0-.05 0 0-.1 0s-.16-.22-.23-.23 0 .19 0 .19-.19-.39-.45-.41-.21 0-.22.07.22.28.14.31-.32-.38-.5-.38-.19.06-.18.1.2.07.16.2-.22-.19-.39-.17-.18 0-.19.07.06.12 0 .13a1.3 1.3 0 0 0-.21.07 1.5 1.5 0 0 0-.2.22.4.4 0 0 1 .25-.17 4 4 0 0 1 .51 0l-.11-.08a.6.6 0 0 1-.09-.15 1 1 0 0 0 .15.14.8.8 0 0 0 .17.11s.16 0 .17 0 0 0-.07.12a2 2 0 0 1-.15.15l.18-.14.13-.11a.5.5 0 0 0 .13 0s0 0-.07-.15l-.21-.19a1 1 0 0 1 .19.21c.09.12.08.18.12.18h.13v.15a.8.8 0 0 0-.1.23 1 1 0 0 1 .13-.18c.07-.08.11-.16.14-.17h.14l-.08-.15a.8.8 0 0 1-.06-.24 1.3 1.3 0 0 0 .12.23c.08.1.11.17.13.18h.11s0 .07-.06.16-.09.2-.09.2Zm-2-1.14a.5.5 0 0 0 .15 0 .54.54 0 0 1-.19-.22c0-.13 0-.4-.07-.4s-.1.2-.16.16 0-.39-.05-.55-.24-.26-.28-.2 0 .38-.13.31 0-.35 0-.48-.1-.22-.16-.19 0 .27-.07.28-.08-.17-.12-.19-.06 0-.08 0 0-.16-.06-.14 0 .1 0 .16a.8.8 0 0 0 .06.16s.1.08.09.1a.11.11 0 0 1-.1.06H45h.32l.13.18a.7.7 0 0 0 0-.2v-.25a2 2 0 0 1 0 .24v.27s.1.09.07.11a.8.8 0 0 1-.26 0 1.3 1.3 0 0 1-.29 0 1.1 1.1 0 0 0 .26.1 3 3 0 0 0 .35 0l.16.18a.7.7 0 0 0 .09-.26 3 3 0 0 0 0-.29 2 2 0 0 1 0 .26 1.4 1.4 0 0 1 0 .34.5.5 0 0 1-.17.09l-.33.06a1.4 1.4 0 0 0 .34 0c.15 0 .16-.07.2 0a.3.3 0 0 1 .08.07l.12.08s-.06 0-.1.07l-.13.07a1.4 1.4 0 0 1 .2-.07h.11a1 1 0 0 0 0-.11 2 2 0 0 0 0-.16.4.4 0 0 1 .06.14.7.7 0 0 1 0 .15s0 0 .12.06Zm-2.83-3.25a2 2 0 0 0 0-.33 1.3 1.3 0 0 0-.14-.47v-.05l.08-.13-.11.08a.4.4 0 0 1-.11 0 .2.2 0 0 1-.07-.08l.1.06h.07v-.17l-.18-.09a1.6 1.6 0 0 1-.23-.17l.26.13a.4.4 0 0 0 .14 0h.15l.15-.11a.6.6 0 0 1-.16.07h-.15v-.21l-.11-.11a1.2 1.2 0 0 1-.14-.25 1 1 0 0 0 .15.15.7.7 0 0 1 .13.13l.15-.09.25-.18-.24.12c-.15.07-.15.06-.15.06v-.13c0-.04.06-.11 0-.15s0 0 0-.06a.8.8 0 0 1 0-.24v.2a1.3 1.3 0 0 0 .33-.29s.07-.17-.06-.12-.09.16-.2.15-.06-.13-.11-.1a.43.43 0 0 0-.14.21v.29c0 .05-.1-.17-.2-.14s-.13.18-.12.23.25.33.18.36-.25-.22-.35 0 .3.36.35.41 0 .05.08.14.16.11.21.17a1.2 1.2 0 0 1 .2.53 2 2 0 0 1 0 .25ZM44.64 53a.4.4 0 0 1-.07-.3c0-.19.16-.53.12-.57s-.18.21-.22.15.08-.39 0-.53-.06-.22-.18-.21-.17.4-.23.33 0-.24 0-.33-.06-.13-.12-.12-.09.2-.13.2-.11-.22-.19-.19.2.41.2.41a.5.5 0 0 0 .08-.11 1 1 0 0 0 0-.14v.17a1 1 0 0 0 0 .17.5.5 0 0 1-.19 0 .7.7 0 0 1-.21-.07.6.6 0 0 0 .2.09l.3.05.09.11.1.13a1.4 1.4 0 0 0 .06-.19c0-.12.12-.31.12-.31s0 .23-.06.35v.27h-.24l-.33-.07s.16.06.32.1l.26.08.13.16.09-.13a1 1 0 0 0 .09-.17 2 2 0 0 1-.06.21l-.07.13a.5.5 0 0 1-.16 0H44a1 1 0 0 0 .23.06h.18a.4.4 0 0 0 .06.12.5.5 0 0 0 .13.12Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7",
    transform: "translate(-24.77 -33.09)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path317",
    d: "M49.49 56.36a.4.4 0 0 0-.13-.1h-.1l.07-.17.5-.48.08-.49h.31v.66h.09l.57.34v.15h-.37l-.37-.27-.14-.08-.28.36-.18.08Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-1",
    transform: "translate(-24.77 -33.09)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path319",
    d: "M49.89 55.07a.3.3 0 0 0 0 .1v.52c0 .05-.3.17-.45.3s-.16.24-.16.24a.5.5 0 0 0-.15 0 .26.26 0 0 0-.14.09 1.06 1.06 0 0 1 .31-.47 3 3 0 0 1 .4-.28 4 4 0 0 0 0-.5s0 0 .05 0Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-16",
    transform: "translate(-24.77 -33.09)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path321",
    d: "M50.54 56.5a1 1 0 0 1 .06-.1l.09-.07-.13-.07c-.13-.07-.21 0-.31-.11a1.3 1.3 0 0 1-.2-.19l-.13.12a.7.7 0 0 0 .48.32 1 1 0 0 1 .14.1",
    className: "nn-icon-flags-MX-delivery_svg__cls-16",
    transform: "translate(-24.77 -33.09)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path323",
    d: "M50.14 55.07h.17a.08.08 0 0 1 0 .06 3 3 0 0 1 0 .48.7.7 0 0 1-.13.28l-.36.33a2 2 0 0 0-.22.25l-.07-.08s-.07-.06-.06-.09a1.1 1.1 0 0 1 .3-.31.7.7 0 0 0 .36-.44 2 2 0 0 0 0-.49Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-17",
    transform: "translate(-24.77 -33.09)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path325",
    d: "M51.14 56.28h-.3a.8.8 0 0 0-.18-.16c-.12-.08-.2-.06-.32-.14a.6.6 0 0 1-.18-.2l.09-.19a1 1 0 0 0 .21.23c.11.08.35.15.42.22l.26.26Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-17",
    transform: "translate(-24.77 -33.09)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path327",
    d: "M52.27 54.13S52 54 52 53.89s.75-.31.75-.31v-.19a.8.8 0 0 0-.29 0 2.5 2.5 0 0 1-.78.14 1.7 1.7 0 0 1-.35 0l-2.64-.16h-.14c-.34 0-.56-.54-.56-.54h-.16v.28a6 6 0 0 1-1.27-.55l-.06.24s.67.36.65.5-.22.12-.22.12l.09.16s1.11.05 1.13.38c0 .13-.27.21-.27.21l.09.11a2.5 2.5 0 0 1 .77.1c.16.09.24.22.45.34a6 6 0 0 0 1.79 0c.25-.07.39-.35.79-.47a2.3 2.3 0 0 1 .52-.12v-.12Z",
    style: {
      fill: "#30c2dc"
    },
    transform: "translate(-24.77 -33.09)"
  }), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path329",
    d: "M52.27 54.13 52.1 54H52a.2.2 0 0 1 0-.06 3 3 0 0 1 .41-.16h.27v-.23a.9.9 0 0 0-.28.05 2.6 2.6 0 0 1-.78.14 1 1 0 0 1-.34 0h-.15l-1.42-.09h-1.23a.5.5 0 0 1-.22-.09.8.8 0 0 1-.23-.27.7.7 0 0 1-.06-.12h-.2a.5.5 0 0 1 0 .13.15.15 0 0 1 0 .07h-.11a5 5 0 0 1-.69-.3l-.31-.15-.13-.07-.08.28.36.21.18.14.05.06a.07.07 0 0 1 0 .06h-.21l.12.21H47a5 5 0 0 1 .6.08 1.6 1.6 0 0 1 .31.11l.1.08a.1.1 0 0 1 0 .08.1.1 0 0 1 0 .07l-.13.08h-.12l.11.14v.06h.66a.3.3 0 0 1 .12 0 1 1 0 0 1 .21.16 1.4 1.4 0 0 0 .25.18.3.3 0 0 0 .13 0 5 5 0 0 0 .77 0h.91a.9.9 0 0 0 .34-.22 1.4 1.4 0 0 1 .45-.24l.4-.11h.09v-.16.12a3 3 0 0 0-.53.13 1.3 1.3 0 0 0-.46.26.9.9 0 0 1-.32.2h-.13a8 8 0 0 1-.77 0h-.88a1.7 1.7 0 0 1-.24-.18.8.8 0 0 0-.21-.16.5.5 0 0 0-.2-.06 4 4 0 0 0-.58 0l-.1-.12a.5.5 0 0 0 .13-.06.3.3 0 0 0 .1-.06.16.16 0 0 0 0-.11.22.22 0 0 0-.06-.13.8.8 0 0 0-.27-.14 2.4 2.4 0 0 0-.52-.11h-.21.05l-.08-.16a.3.3 0 0 0 .13 0 .13.13 0 0 0 .07 0 .2.2 0 0 0 0-.08v-.08a.5.5 0 0 0-.15-.13 5 5 0 0 0-.48-.3l.07-.24.54.28.42.19.17.06a.3.3 0 0 0 .13 0V53a1 1 0 0 0 0-.15h.16a2 2 0 0 0 .15.27 1 1 0 0 0 .18.19.5.5 0 0 0 .25.1h.28l1.44.08h1.06a1.2 1.2 0 0 0 .36 0 2.6 2.6 0 0 0 .79-.14 1 1 0 0 1 .27-.06v.19l-.36.11-.26.1h-.09A.07.07 0 0 0 52 54a1 1 0 0 0 .22.12Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-19",
    transform: "translate(-24.77 -33.09)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path331",
    d: "M47 53.61a.19.19 0 0 1-.19.19.18.18 0 0 1-.19-.19.19.19 0 0 1 .19-.19.2.2 0 0 1 .19.19",
    className: "nn-icon-flags-MX-delivery_svg__cls-1",
    transform: "translate(-24.77 -33.09)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path333",
    d: "M47 53.61h-.05a.14.14 0 1 1-.28 0 .14.14 0 0 1 .28 0za.23.23 0 0 0-.23-.24.24.24 0 0 0-.24.24.24.24 0 0 0 .24.24.23.23 0 0 0 .23-.24",
    className: "nn-icon-flags-MX-delivery_svg__cls-19",
    transform: "translate(-24.77 -33.09)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path335",
    d: "M48 52.72a.19.19 0 1 1-.37 0 .19.19 0 1 1 .37 0",
    className: "nn-icon-flags-MX-delivery_svg__cls-1",
    transform: "translate(-24.77 -33.09)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path337",
    d: "M48 52.72a.15.15 0 1 1-.29 0 .14.14 0 0 1 .14-.14.15.15 0 0 1 .15.14h.09a.24.24 0 1 0-.47 0 .24.24 0 1 0 .47 0Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-19",
    transform: "translate(-24.77 -33.09)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path339",
    d: "M52.61 54.15a.2.2 0 0 1-.19.19.2.2 0 1 1 .19-.19",
    className: "nn-icon-flags-MX-delivery_svg__cls-1",
    transform: "translate(-24.77 -33.09)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path341",
    d: "M52.61 54.15a.14.14 0 0 1-.14.14.15.15 0 0 1-.15-.14.15.15 0 0 1 .15-.15.14.14 0 0 1 .14.15h.1a.25.25 0 0 0-.24-.25.24.24 0 0 0-.24.25.24.24 0 0 0 .24.24.24.24 0 0 0 .24-.24Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-19",
    transform: "translate(-24.77 -33.09)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path343",
    d: "M45.91 52.44c-.06.14.19.42.36.45s.26 0 .29-.1a.26.26 0 0 0 0-.23c-.11-.14-.56-.26-.62-.12Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path345",
    d: "M46.45 52.66c0-.09-.14-.17-.24-.17h-.16c.02 0 .25.11.25.14s-.07.06 0 .1a.09.09 0 0 0 .12 0s.07 0 .06-.09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-1",
    transform: "translate(-24.77 -33.09)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path347",
    d: "M48 54.3c0 .13-.06.19-.19.25s-.39 0-.44-.08.09-.27.25-.31a.34.34 0 0 1 .38.14",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path349",
    d: "M47.7 54.38s0 .07.1.07a.13.13 0 0 0 .07-.13.18.18 0 0 0-.17-.11c-.07 0-.28.18-.25.23s.07 0 .11 0a.5.5 0 0 1 .14-.09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-1",
    transform: "translate(-24.77 -33.09)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path351",
    d: "M52.66 53.65c.12.15.33 0 .38 0s.22-.16.16-.26a.29.29 0 0 0-.27-.09.52.52 0 0 0-.27.18.22.22 0 0 0 0 .22Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path353",
    d: "M52.7 53.54a.18.18 0 0 1 .17-.17c.08 0 .09 0 .15.06s.1 0 .1 0 0 .12-.11.12-.07 0-.17-.06-.14.1-.14.1Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-1",
    transform: "translate(-24.77 -33.09)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path355",
    d: "M50.17 53.22h-.65l.31.89.37.54h.43v-.14l-.11-.87-.4-.41Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-20",
    transform: "translate(-24.77 -33.09)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path357",
    d: "m50.17 53.22-.08-.05h-.6l.31.9.37.53h.42l.05-.14-.11-.87-.4-.42.4.41.11.85v.12h-.39l-.37-.53-.31-.89h.57l.08.05Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-21",
    transform: "translate(-24.77 -33.09)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path359",
    d: "M49.15 53.28v-.11h.17a.6.6 0 0 1 .19 0 2 2 0 0 1 .29.42c.07.16.15.44.24.61s.29.45.29.45H50l-.16-.07-.52-.81-.14-.51Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-20",
    transform: "translate(-24.77 -33.09)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path361",
    d: "M49.15 53.28v-.1h.35a2 2 0 0 1 .27.4l.11.3c0 .11.09.22.13.31s.29.45.29.45H50l-.16-.07-.51-.8-.14-.51h-.05l.14.52.52.82.16.06h.41a5 5 0 0 1-.25-.4 1.5 1.5 0 0 1-.13-.31 3 3 0 0 0-.12-.3 2 2 0 0 0-.17-.28l-.08-.1h-.39v.1Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-21",
    transform: "translate(-24.77 -33.09)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path363",
    d: "M48.93 53.17a2 2 0 0 1 .23 0 1.4 1.4 0 0 1 .35.49c.1.26.05.29.17.56a1.8 1.8 0 0 0 .29.45 3 3 0 0 1-.55 0c-.2 0-.27 0-.32-.09a1 1 0 0 0-.16-.12h-.2v-.28l-.06-.63v-.32h.19Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-20",
    transform: "translate(-24.77 -33.09)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path365",
    d: "M48.93 53.17h.22a1.3 1.3 0 0 1 .32.45 1 1 0 0 1 .07.28 1.7 1.7 0 0 0 .1.29 1.7 1.7 0 0 0 .3.45h-.76a.08.08 0 0 1-.06 0l-.1-.09h-.25v-.26l-.05-.63v-.3h.16-.18v1.23h.22a.6.6 0 0 1 .13.11.1.1 0 0 0 .05 0 1.4 1.4 0 0 0 .28.06H50a2 2 0 0 1-.28-.43 1.4 1.4 0 0 1-.09-.28c0-.07 0-.15-.07-.28a1.1 1.1 0 0 0-.21-.34l-.1-.11h-.27Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-21",
    transform: "translate(-24.77 -33.09)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path367",
    d: "m51.06 53.33-.34-.14h-.63v.32a3 3 0 0 0 .24.71 4 4 0 0 0 .26.45c.06 0 .42-.1.42-.1h.24v-.34l.06-.74-.05-.11Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-20",
    transform: "translate(-24.77 -33.09)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path369",
    d: "m51.06 53.33-.34-.14h-.63v.33a3.3 3.3 0 0 0 .24.71l.15.27a.5.5 0 0 0 .06.11.3.3 0 0 0 .06.08h.15a2 2 0 0 0 .27-.1h.24v-1.16h-.16.15v1.13h-.21l-.16.05h-.17v-.06c-.05-.09-.13-.25-.21-.38a2.7 2.7 0 0 1-.23-.7v-.32h.62l.34.13Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-21",
    transform: "translate(-24.77 -33.09)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M23.83 20.75a.56.56 0 0 0 .15.33.4.4 0 0 0-.15.25.23.23 0 0 0 .23.21c.11 0 .26-.07.26-.17a.16.16 0 0 0-.16-.15c-.07 0-.1 0-.1.07v-1c0 .08.08.08.1.08a.15.15 0 0 0 .1-.14.19.19 0 0 0-.2-.2c-.13 0-.23.15-.23.27s.11.17.11.21a.4.4 0 0 0-.11.24",
    className: "nn-icon-flags-MX-delivery_svg__cls-20"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path373",
    d: "M48.8 53.34h.07a.13.13 0 0 0 .07 0 .17.17 0 0 0 0-.12.3.3 0 0 0 0-.16.3.3 0 0 0-.17-.07.23.23 0 0 0-.18.11.32.32 0 0 0-.07.19.26.26 0 0 0 .06.14.5.5 0 0 0-.06.08.5.5 0 0 0-.05.21.46.46 0 0 0 .08.25.4.4 0 0 0 .08.09l-.08.08a.4.4 0 0 0-.09.19.22.22 0 0 0 .09.17.27.27 0 0 0 .17.06.4.4 0 0 0 .18 0l.07-.06a.1.1 0 0 0 0-.08.15.15 0 0 0-.06-.13.18.18 0 0 0-.12 0 .12.12 0 0 0-.09 0 .1.1 0 0 0 0 .07.08.08 0 0 1 .06 0 .12.12 0 0 1 .09 0 .1.1 0 0 1 0 .09s0 .05-.09.07h-.12a.24.24 0 0 1-.14-.05.17.17 0 0 1-.07-.13.3.3 0 0 1 .08-.16.5.5 0 0 1-.14-.31.33.33 0 0 1 0-.19s0-.05-.06-.08a.2.2 0 0 1 0-.1.3.3 0 0 1 .06-.17.2.2 0 0 1 .14-.08.15.15 0 0 1 .13.06.16.16 0 0 1 0 .12.11.11 0 0 1 0 .09h-.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-21",
    transform: "translate(-24.77 -33.09)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M26.32 21.22c-.06 0-.13 0-.13.17s.15.17.23.17a.2.2 0 0 0 .21-.23.26.26 0 0 0-.15-.24.5.5 0 0 0 .12-.3c0-.17-.07-.21-.07-.21a.32.32 0 0 0 .11-.23.29.29 0 0 0-.23-.25c-.08 0-.21.06-.21.15s.06.13.1.13.1 0 .1-.08v1.06a.14.14 0 0 0-.08-.14",
    className: "nn-icon-flags-MX-delivery_svg__cls-20"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path377",
    d: "M51.14 53.39H51a.11.11 0 0 1 0-.09.2.2 0 0 1 0-.05.16.16 0 0 1 .08 0 .15.15 0 0 1 .09 0h.06a.4.4 0 0 1 .1.09.3.3 0 0 1 0 .12.34.34 0 0 1 0 .16v.18a.4.4 0 0 1-.05.2.2.2 0 0 1 0 .06h.06a.2.2 0 0 1 .07.17.19.19 0 0 1-.07.16.15.15 0 0 1-.12.05.3.3 0 0 1-.14 0 .1.1 0 0 1 0-.05.08.08 0 0 1 0-.06.14.14 0 0 1 0-.11.1.1 0 0 1 .07 0 .07.07 0 0 1 .06 0 .12.12 0 0 1 0 .08.15.15 0 0 0 0-.11.12.12 0 0 0-.1-.05.14.14 0 0 0-.1 0 .18.18 0 0 0-.06.15.12.12 0 0 0 0 .09.2.2 0 0 0 .11.08.3.3 0 0 0 .12 0 .22.22 0 0 0 .15-.06.25.25 0 0 0 .08-.2.3.3 0 0 0-.08-.21.2.2 0 0 0-.08-.05.5.5 0 0 0 .12-.31.36.36 0 0 0 0-.18v-.05a.2.2 0 0 0 .06-.07.4.4 0 0 0 0-.18.28.28 0 0 0-.09-.19.16.16 0 0 0-.08-.06h-.08a.3.3 0 0 0-.15 0l-.06.06a.1.1 0 0 0 0 .07.14.14 0 0 0 .05.12.08.08 0 0 0 .08 0h.08Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-21",
    transform: "translate(-24.77 -33.09)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path379",
    d: "M49 54.34s0 .09.07.12a3 3 0 0 0 .84.09 3.5 3.5 0 0 0 .81 0c.1-.06.11-.16.17-.21h.08l-.07.07v.12l.05.07-.08.08a.4.4 0 0 1-.2.06h-1.39c-.19 0-.16 0-.22-.06a.5.5 0 0 1-.08-.08v-.21Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-21",
    transform: "translate(-24.77 -33.09)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path381",
    d: "m50.86 53.26.1.05s-.08 0-.15.2 0 .23-.05.25a5 5 0 0 1-.53 0l-.09-.21.72-.3Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-21",
    transform: "translate(-24.77 -33.09)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path383",
    d: "M52.41 53.19a.22.22 0 0 1-.12-.1c0-.07-.07-.15 0-.17s.09 0 .08.1.08.17.08.17Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path385",
    d: "M53.35 52.93a.6.6 0 0 0 .08.12l.12.05a.4.4 0 0 1-.17 0 .7.7 0 0 1-.11-.14Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path387",
    d: "M53.64 53a.18.18 0 0 1-.15 0c-.06 0-.12-.07-.09-.1s0 0 .08 0 .16.06.16.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path389",
    d: "M54.12 52.61a.2.2 0 0 1-.11.06s-.14 0-.14 0h.14Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path391",
    d: "M53.4 51.65a.34.34 0 0 0-.14.09s0 .11 0 .11v-.08a.6.6 0 0 1 .14-.12",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path393",
    d: "M52.93 51.92a.5.5 0 0 0-.11.09v.14s.07-.07.07-.11a.5.5 0 0 1 0-.12Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path395",
    d: "m52.07 52.49-.26.28a2.65 2.65 0 0 0 1.07.32 1.85 1.85 0 0 0 1-.45 1 1 0 0 0-.06-.5.92.92 0 0 0-.5-.34 1.24 1.24 0 0 0-.53.37c-.2.19-.18.35-.45.34h-.29Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-23",
    transform: "translate(-24.77 -33.09)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path397",
    d: "m52.07 52.49-.28.3s.15.08.35.16a2 2 0 0 0 .69.16 1.8 1.8 0 0 0 .68-.2l.24-.15.08-.06v-.05a.13.13 0 0 0 0-.06.2.2 0 0 0 0-.07 2 2 0 0 0 0-.22.6.6 0 0 0-.05-.17.4.4 0 0 0-.09-.1 1.3 1.3 0 0 0-.22-.17l-.11-.06h-.1a.5.5 0 0 0-.25.12 2 2 0 0 0-.29.25 1.7 1.7 0 0 0-.2.24.3.3 0 0 1-.08.07h-.46.29a.3.3 0 0 0 .15 0 .44.44 0 0 0 .14-.13 1 1 0 0 1 .15-.19 3 3 0 0 1 .29-.24.56.56 0 0 1 .23-.12.3.3 0 0 1 .11 0 1.4 1.4 0 0 1 .22.15.4.4 0 0 1 .09.08.2.2 0 0 1 0 .06.4.4 0 0 1 0 .16 2 2 0 0 1 0 .21v.07a1.7 1.7 0 0 1-.39.24 1.4 1.4 0 0 1-.59.16 1.9 1.9 0 0 1-.67-.16 1.5 1.5 0 0 1-.25-.11h-.07l.26-.27Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path399",
    d: "M52 52.6s.64.1.83-.07.38-.48.51-.55a.4.4 0 0 1 .19-.08l.14.1.16.14.06.3v.17l-.2.17-.37.17-.35.11h-.3l-.61-.18-.15-.11z",
    className: "nn-icon-flags-MX-delivery_svg__cls-24",
    transform: "translate(-24.77 -33.09)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path401",
    d: "M53 52.23h.08c.08 0 .1 0 .1.06s-.05.14-.1.14-.08-.14-.08-.2",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path403",
    d: "M53.25 52.39s0-.07.09-.07a.12.12 0 0 1 .11.11.09.09 0 0 1-.1.09c-.06 0-.1-.08-.1-.13",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path405",
    d: "M53.16 52.78c0-.07 0-.08.09-.08s.1 0 .1.09a.11.11 0 0 1-.11.11c-.06 0-.08-.06-.08-.12",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path407",
    d: "M52.82 52.66c0-.07.06-.09.11-.09s.1 0 .1.12 0 .12-.1.12-.11-.09-.11-.15",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path409",
    d: "M52.28 52.72a.13.13 0 1 1 .26 0 .13.13 0 1 1-.26 0",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path411",
    d: "M53.25 52.39s.06-.07.09-.07a.07.07 0 0 1 .07.08.08.08 0 0 1-.07.08.11.11 0 0 1-.09-.09",
    className: "nn-icon-flags-MX-delivery_svg__cls-23",
    transform: "translate(-24.77 -33.09)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path413",
    d: "M53.16 52.76s.05-.07.1-.07.09 0 .09.07a.09.09 0 0 1-.09.09.09.09 0 0 1-.1-.09",
    className: "nn-icon-flags-MX-delivery_svg__cls-23",
    transform: "translate(-24.77 -33.09)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path415",
    d: "M52.82 52.65c0-.06.09-.08.13-.08s0 0 0 .09 0 .1-.07.1a.11.11 0 0 1-.09-.11Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-23",
    transform: "translate(-24.77 -33.09)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path417",
    d: "M53 52.22h.07c.07 0 .06 0 .06.07s0 .09-.06.09-.07 0-.07-.11Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-23",
    transform: "translate(-24.77 -33.09)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path419",
    d: "M52.28 52.68a.12.12 0 0 1 .13-.11c.07 0 .15 0 .15.08a.21.21 0 0 1-.17.17c-.07 0-.11-.08-.11-.14",
    className: "nn-icon-flags-MX-delivery_svg__cls-23",
    transform: "translate(-24.77 -33.09)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path421",
    d: "M52.53 52.58a.4.4 0 0 0-.14.06s0 .1 0 .11.06 0 .07 0l.1-.12Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path423",
    d: "M53 52.49a.25.25 0 0 0-.09.12v.09-.21Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path425",
    d: "M53 52.58a.14.14 0 0 0-.09 0s-.08.08 0 .08h.07a.3.3 0 0 1 .07-.08Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path427",
    d: "m53.11 52.08-.06.06s-.06.08 0 .1 0 0 .07-.06a.3.3 0 0 0 0-.1Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path429",
    d: "M53.44 52.29s-.09 0-.11.05 0 .08 0 .08l.06-.06a.2.2 0 0 1 .06-.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path431",
    d: "M53.39 52.67a.14.14 0 0 1-.07.08s-.07.06-.09 0 0-.06 0-.06h.12Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path433",
    d: "M53.9 52.41a.25.25 0 0 1-.12.27 1.84 1.84 0 0 1-1 .35 2.7 2.7 0 0 1-.87-.27h-.07l.11.05.31.13.36.11h.42l.36-.12.31-.16.16-.13v-.17Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path435",
    d: "M45.89 50.11s.09.08.09.15 0 .09-.06.08 0-.08 0-.11v-.12Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path437",
    d: "M46.59 50.76s0 .12-.07.13-.09 0-.08-.06.05 0 .07 0l.08-.05Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path439",
    d: "M45.07 50.85a.14.14 0 0 0 .09.08h.08-.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path441",
    d: "M45.34 51.38a.25.25 0 0 0 .13.08.1.1 0 0 0 .12-.07s-.09 0-.11 0h-.14Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path443",
    d: "M45.82 51.79h.15c.02 0 .05-.09 0-.13s0 .06-.06.09-.11.09-.11.09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path445",
    d: "M46.6 51.47a1.13 1.13 0 0 0-.37-.95c-.45-.39-.74-.3-.9-.15a.72.72 0 0 0 .19 1 1.33 1.33 0 0 0 1.07.28v-.21Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-23",
    transform: "translate(-24.77 -33.09)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path447",
    d: "M46.6 51.47a.5.5 0 0 0 0-.11 1.15 1.15 0 0 0-.39-.86.9.9 0 0 0-.59-.28.46.46 0 0 0-.33.13.6.6 0 0 0-.15.41.86.86 0 0 0 .34.66 1.34 1.34 0 0 0 .86.3 1 1 0 0 0 .22 0v-.23.21h-.21a1.25 1.25 0 0 1-.83-.29.8.8 0 0 1-.32-.62.47.47 0 0 1 .13-.37.4.4 0 0 1 .3-.12.85.85 0 0 1 .56.27 1.05 1.05 0 0 1 .37.82.2.2 0 0 1 0 .08Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path449",
    d: "M45.23 50.88s0-.31.13-.4a.62.62 0 0 1 .85.28 1.14 1.14 0 0 1 .18.91h-.25l-.38-.16-.33-.24z",
    className: "nn-icon-flags-MX-delivery_svg__cls-24",
    transform: "translate(-24.77 -33.09)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path451",
    d: "M46.54 51.55a.3.3 0 0 1-.24.08 1.36 1.36 0 0 1-1.11-.88v.33l.16.23.2.17.25.13h.18l.23.05h.14l.12-.16Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path453",
    d: "M46.14 51.35c0-.06 0-.06.08-.06h.09s0 .15-.08.15-.09-.07-.09-.13Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path455",
    d: "M46.18 51a.07.07 0 0 1 .08-.08.08.08 0 0 1 .09.08.08.08 0 0 1-.09.07.07.07 0 0 1-.08-.07",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path457",
    d: "M45.84 51.39s0-.06.09-.06.1 0 .1.06-.1.08-.15.08 0 0 0-.08Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path459",
    d: "M45.8 51h.08c.08 0 .1 0 .1.07s-.06.12-.1.12-.08-.19-.08-.19",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path461",
    d: "M45.49 51s0-.11.08-.11a.14.14 0 0 1 .12.11.1.1 0 0 1-.1.08.09.09 0 0 1-.1-.08",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path463",
    d: "M45.54 50.67c0-.05 0-.05.09-.05s.11 0 .11.07a.14.14 0 0 1-.13.11c-.06 0-.07-.09-.07-.13",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path465",
    d: "M45.89 50.63h.09a.1.1 0 0 1 .1.08s-.07.1-.13.1-.06-.1-.06-.15Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path467",
    d: "M45.54 50.66a.07.07 0 0 1 .07-.06s.08 0 .08.06a.08.08 0 0 1-.07.08s-.09 0-.08-.08",
    className: "nn-icon-flags-MX-delivery_svg__cls-23",
    transform: "translate(-24.77 -33.09)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path469",
    d: "M45.48 51s0-.09.07-.09h.08a.1.1 0 0 1-.09.1s-.06 0-.06-.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-23",
    transform: "translate(-24.77 -33.09)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path471",
    d: "M45.88 50.64h.15a.07.07 0 0 1-.08.07.08.08 0 0 1-.07-.07",
    className: "nn-icon-flags-MX-delivery_svg__cls-23",
    transform: "translate(-24.77 -33.09)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path473",
    d: "M45.8 51a.09.09 0 0 0 .09.09A.1.1 0 0 0 46 51a.11.11 0 0 0-.1-.1.1.1 0 0 0-.08.1Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-23",
    transform: "translate(-24.77 -33.09)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path475",
    d: "M46.19 50.94a.09.09 0 0 0 .09.08.09.09 0 0 0 .08-.08.08.08 0 0 0-.08-.08.08.08 0 0 0-.09.08",
    className: "nn-icon-flags-MX-delivery_svg__cls-23",
    transform: "translate(-24.77 -33.09)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path477",
    d: "M45.82 51.39a.09.09 0 0 1 .08-.08s.08 0 .08.06-.07.09-.11.09-.05-.04-.05-.07",
    className: "nn-icon-flags-MX-delivery_svg__cls-23",
    transform: "translate(-24.77 -33.09)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path479",
    d: "M46.15 51.33h.16a.09.09 0 0 1-.09.09s-.07 0-.07-.09",
    className: "nn-icon-flags-MX-delivery_svg__cls-23",
    transform: "translate(-24.77 -33.09)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path481",
    d: "M46.23 50.77a.2.2 0 0 1 .06.11.2.2 0 0 1 0 .11s0 0-.06-.08a.6.6 0 0 1 0-.14",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path483",
    d: "M46 50.46a.2.2 0 0 1 0 .1v.09-.08a1 1 0 0 1 0-.11",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path485",
    d: "M45.61 50.5a.3.3 0 0 1 0 .1v.09-.07a1 1 0 0 1 0-.12",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path487",
    d: "M45.49 50.57a.3.3 0 0 1 .09 0s.05.07 0 .08 0 0-.06 0-.06-.09-.06-.09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path489",
    d: "M45.75 50.92a.14.14 0 0 1 .1 0s.07.06 0 .08-.07 0-.09 0a1 1 0 0 1 0-.08Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path491",
    d: "M45.44 50.91a.2.2 0 0 1 .09 0s0 .06 0 .07 0 0-.06 0a.3.3 0 0 1-.03-.07",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path493",
    d: "M46.19 51.15a.6.6 0 0 1 0 .12v.1-.11a.4.4 0 0 1 0-.11",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path495",
    d: "M46.11 51.26a.2.2 0 0 1 .07.05s0 0 0 .06 0 0-.05 0v-.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path497",
    d: "M45.77 51.29h.08c.02 0 0 .09 0 .1s0 0-.06 0a.3.3 0 0 0 0-.09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path499",
    d: "M45.64 50.26s-.3.06-.35.25a1.6 1.6 0 0 0-.06.41v-.25l.06-.16.08-.14.13-.08h.12Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path501",
    d: "M46.57 51.39s0-.07-.06-.3a4 4 0 0 0-.26-.55l.14.16.11.18v.47Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path503",
    d: "M46.87 51s.1.07.11.11 0 .05 0 .06-.07 0-.08-.06a1 1 0 0 1-.03-.11",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path505",
    d: "M46.43 52.19a.4.4 0 0 1 .12-.13h.13c.02 0 0 .07-.09.09h-.16Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path507",
    d: "M47.17 52.47a.7.7 0 0 0 .12-.09c.05-.05.05-.08 0-.1s-.07 0-.1 0a.5.5 0 0 0-.02.19",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path509",
    d: "M47.09 52.4a.4.4 0 0 1 0-.13.07.07 0 0 1 .08 0s0 .06 0 .09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path511",
    d: "M48.31 51.84a1.66 1.66 0 0 0-1.16-.69.66.66 0 0 0-.73.63c0 .15.23.48 1 .53s.88-.35.91-.37 0-.1 0-.1Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-23",
    transform: "translate(-24.77 -33.09)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path513",
    d: "M48.31 51.84a1.6 1.6 0 0 0-.32-.34 1.48 1.48 0 0 0-.86-.37.69.69 0 0 0-.55.25.9.9 0 0 0-.12.21.6.6 0 0 0 0 .17c0 .17.25.5 1 .56h.14a.94.94 0 0 0 .63-.19l.07-.13v-.05h-.05a.6.6 0 0 1-.2.2 1 1 0 0 1-.53.13h-.14c-.75-.06-.95-.38-1-.52a.4.4 0 0 1 0-.16.64.64 0 0 1 .2-.28.66.66 0 0 1 .42-.14 1.5 1.5 0 0 1 .83.35 3 3 0 0 1 .23.23l.06.08Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path515",
    d: "M47.78 51.39a1.7 1.7 0 0 1 .26.25c.08.12.1.2.05.22a3.7 3.7 0 0 0-.79-.45c-.34-.08-.63 0-.7.16a.43.43 0 0 0 .12.5 4.4 4.4 0 0 0 .87.22h.34l.21-.12v-.12l.05-.15v-.06l-.17-.19-.31-.21Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-24",
    transform: "translate(-24.77 -33.09)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path517",
    d: "M47.2 51.48s-.05.06-.09.06-.08 0-.08-.06a.08.08 0 0 1 .08-.08.1.1 0 0 1 .09.08",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path519",
    d: "M46.78 51.63h.1a.08.08 0 0 1 .08.08.1.1 0 0 1-.12.08.13.13 0 0 1-.06-.16",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path521",
    d: "M47.23 51.87a.09.09 0 0 1 .1-.09.1.1 0 0 1 .1.09.15.15 0 0 1-.13.12c-.06 0-.07-.06-.07-.12",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path523",
    d: "M46.89 52h.09a.1.1 0 0 1 .09.09.09.09 0 0 1-.09.08s-.09-.17-.09-.17",
    className: "nn-icon-flags-MX-delivery_svg__cls-23",
    transform: "translate(-24.77 -33.09)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path525",
    d: "M47.49 52.14a.07.07 0 0 1 .07-.07s.08 0 .08.06a.09.09 0 0 1-.08.08.08.08 0 0 1-.07-.07",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path527",
    d: "M47.77 51.93h.07c.07 0 .1 0 .1.07s-.06.08-.11.08-.06-.06-.06-.11Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path529",
    d: "M47.17 51.44s0 .06-.05.06-.09 0-.09-.06 0 0 .06 0z",
    className: "nn-icon-flags-MX-delivery_svg__cls-23",
    transform: "translate(-24.77 -33.09)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path531",
    d: "M47 51.62s-.06.06-.1.06a.05.05 0 0 1-.06-.06.06.06 0 0 1 .06-.06s.1 0 .1.06",
    className: "nn-icon-flags-MX-delivery_svg__cls-23",
    transform: "translate(-24.77 -33.09)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path533",
    d: "M47.05 52a.05.05 0 0 1-.05 0s-.1 0-.1-.06a.05.05 0 0 1 .06-.06s.1 0 .1.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-23",
    transform: "translate(-24.77 -33.09)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path535",
    d: "M47.41 51.85s-.07.08-.11.08-.06-.07-.06-.11a.07.07 0 0 1 .07-.07.13.13 0 0 1 .1.1",
    className: "nn-icon-flags-MX-delivery_svg__cls-23",
    transform: "translate(-24.77 -33.09)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path537",
    d: "M47.93 52h-.09c-.03 0-.07 0-.07-.08s0-.08.1-.07.06.07.06.11Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-23",
    transform: "translate(-24.77 -33.09)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path539",
    d: "M47.62 52.12a.07.07 0 0 1-.06.07.07.07 0 0 1-.07-.07s0 0 .07 0 .06-.04.06 0",
    className: "nn-icon-flags-MX-delivery_svg__cls-23",
    transform: "translate(-24.77 -33.09)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path541",
    d: "M47.67 51.9h.19-.19",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path543",
    d: "M47.36 52.16h.18-.18",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path545",
    d: "M47.17 51.71a.4.4 0 0 1 .15.1s0 .07 0 .08 0 0-.07 0l-.09-.14Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path547",
    d: "M47.13 51.87h.21-.05Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path549",
    d: "M46.82 51.88a.3.3 0 0 1 .14 0A.06.06 0 0 1 47 52s-.06 0-.08 0l-.07-.1Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path551",
    d: "M46.81 52a.14.14 0 0 1 .08-.07.09.09 0 0 1 .11.07.07.07 0 0 1-.06.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path553",
    d: "M46.73 51.56a.2.2 0 0 1 .1 0s.05 0 0 .07a.08.08 0 0 1-.08 0 .2.2 0 0 1-.06-.09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path555",
    d: "M47 51.29a.6.6 0 0 1 .14.08v.09c0 .01-.06 0-.08 0a1 1 0 0 1-.07-.13Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path557",
    d: "M48.19 52.07a1.15 1.15 0 0 1-.72.17 1.3 1.3 0 0 1-1-.46v.11l.11.15.35.17.39.09h.6l.22-.11v-.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path559",
    d: "M48.25 51.83a2 2 0 0 0-.2-.21c-.11-.1-.56-.4-.56-.4l.36.17.24.2.17.19Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path561",
    d: "M48.27 51.4s.13 0 .15.07v.06s0 .08-.06 0l-.07-.08a1 1 0 0 1-.06-.1Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path563",
    d: "M48.64 51.2a.5.5 0 0 1 .16.1v.11s-.09-.06-.1-.08a1 1 0 0 0-.07-.13Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path565",
    d: "M48.76 51.17s.11.08.12.12.06.08 0 .1-.08 0-.1-.08v-.14Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path567",
    d: "M49.38 51.32s.09 0 .09.1a.5.5 0 0 1 0 .13s-.06 0-.06-.07v-.16Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path569",
    d: "M49.55 51.38a.4.4 0 0 1 .07.11s0 .08 0 .08-.06 0-.06-.07v-.12Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path571",
    d: "M48.43 52.74a.2.2 0 0 0 .1 0s.09-.07.08-.1 0 0-.07 0 0 .06 0 .08h-.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path573",
    d: "M49 52.91a.22.22 0 0 0 .14-.08c.06 0 .08-.1 0-.11a.06.06 0 0 0-.09.05.7.7 0 0 1-.09.14Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path575",
    d: "M49.55 52.92a.5.5 0 0 0 .11-.08c.05 0 .07-.07 0-.1h-.07v.06a1 1 0 0 1-.06.11Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path577",
    d: "M49.7 52.92a1 1 0 0 0 .09-.12s0-.1 0-.1a.11.11 0 0 0-.07.08s0 .14 0 .14Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path579",
    d: "M48.17 52.1c0-.22.31-.73.68-.73a2.7 2.7 0 0 1 .69.19c.2.09.26.19.4.23a1.1 1.1 0 0 0 .33 0h.45l-.35.52-.13.12a.85.85 0 0 1-.43.34 2.2 2.2 0 0 1-1.12 0 .66.66 0 0 1-.52-.59Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-23",
    transform: "translate(-24.77 -33.09)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path581",
    d: "M48.17 52.1a.5.5 0 0 1 .05-.19 1 1 0 0 1 .25-.35.54.54 0 0 1 .35-.16 1.4 1.4 0 0 1 .3.05l.38.13a2 2 0 0 1 .22.14.6.6 0 0 0 .18.09h.74l-.32.48-.13.11a.87.87 0 0 1-.42.33 1.3 1.3 0 0 1-.41.06 3 3 0 0 1-.69-.09.7.7 0 0 1-.34-.2.5.5 0 0 1-.17-.36.6.6 0 0 0 .18.4.9.9 0 0 0 .37.21 3 3 0 0 0 .7.09 1.1 1.1 0 0 0 .42-.07.84.84 0 0 0 .45-.35l.13-.11.38-.57-.5.06h-.16a.5.5 0 0 1-.17 0 .35.35 0 0 1-.16-.08 2 2 0 0 0-.23-.14 3 3 0 0 0-.38-.13 1.2 1.2 0 0 0-.32-.06.46.46 0 0 0-.27.09 1 1 0 0 0-.3.32.73.73 0 0 0-.13.34Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path583",
    d: "M50.36 52.17a.2.2 0 0 1-.13 0 5.8 5.8 0 0 0-1.36-.59c-.32 0-.62.17-.62.49s.07.32.13.41a2.7 2.7 0 0 0 .68.23h.68l.26-.15.15-.11.1-.12.11-.15Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-24",
    transform: "translate(-24.77 -33.09)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path585",
    d: "M48.77 52c0 .06 0 .11-.09.11s-.1 0-.1-.09 0-.09.09-.09.1.07.1.07",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path587",
    d: "M48.87 51.73s.05-.08.11-.08.11 0 .11.08a.11.11 0 0 1-.22 0",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path589",
    d: "M49.48 51.89a.09.09 0 0 1 .09-.08.09.09 0 0 1 .08.08.08.08 0 0 1-.08.08.08.08 0 0 1-.09-.08",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path591",
    d: "M49.6 52.26a.09.09 0 0 1 .09-.1c.06 0 .1 0 .1.08s0 .11-.07.11-.12-.03-.12-.09",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path593",
    d: "M49.31 52.5a.09.09 0 0 1 .1-.09.09.09 0 0 1 .09.09s0 .08-.09.08a.09.09 0 0 1-.1-.08",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path595",
    d: "M48.75 52.4a.09.09 0 0 1 .18 0 .09.09 0 0 1-.18 0",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path597",
    d: "M48.77 52a.11.11 0 0 1-.1.09.1.1 0 0 1-.09-.09s0-.07.09-.07.1 0 .1.07",
    className: "nn-icon-flags-MX-delivery_svg__cls-23",
    transform: "translate(-24.77 -33.09)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path599",
    d: "M49.06 51.71s0 .08-.07.08-.11 0-.11-.08a.09.09 0 0 1 .18 0",
    className: "nn-icon-flags-MX-delivery_svg__cls-23",
    transform: "translate(-24.77 -33.09)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path601",
    d: "M49.64 51.87a.07.07 0 0 1-.08.07.08.08 0 0 1-.09-.07.09.09 0 0 1 .09-.08.08.08 0 0 1 .08.08",
    className: "nn-icon-flags-MX-delivery_svg__cls-23",
    transform: "translate(-24.77 -33.09)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path603",
    d: "M49.33 52.11c0 .07 0 .11-.08.11s-.11 0-.11-.09 0-.09.1-.09.09 0 .09.07",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path605",
    d: "M48.91 52.38a.09.09 0 0 1-.09.09.09.09 0 0 1-.1-.09c0-.05.06-.07.11-.07s.08 0 .08.07",
    className: "nn-icon-flags-MX-delivery_svg__cls-23",
    transform: "translate(-24.77 -33.09)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path607",
    d: "M49.31 52.1a.09.09 0 1 1-.09-.09.09.09 0 0 1 .09.09",
    className: "nn-icon-flags-MX-delivery_svg__cls-23",
    transform: "translate(-24.77 -33.09)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path609",
    d: "M49.79 52.23a.09.09 0 0 1-.09.1.11.11 0 0 1-.1-.1c0-.06 0-.08.07-.08s.12 0 .12.08",
    className: "nn-icon-flags-MX-delivery_svg__cls-23",
    transform: "translate(-24.77 -33.09)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path611",
    d: "M49.49 52.48a.08.08 0 0 1-.09.08.09.09 0 0 1-.1-.08s0-.07.09-.07.1.02.1.07",
    className: "nn-icon-flags-MX-delivery_svg__cls-23",
    transform: "translate(-24.77 -33.09)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path613",
    d: "M49.52 52.18h.18a.06.06 0 0 1 0 .08s-.07 0-.08 0l-.11-.08Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path615",
    d: "M49.38 51.69a.4.4 0 0 1 .16.08s0 .1 0 .11a.12.12 0 0 1-.09 0s-.1-.17-.1-.17Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path617",
    d: "M49 51.93a.8.8 0 0 1 .17.11s0 .08 0 .09-.08 0-.09 0l-.1-.18Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path619",
    d: "M49 52a.7.7 0 0 1 .19 0s.06 0 .06.05l-.11-.05z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path621",
    d: "M48.8 51.59a.6.6 0 0 1 .18 0 .07.07 0 0 1 0 .11s-.08 0-.09 0a.6.6 0 0 0-.1-.11Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path623",
    d: "M48.47 51.82a.6.6 0 0 1 .18.13s.05.06 0 .08-.08-.06-.08-.08a.7.7 0 0 0-.1-.13",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path625",
    d: "M48.44 52h.24-.09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path627",
    d: "M49.22 52.51s.1-.06.15 0 .06 0 .06 0h-.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path629",
    d: "M48.67 52.43s0-.06.08-.06h.07-.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path631",
    d: "M50.24 52.33a1.1 1.1 0 0 1-.36.27 1.27 1.27 0 0 1-.67.1 1.3 1.3 0 0 1-.63-.16 1 1 0 0 1-.38-.31v.1l.18.24.22.1.31.07h.8l.18-.06.11-.08.1-.08.11-.19Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path633",
    d: "M50 51.79s-.09 0-.27-.08a1.4 1.4 0 0 0-.8-.26.66.66 0 0 0-.57.3l.19-.24.18-.1h.45l.16.05.19.06.17.09.2.11h.08Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path635",
    d: "M50.5 51.92a3 3 0 0 0-.3 0h-.08l-.12-.08.32-.05.18.07z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path637",
    d: "M50.06 53.59a.13.13 0 0 0 .11.08h.47l.11-.13.07-.29.09-.11.3-.17.26-.07h.17l.23-.08.17-.09.07-.11.07-.16-.07-.23-.18-.23-.3-.12h-.26l-.28.1-.5.12a.9.9 0 0 0-.39.33 1.1 1.1 0 0 0-.13.56v.65Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-24",
    transform: "translate(-24.77 -33.09)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path639",
    d: "M50.06 53.59a.15.15 0 0 0 .05.06.1.1 0 0 0 .08 0h.48l.12-.14.07-.3v-.05l.24-.16.12-.06.26-.07h.17l.24-.08.17-.09.08-.12.08-.17-.08-.24-.14-.24-.32-.13h-.26l-.29.11-.5.12-.16.09a.8.8 0 0 0-.34.51 1.7 1.7 0 0 0 0 .3v.66h.05v-.95a1 1 0 0 1 .1-.25.63.63 0 0 1 .23-.23l.1-.07h.05l.5-.12.29-.1h.24l.3.12.17.23.07.22-.07.15-.07.1-.16.09-.23.07h-.17l-.26.08-.15.08-.11.06-.07.08-.07.29-.1.12h-.51a.05.05 0 0 1 0-.05Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path641",
    d: "M50.2 53.48c.09 0 0-.16.13-.35a2 2 0 0 1 .27-.42s0 0 .08 0 .11-.07.11-.09a.24.24 0 0 1 .09-.19 1 1 0 0 1 .25-.18h.09c.01 0 0 .06 0 .07a.13.13 0 0 0 .15 0 .13.13 0 0 0 0-.08.2.2 0 0 1 .17 0c.1 0 .12 0 .13.06s0 0 0 .08v.05a.11.11 0 0 0 .1.09.16.16 0 0 0 .11 0s0 0 0-.06.14.17.18.1a.18.18 0 0 0 0-.17L51.9 52l-.27-.09h-.37l-.36.2-.33.18s0 .26-.07.22-.15-.18-.17-.14-.08.24-.12.34a2.2 2.2 0 0 0-.12.51c0 .11.07.27.11.27Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-23",
    transform: "translate(-24.77 -33.09)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path643",
    d: "M50.53 53a.11.11 0 0 0-.08.05.09.09 0 0 0 0 .08l.07.07h.09a.1.1 0 0 0 0-.07.06.06 0 0 0 0-.06h-.09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-23",
    transform: "translate(-24.77 -33.09)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path645",
    d: "M51.09 52.58a.06.06 0 0 0-.08 0s0 .07 0 .08.1 0 .12 0 .05 0 0-.09-.06-.07-.06-.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-23",
    transform: "translate(-24.77 -33.09)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path647",
    d: "M51.54 52.69h-.07a.09.09 0 0 0-.06.1.08.08 0 0 0 .11.05s0-.07 0-.08Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-23",
    transform: "translate(-24.77 -33.09)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path649",
    d: "M50.23 52.78a.11.11 0 0 0 .11.07.1.1 0 0 0 .11-.09s0 0-.08.05-.07 0-.09 0h-.05Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-23",
    transform: "translate(-24.77 -33.09)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path651",
    d: "M50.66 53.14a.1.1 0 0 1 0 .09.14.14 0 0 1-.1 0 .1.1 0 0 1-.07 0v-.06a.12.12 0 0 0 .12 0 .17.17 0 0 0 .11-.08Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path653",
    d: "M51.88 52.38a.12.12 0 0 1 0 .09h-.09a.1.1 0 0 1-.08 0c-.05-.09 0-.14 0-.14s0 .14.11.13a.18.18 0 0 0 .12-.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path655",
    d: "M50.79 52.64s0 .12-.11.12h-.06.07a.5.5 0 0 0 .1-.09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path657",
    d: "M51 52.62v.11a.14.14 0 0 0 .09.05.08.08 0 0 0 .08 0 .06.06 0 0 0 0-.07s0 0-.07 0h-.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path659",
    d: "M51.39 52.23a.1.1 0 0 1 0 .11.15.15 0 0 1-.14 0 .12.12 0 0 0 .11 0 .4.4 0 0 0 .03-.11",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path661",
    d: "M50.16 53.65s.48 0 .52-.07a.6.6 0 0 1 .24-.53 1.2 1.2 0 0 1 .67-.22.59.59 0 0 0 .55-.41c0-.18-.21-.19-.3-.36s-.33-.1-.34-.1a.64.64 0 0 0-.4.11c-.08.08-.07.17-.1.21s-.35 0-.39 0 0 .16 0 .18-.09-.07-.09-.07v-.25l.41-.24.46-.25h.31l.32.16.16.18a1 1 0 0 1 0 .22.5.5 0 0 1 0 .17.64.64 0 0 1-.6.46 1.27 1.27 0 0 0-.65.23c-.12.09-.19.49-.19.54a3 3 0 0 1-.59 0Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path663",
    d: "M50.36 52.72h-.07a.4.4 0 0 1 0-.2.7.7 0 0 0 0 .14s.09.04.07.06",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path665",
    d: "M50.66 52.65v-.11a1.4 1.4 0 0 1 .15-.13l-.06.14s-.06.11-.09.1",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path667",
    d: "M50.54 53.14v-.09c0-.09.09-.15.09-.15a1 1 0 0 0 0 .11v.09c0 .04 0 0-.05 0Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path669",
    d: "M50.76 53a.3.3 0 0 1-.09.07s-.1.07-.13.06 0-.07 0-.08l.18-.05Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path671",
    d: "M51.18 52.42a.3.3 0 0 0-.09.11v.13c0 .01.07-.08.07-.1s.02-.14.02-.14",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path673",
    d: "M51.33 52.62a.4.4 0 0 0-.11 0h-.11c-.01 0 0 0 0 .07s.06 0 .08 0h.17Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path675",
    d: "M51.24 52.22h.09a.3.3 0 0 0 .06-.11.4.4 0 0 0-.1.06s-.06.09 0 .1Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path677",
    d: "M51.87 52.21a.6.6 0 0 0-.11.07s-.07.08 0 .1.05 0 .08-.05Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path679",
    d: "M51.69 52.63a.4.4 0 0 1-.08.09s-.11.05-.12 0 0-.06 0-.07h.18Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-22",
    transform: "translate(-24.77 -33.09)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon681",
    d: "m22.99 17.44-.16.39.13-.02.08-.34z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path7828",
    d: "M47.35 51.2c0 .21.06.4.2.42s.28-.13.32-.34-.06-.41-.2-.43-.29.15-.32.35",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon683",
    d: "m23.05 17.47-.07-.05v.02h.01l-.01.01.04.03-.07.32-.1.02.15-.37-.01-.01-.01.01.01-.01h-.01l-.16.41.15-.03z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path685",
    d: "M47.83 50.37a.11.11 0 0 0-.12.1c0 .05 0 .11.09.11a.09.09 0 0 0 .11-.09.1.1 0 0 0-.08-.12",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path687",
    d: "M47.83 50.37a.13.13 0 0 0-.12.1.12.12 0 0 0 .1.12.13.13 0 0 0 .12-.11.12.12 0 0 0-.1-.12.11.11 0 0 1 .08.1.09.09 0 0 1-.09.09.09.09 0 0 1-.08-.09.11.11 0 0 1 .1-.09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path689",
    d: "M47.87 50.39a.11.11 0 0 0-.12.09.09.09 0 0 0 .09.1h-.08v-.05Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path691",
    d: "M47.78 50.65h-.05l-.07.09.09-.21v.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon771",
    d: "m20.02 16.17.2.45.09-.12-.23-.34z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon773",
    d: "m20.09 16.14-.09.03.01.01.01-.01v.01l.06-.01.22.33-.07.1-.2-.43h-.01v.01-.01l-.01.01.21.46.1-.14z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path775",
    d: "M44.71 49.07a.14.14 0 0 0 0 .18.13.13 0 0 0 .17 0 .14.14 0 0 0 0-.18.13.13 0 0 0-.17 0",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path3910",
    d: "M45.49 50c.11.2.09.43-.05.5s-.34 0-.44-.23-.09-.44 0-.51.38.01.49.24",
    style: {
      fill: "#f15770"
    },
    transform: "translate(-24.77 -33.09)"
  }), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path2929",
    d: "M45.49 50c.11.2.09.43-.05.5s-.34 0-.44-.23-.09-.44 0-.51.38.01.49.24",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path777",
    d: "M44.71 49.07a.12.12 0 0 0-.05.09.1.1 0 0 0 0 .09.1.1 0 0 0 .1 0 .1.1 0 0 0 .08 0 .16.16 0 0 0 .05-.1.1.1 0 0 0 0-.09.1.1 0 0 0-.1-.05.1.1 0 0 0-.08 0h.07a.12.12 0 0 1 .09 0 .1.1 0 0 1 0 .08.1.1 0 0 1 0 .08.1.1 0 0 1-.07 0 .11.11 0 0 1-.09 0 .1.1 0 0 1 0-.08.12.12 0 0 1 0-.08Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path779",
    d: "M44.75 49.05a.13.13 0 0 0 0 .18.1.1 0 0 0 .15 0h-.11v-.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path781",
    d: "M44.9 49.34v.2l-.11-.25h.06v.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path783",
    d: "M44.77 50h.13a.15.15 0 0 0 .07-.07.1.1 0 0 0 0-.08.34.34 0 0 0-.09-.14h-.09s-.16.14-.13.17a.3.3 0 0 1 0 .1s.07.08.07.08Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-17",
    transform: "translate(-24.77 -33.09)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path785",
    d: "M44.9 49.74a.3.3 0 0 0 .08.09.17.17 0 0 0 .1 0s.08-.07.08-.09a.15.15 0 0 0 0-.07v-.17c0-.07-.22.1-.21.12a.5.5 0 0 0 0 .12Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-17",
    transform: "translate(-24.77 -33.09)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path787",
    d: "M45.38 49.68a.3.3 0 0 0 0-.16s-.06 0-.06 0v-.05c0-.05-.24 0-.22 0s.06 0 0 0 0 0 0 .06a.3.3 0 0 0 0 .1v.05h.13Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-17",
    transform: "translate(-24.77 -33.09)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path789",
    d: "M44.91 49.82a.13.13 0 0 1 0 .12s-.12 0-.12 0v-.07c0-.07 0-.06.08-.05s.06 0 .06 0Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path791",
    d: "M44.94 49.69a.07.07 0 0 0 0 .07s.09 0 .11 0a.25.25 0 0 0 0-.14.1.1 0 0 0-.07 0 .3.3 0 0 0-.1.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path793",
    d: "M45.19 49.57a.08.08 0 0 0 0 .07.15.15 0 0 0 .08 0s0-.08 0-.1h-.11Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path795",
    d: "M47.37 50.85a.3.3 0 0 0 .08.09.2.2 0 0 0 .08 0 .13.13 0 0 0 .07 0 .6.6 0 0 0 0-.13l-.05-.07h-.18l-.06.06c-.06.06 0 .08 0 .08Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-17",
    transform: "translate(-24.77 -33.09)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path797",
    d: "M47.62 50.77a.4.4 0 0 0 0 .11l.06.06a.2.2 0 0 0 .11 0s0-.06 0-.08-.19-.09-.2-.07-.07 0-.07.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-17",
    transform: "translate(-24.77 -33.09)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path799",
    d: "M47.93 51s.09-.07.09-.1v-.06c0-.06 0 0 0 0s-.14-.14-.15-.12h-.06l-.05.07s.06.08.08.08Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-17",
    transform: "translate(-24.77 -33.09)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path801",
    d: "M47.57 50.83s-.06.06-.08.06-.07-.08-.06-.1a.12.12 0 0 1 .08 0 .2.2 0 0 1 0 .06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path803",
    d: "M47.67 50.77a.07.07 0 0 0 0 .06.2.2 0 0 0 0 .08s.11 0 .11-.07a.1.1 0 0 0 0-.05h-.1Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path805",
    d: "M47.89 50.86a.2.2 0 0 0 0 .08S48 51 48 51a.3.3 0 0 0-.07-.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon819",
    d: "m23.91 12.69-.05-.14-.21-.08-.06-.01.05-.1.16-.06.17-.01h.18l.08.05.09.21-.34.2-.05.02z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path821",
    d: "M49.88 43.58s-.64-.12-.63.42c0 .16 0 .22.17.26a1.3 1.3 0 0 1 .64.26.57.57 0 0 1 .25.48.55.55 0 0 1-.06.23l.14.71.15.52.43-.25.26-.77-.33-1.39-1-.47Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-27",
    transform: "translate(-24.77 -33.09)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path823",
    d: "M49.88 43.58a.5.5 0 0 0-.15 0 .66.66 0 0 0-.32.08.38.38 0 0 0-.18.35.36.36 0 0 0 0 .19.27.27 0 0 0 .15.09l.28.06a1 1 0 0 1 .35.19.8.8 0 0 1 .2.26.43.43 0 0 1 0 .21.4.4 0 0 1 0 .16v.05l.15.71.15.54.46-.26.25-.78-.3-1.43-1-.46 1 .46.32 1.37-.25.76-.41.24-.14-.5-.14-.7a.7.7 0 0 0 0-.24.6.6 0 0 0 0-.22.9.9 0 0 0-.22-.28.84.84 0 0 0-.36-.19 3 3 0 0 0-.28-.07.26.26 0 0 1-.13-.07.4.4 0 0 1 0-.17.35.35 0 0 1 .16-.32.55.55 0 0 1 .3-.07h.15Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path825",
    d: "M50.51 46.26a.53.53 0 0 0 .28-.27c0-.05-.22-.26-.23-.26s.12.06.18.11.11.08.13.07.11-.24.08-.3a1 1 0 0 0-.2-.23.43.43 0 0 0-.21-.06s.17 0 .25 0 .09.1.1.08a1 1 0 0 0 0-.34.21.21 0 0 0-.18-.13 1 1 0 0 0-.21 0 .4.4 0 0 1 .26-.06c.11 0 .1.08.12.07a1 1 0 0 0-.09-.27.5.5 0 0 0-.2-.16.5.5 0 0 0-.15 0h-.06a.3.3 0 0 1 .19 0h.13c.02 0 0 0-.08-.07s-.38-.18-.38-.18h-.3a.09.09 0 0 1 .09-.09h.1a1.4 1.4 0 0 0-.25-.08h-.47a.3.3 0 0 1 .06-.09l.13-.05c.09 0-.06-.1-.06-.1l.08-.12h.36l.75.43.35.31.22.56-.07 1-.5.41h-.22v-.21Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path827",
    d: "M49.86 43.83a.5.5 0 0 1 0-.15v-.09a.6.6 0 0 0-.41.11.34.34 0 0 0-.08.38.5.5 0 0 1 .18-.11.8.8 0 0 1 .27 0s0-.09-.1-.1a1 1 0 0 0-.2 0 .35.35 0 0 1 .2 0h.15Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path829",
    d: "m50.61 46.34-.16.06.09.68.65 1.11.34-.06.11-.21a.16.16 0 0 1 .1 0s.16.26.27.3.16 0 .25.11a4.6 4.6 0 0 1 .46.61s0-.22 0-.22l-.1-.31-.13-.22v-.06h.18l.11.07.17.14.09.1v.35l.09.21.12.19v-.08l-.05-.23-.18-.55-.1-.19a2 2 0 0 0 .17.12s.17.2.17.2l.08.2.06.18V49l.06.17.1-.06v-.12l-.09-.38v-.41a.17.17 0 0 1 .11.06.8.8 0 0 1 .11.21v.38l.06.34.11.34.11.22.08.13v-.19l-.05-1.4v-.06l.06.06a2 2 0 0 1 .1.17v1l.15.35.08.19v-.23l-.07-1.55a.7.7 0 0 1 .11.12.24.24 0 0 0 .08.09v1.6l.29-2.57h.18v-.05l-.13-.1.15-.56-.2-.44-.35-.64-.6-.73-.46-.39-.18-.12v-.09l.1-.16h-.29l-.2-.06-.4-.28-.43-.2-.25-.09-.6-.15-.6-.09h-.51a.4.4 0 0 0-.17.12.4.4 0 0 0 0 .25c0 .11.08.17.25.24a5 5 0 0 1 .56.33l.2.19.07.1v.06l.12 1-.25.55-.18.09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path831",
    d: "M51.26 47.92a.16.16 0 0 0 .26 0c.15-.14-.07-.54-.07-.57s.08 0 .08 0l.11.21a.53.53 0 0 1 0 .29.67.67 0 0 1-.2.33h-.19v-.23Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-27",
    transform: "translate(-24.77 -33.09)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path833",
    d: "m55 50.29-.14-.41v-1.17a1.4 1.4 0 0 0 0-.28l-.15-.2v-.06h.06a1 1 0 0 0-.06-.4 4.4 4.4 0 0 0-.35-.76l.08.08.17.14.37.14h.2l.13.26a5 5 0 0 1 .09.67 1.8 1.8 0 0 1-.11.64 5.6 5.6 0 0 0-.16 1.06.8.8 0 0 1-.06.22Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path835",
    d: "M55 49.1a.7.7 0 0 0 .12-.22 3.5 3.5 0 0 0-.08-1.24 1 1 0 0 0-.37-.22 3 3 0 0 0 .1.33.35.35 0 0 1 .07.13 2 2 0 0 1 .06.16 3.4 3.4 0 0 1 .09.55v.51Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path837",
    d: "M54.49 49.73a6 6 0 0 0 0-.82 1 1 0 0 0-.09-.45 3 3 0 0 1-.23-.58 2.1 2.1 0 0 0-.19-.56c0-.06-.15-.18-.17-.15a.2.2 0 0 0 0 .11h-.14v-.41l.18.15.38.26.19.78.17.48v1.55l-.1-.32Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path839",
    d: "M54.71 47.48a1 1 0 0 0 .16.12c.05 0 .16.1.14.11a.44.44 0 0 1-.19-.07.3.3 0 0 1-.1-.08v-.08Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path841",
    d: "M54 49.54a.9.9 0 0 0 .06-.37 4.5 4.5 0 0 0-.14-.78 1.7 1.7 0 0 1-.32-.45c-.13-.28-.12-.34-.21-.44l-.18-.22v-.31l.32.17.14.07.17.79.15.23.06.31.08.75v.64z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path843",
    d: "M53.6 49.21a1.7 1.7 0 0 0-.05-.45 1.1 1.1 0 0 0-.17-.43 4 4 0 0 1-.38-.46 4 4 0 0 0-.35-.45v-.3a1 1 0 0 0 .18.13l.21.11.09.34.11.25.17.22.1.1.07.36v.21l.09.3v.14l-.08-.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path845",
    d: "m53.33 49.21-.09-.09a.19.19 0 0 0 0-.17 1 1 0 0 0-.11-.34c0-.11-.06-.18-.1-.21s-.31-.3-.4-.38-.25-.23-.34-.29a.4.4 0 0 0-.16-.07v-.37s.12.17.19.19l.2.07.25.45.09.12.24.19.1.19.07.23.09.31v.17Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path847",
    d: "M52.82 49.11a1 1 0 0 1-.17-.29v-.24a1.16 1.16 0 0 0-.33-.42c-.13-.1-.32-.25-.3-.34s0-.09 0-.09l.08.07.41.43.12.23.09.28.07.13.06.17v.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path849",
    d: "M54.29 47s.28.34.35 0a.9.9 0 0 0-.1-.42s-.26-.45-.35-.56l-.52-.67-.32-.15.11.19a4 4 0 0 1 .54.76 1.3 1.3 0 0 1 .24.81Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path851",
    d: "M52.66 44.9a6 6 0 0 1 .92 1c.35.52.5.86.41.93s-.3 0-.39-.19a3.7 3.7 0 0 0-.51-.78 1.5 1.5 0 0 0-.5-.44l-.24-.42.31-.11Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path853",
    d: "M52.37 46s.33.28.54.5a4 4 0 0 1 .31.38l.13.13s-.08-.14 0-.19a.08.08 0 0 1 .1 0l-1.05-1.1V46Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path855",
    d: "M52.3 46.06a1.6 1.6 0 0 0 .29.38l.36.35.08.27s-.48-.37-.48-.28a.7.7 0 0 0 .11.28l-.14-.06-.2-.29-.13-.25-.13-.35h.24Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path857",
    d: "M50.87 47.19s.24.22.38 0a.54.54 0 0 0 0-.47s.35.52.45 0c0-.08-.22-.42-.22-.42l.09-.08.17.3a.3.3 0 0 0 .17-.28 1.14 1.14 0 0 0-.17-.47l.16.18s.33 0 .33-.19-.27-.41-.27-.41.22 0 .22-.11-.3-.22-.31-.3a.15.15 0 0 1 .23-.14c.13.07.32.13.4 0s0-.17 0-.17h-.19l-.31-.19-.25-.09h-.25l.1.19.06.52v.76l-.12.44-.07.08v.06l-.11.23-.15.16L51 47l-.17.19Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path859",
    d: "M52.62 48.17a.66.66 0 0 0-.19-.26.7.7 0 0 0-.35-.12l.37.39Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-27",
    transform: "translate(-24.77 -33.09)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path861",
    d: "M53.13 48.25a1.8 1.8 0 0 0-.25-.38c-.14-.14-.23-.33-.27-.33h-.06v.3l.26.24s.23.18.29.16Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-27",
    transform: "translate(-24.77 -33.09)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path863",
    d: "M53.55 48.24a2 2 0 0 0-.19-.54 1 1 0 0 0-.29-.37v.28l.12.27.18.27.15.09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-27",
    transform: "translate(-24.77 -33.09)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path865",
    d: "M53.9 48.08a1.8 1.8 0 0 0 0-.72.4.4 0 0 0-.26-.18v.48l.14.31.11.11Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-27",
    transform: "translate(-24.77 -33.09)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path867",
    d: "M54.23 47.14a.5.5 0 0 1 .19.23 4.5 4.5 0 0 1 .24.79s0 0-.07 0l-.35-.54-.06-.5Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-27",
    transform: "translate(-24.77 -33.09)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path869",
    d: "M51.86 47.8s.18 0 .18-.1-.22-.19-.2-.3.18 0 .19 0-.18-.34-.12-.41.22.33.22.33.1.18.06.29c-.1.32-.33.21-.33.21Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path871",
    d: "M52.28 47.39h.28l-.24-.27s-.06-.11 0-.13.19 0 .2 0-.19-.28-.19-.33a2 2 0 0 1 .24.29.6.6 0 0 1 .13.45c0 .22-.45.05-.42 0Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path873",
    d: "M53.52 47s-.05-.18 0-.21h.1a.7.7 0 0 0-.22-.09h-.09c-.01 0 .12.21.12.21l.11.13Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path875",
    d: "M52.68 47.12a2 2 0 0 0 .44.07s-.33-.36-.33-.36v-.08c0-.02.15 0 .2 0s0 .11 0 .14.15.23.17.19 0-.28 0-.3.16.15.2.17.28.22.3.13 0-.1 0-.15.08.24 0 .27a.32.32 0 0 1-.24 0l-.09-.07-.08-.13s.06.22 0 .25a.5.5 0 0 1-.16 0h-.18l-.22-.16Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path877",
    d: "M46.88 46.19a3 3 0 0 1-.58 0c-.14 0-.2-.24-.19-.63a.4.4 0 0 1-.1-.28c0-.13.46-.49.52-.51a.23.23 0 0 1 .12 0 .6.6 0 0 1 .14-.1s0 0-.05 0-.12.1-.13.15v.06a.3.3 0 0 1 0 .14v.07a.5.5 0 0 0-.09.15s0 .08 0 .1a.63.63 0 0 0 .33 0 .7.7 0 0 0 .15-.11.5.5 0 0 1-.21.2h-.12a.3.3 0 0 1-.17.06.2.2 0 0 0 0 .14.25.25 0 0 0 .17.07.7.7 0 0 0 .37-.06l-.14.49Zm.12-.49a.58.58 0 0 1-.36 0 .16.16 0 0 1-.15-.06.13.13 0 0 1 0-.11s.1 0 .18-.06l.12-.05a.44.44 0 0 0 .22-.22l-.15.1a.5.5 0 0 1-.31 0s0 0 0-.08a.6.6 0 0 1 .09-.14v-.07a.3.3 0 0 0 0-.15v-.06s.08-.09.13-.13 0 0 0-.05a.07.07 0 0 0 0-.06.09.09 0 0 0-.07-.05s-.13.1-.15.12a.4.4 0 0 0-.14 0c-.06 0-.51.39-.54.53a.46.46 0 0 0 .11.29c0 .15 0 .61.2.65a3 3 0 0 0 .6 0l.14-.48Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7",
    transform: "translate(-24.77 -33.09)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path879",
    d: "M53.65 46.83s.45.27.5.22-.12-.68-.09-.75.36.73.2.83-.2 0-.2 0l-.22-.13-.19-.21Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path881",
    d: "M54.91 48h.14a.4.4 0 0 0-.12 0s0-.09 0-.09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path883",
    d: "M54.47 46.48h.13a.08.08 0 0 1-.06 0v-.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path885",
    d: "M54.34 46.26a.12.12 0 0 0 .11 0c.06-.05.06-.07 0-.1s-.09 0-.12 0a.05.05 0 0 1 0-.06h-.14Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path887",
    d: "M54.74 47.57a.8.8 0 0 0 .18.08s.1.05.09.06a.23.23 0 0 1-.16 0h-.07v-.12Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path889",
    d: "M54 45.51h.06a.13.13 0 0 1 0 .14l-.06.05-.15-.2Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path891",
    d: "M53.35 44.93h.13a.25.25 0 0 1 .14.06.63.63 0 0 1 .06.34c0 .06-.32-.17-.33-.19l-.14-.23h.14Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path893",
    d: "M53.06 44.81s.23 0 .2-.13a.3.3 0 0 0-.12-.2l-.26.19z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path895",
    d: "M52.47 44.55a.2.2 0 0 0 .13 0c.06 0 .24-.26.36-.28s.15 0 .18 0a.25.25 0 0 1 0 .19 3 3 0 0 1-.4.2h-.25v-.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path897",
    d: "M52.4 44.14c0-.13-.15-.18-.19-.17s.13.14.15.32a3 3 0 0 1 0 .31h.07v-.47Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path899",
    d: "M51.88 44a1.4 1.4 0 0 0-.5-.34s.36.23.44.37.09.35.13.37a.06.06 0 0 0 .08 0s0-.05 0-.06v-.1L52 44.1v-.07z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path901",
    d: "M51.38 43.75a1.52 1.52 0 0 0-.92-.28c-.32 0-.48 0-.43.19s.19.25.45.25a1.4 1.4 0 0 1 .48 0 .73.73 0 0 1 .32.18 1 1 0 0 0-.23-.24l-.23-.15s0-.06.16 0a.66.66 0 0 1 .49.29.55.55 0 0 1 .06.27s.06 0 .06 0v-.08a.2.2 0 0 0 0-.13.6.6 0 0 0-.12-.18c-.08-.1-.09-.1-.09-.1Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path903",
    d: "M50.5 46.35a.73.73 0 0 0 .48-.62 3.1 3.1 0 0 0-.23-1.15c0-.08.08 0 .16 0a2.3 2.3 0 0 1 .22 1 .74.74 0 0 1-.28.68.5.5 0 0 1-.36.17v-.08Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path905",
    d: "M51 47.4s.06.09.14.06.35-.16.35-.35-.17-.24-.17-.29a.2.2 0 0 1 0-.09h.14v.21s.06.06.12 0 .23-.15.2-.27-.18-.26-.2-.32a.3.3 0 0 1 0-.12h.14v.17a.11.11 0 0 0 .11 0c.08 0 .22-.16.19-.23s-.14-.23-.14-.24a.3.3 0 0 1 0-.08L52 46a.3.3 0 0 0 .16 0c.1 0 .21-.1.21-.18s-.08-.14-.09-.18a.1.1 0 0 1 0-.06h.07l.08.11v.24l-.13.14h-.12l.08.13v.19l-.11.1-.15.09v.17l-.08.18-.19.12h-.06v.11l-.13.18-.21.14h-.15l-.18-.03z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path907",
    d: "M52.13 45.48s.36.1.35-.12-.35-.42-.37-.47a.3.3 0 0 1 0-.11l.18.16s.22.05.29-.08 0-.21 0-.21h.1v.2l-.11.5s0 .2-.13.22a.7.7 0 0 1-.33-.1Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path909",
    d: "M52.47 48.16a.26.26 0 0 0-.07-.16 1 1 0 0 0-.26-.15l.25.31Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path911",
    d: "M53 48.18a2.5 2.5 0 0 1-.21-.29c0-.08-.14-.24-.21-.25s.07.27.07.27l.29.26Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path913",
    d: "M53.47 48.18s-.16-.29-.19-.38-.12-.31-.21-.37 0 .1 0 .1l.1.3.17.26.12.09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path915",
    d: "M53.83 48v-.42a.6.6 0 0 0-.18-.31v.31l.21.42Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path917",
    d: "M54.56 48.15s-.12-.29-.17-.43a2 2 0 0 0-.19-.38 3 3 0 0 0 0 .27l.15.43.17.11Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path919",
    d: "M55.21 47.38a1.1 1.1 0 0 0-.36-.21 1.7 1.7 0 0 0-.49-.11l.11.1.25.13.34.08h.12Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path921",
    d: "M52.57 47.52a.63.63 0 0 0 .11.35 4 4 0 0 0 .43.41 5 5 0 0 1 .17.54c.07.22.09.4.13.46s.1.16.05.15a.22.22 0 0 1-.13-.15v-.19a2.3 2.3 0 0 0-.25-.74 3.3 3.3 0 0 1-.58-.57c-.14-.21-.11-.25-.11-.25Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path923",
    d: "M53.16 48.93a1.7 1.7 0 0 1-.12-.39 1.3 1.3 0 0 0-.4-.38s-.17 0-.22 0l-.33-.36s-.05 0 0 0 .31.34.42.44a1.8 1.8 0 0 1 .25.52.35.35 0 0 1 .05.23c0 .08.06.14.12.14h.05a.9.9 0 0 1-.2-.31 2.6 2.6 0 0 0-.23-.56h.12c.07 0 .37.27.4.35a.9.9 0 0 0 .12.39 1.4 1.4 0 0 0 .19.34 3 3 0 0 1-.19-.35Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path925",
    d: "M52.68 47.12a2 2 0 0 0 .29.16h.11a1.5 1.5 0 0 0 .19.62 1.2 1.2 0 0 0 .29.31 2.8 2.8 0 0 0 .12.73 1.56 1.56 0 0 1 .12.72c0 .06-.13-.17-.19-.38s-.13-.43-.17-.57a1.1 1.1 0 0 0-.24-.4c-.07-.06 0 0 0 0a1.2 1.2 0 0 1 .23.41c.07.23.1.46.14.46s.07 0 .07-.08-.05-.17-.09-.38a1.2 1.2 0 0 0-.11-.42 3 3 0 0 1-.22-.31 1.6 1.6 0 0 1-.22-.49v-.11a1 1 0 0 1-.15-.06.64.64 0 0 1-.18-.21Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path927",
    d: "M53.25 47a1.2 1.2 0 0 0 .21.13.4.4 0 0 0 .18 0 1.25 1.25 0 0 0 .12.63 2.4 2.4 0 0 0 .3.39 4 4 0 0 1 .07.62l.07.74a7 7 0 0 1 0 .95c-.12-.09 0-.5-.08-.67a2.5 2.5 0 0 1-.26-.67c-.11-.48 0-.58-.12-.76s-.18-.2-.18-.2a.31.31 0 0 1 .21.18c.06.15.07.55.12.75a2.4 2.4 0 0 0 .26.67s0-.56-.07-.88a4 4 0 0 0-.1-.7c-.06-.13-.19-.22-.27-.39s-.1-.48-.14-.56-.06-.05-.11-.08a.32.32 0 0 1-.2-.19Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path929",
    d: "M53.65 46.83a1.4 1.4 0 0 0 .29.23.7.7 0 0 0 .27.09 1.8 1.8 0 0 0 .14.66c.17.31.24.32.24.36s0 1 .06 1.27 0 1.35-.08 1.35 0-.77-.08-.95a2 2 0 0 0-.12-.27c-.06-.15-.06-.72-.16-1s-.15-.29-.15-.29a.4.4 0 0 1 .18.27c.06.21.08.91.14 1a1.4 1.4 0 0 1 .19.35v-1.41a3.7 3.7 0 0 1-.34-.89c0-.29 0-.31-.06-.34a.44.44 0 0 1-.24-.13 2 2 0 0 1-.24-.27Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path931",
    d: "M54.3 47s.09.15.35.25a4 4 0 0 0 .54.11 2.2 2.2 0 0 1 .2.93 3 3 0 0 1-.17.91c-.08.45-.08 1.35-.13 1.49a.6.6 0 0 0-.08.16c0 .08 0 .25-.06.25s-.09-.12-.09-.19a4 4 0 0 0 .08-.56 5 5 0 0 0-.08-.57c0-.3 0-1.23-.08-1.32a1.6 1.6 0 0 0-.19-.29.57.57 0 0 1 .21.24c.05.12.05 1.16.1 1.37s0-.05.05-.17a9 9 0 0 0 .07-.9 2.8 2.8 0 0 0-.22-1 .7.7 0 0 1 .1.19l.1.1h.08H55a2 2 0 0 1 .12.73 10 10 0 0 0 0 1.5 5.3 5.3 0 0 0 .13-1 3 3 0 0 0 .15-.9 1.8 1.8 0 0 0-.21-.84c-.08-.05-.31 0-.51-.16s-.39-.33-.38-.33",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path933",
    d: "M51 47.51a.2.2 0 0 0 .16 0c.09 0 .32-.23.32-.3v-.15h.07a.41.41 0 0 0 .27-.22.8.8 0 0 0 0-.28s.06 0 .09 0 .22-.15.22-.27a.4.4 0 0 0-.1-.23h.14s.23-.12.23-.22-.07-.28-.21-.29a.5.5 0 0 0 .2 0 .19.19 0 0 0 .14-.21c0-.11-.21-.36-.24-.38s.22.07.28 0a.25.25 0 0 0 .06-.23.1.1 0 0 0-.07-.07.38.38 0 0 0 .26 0 1.5 1.5 0 0 1 .34-.17c.07 0-.21.15-.23.24s.08.09.21.19a1.5 1.5 0 0 0 .29.06s-.21 0-.19 0a3 3 0 0 1 .52.49.17.17 0 0 0 .09.05h.12-.15s.21.29.3.42a.14.14 0 0 0 .08.07h.1-.11c.17.28.3.54.3.54a6 6 0 0 0-.62-.87c-.34-.38-.42-.43-.44-.39s.26.37.4.61a4 4 0 0 1 .28.53 4.4 4.4 0 0 0-.82-1.15c-.48-.43-.53-.5-.58-.48s-.1.33-.06.4.38.33.68.68a11 11 0 0 1 .67 1 6.4 6.4 0 0 0-.72-.92c-.46-.49-.63-.6-.67-.59s0 .09-.09.16-.16.06-.17.09a3 3 0 0 0 .47.44h.17a1 1 0 0 1 .13.09l-.12.01h-.12a3 3 0 0 0 .36.42h.16a1 1 0 0 1 .17.1 1 1 0 0 0-.19-.08h-.1c.01 0 .24.33.22.33s-.36-.42-.66-.68-.44-.33-.46-.32 0 .09-.08.12-.14 0-.14.06.27.28.47.49l.35.42-.4-.4c-.22-.2-.33-.28-.35-.27a.2.2 0 0 0 0 .15s.41.49.4.5-.46-.56-.49-.56-.05.07-.08.11-.16 0-.16.07.64.68.63.69a6 6 0 0 0-.55-.43s.22.47.2.48-.3-.46-.33-.46 0 0-.1.12-.18 0-.18.07.44.52.43.53-.45-.47-.46-.44 0 0 0 .07.13.33.12.34-.14-.29-.18-.28 0 .07-.1.12-.12 0-.13.06.08.08.12.15a2 2 0 0 1 .06.22.8.8 0 0 0-.1-.21c-.07-.08-.12-.13-.17-.13a.1.1 0 0 0-.08 0z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path935",
    d: "M55.19 47.36h.16c.02 0-.06 0-.18-.15s-.47-1.1-.83-1.58a5 5 0 0 0-1.15-1.16 4.1 4.1 0 0 1 1.18 1.13c.51.76.64 1.36.79 1.51s.29.19.28.23a.1.1 0 0 1-.09.09h-.19Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path937",
    d: "M50.82 47.15s.2-.18.19-.23a.4.4 0 0 1-.14-.1.4.4 0 0 1-.08-.17.5.5 0 0 0 .11.15.17.17 0 0 0 .16 0s.29-.22.28-.3a.3.3 0 0 1-.16 0 .28.28 0 0 1-.09-.18.35.35 0 0 0 .13.14h.17c.02 0 .2-.27.18-.34a.3.3 0 0 1-.17 0 .45.45 0 0 1-.12-.2.28.28 0 0 0 .16.14.17.17 0 0 0 .2-.11c0-.07.07-.34 0-.41a.33.33 0 0 1-.22 0 .3.3 0 0 1-.13-.16.3.3 0 0 0 .19.12c.1 0 .15 0 .16-.08a.45.45 0 0 0 0-.28c0-.09-.09-.08-.11-.21s0 .05-.16.05a.26.26 0 0 1-.21-.15.34.34 0 0 0 .21.09.15.15 0 0 0 .15-.16.6.6 0 0 0-.08-.2v-.14a.19.19 0 0 1-.19 0 .19.19 0 0 1-.16-.12.4.4 0 0 0 .17.07c.08 0 .13 0 .13-.1s0-.14-.2-.29l-.32-.25a2.4 2.4 0 0 1 .37.24 1.2 1.2 0 0 1 .23.24s.16 0 .18 0a.28.28 0 0 0 0-.22 1.7 1.7 0 0 0-.18-.23 1.2 1.2 0 0 1 .21.24.4.4 0 0 1 0 .24.6.6 0 0 0 .37.1c.07 0 0-.12 0-.21l-.1-.16a.8.8 0 0 1 .12.16c0 .09.09.16.07.2s-.06 0-.06.07a1 1 0 0 0 .21.12c.1.06.22.1.23.07a.4.4 0 0 0 0-.19 1.2 1.2 0 0 0-.07-.25 1 1 0 0 1 .08.25v.21c0 .03.1 0 .1 0a.23.23 0 0 1-.19 0c-.13 0-.7-.32-.73-.3s.27.21.4.33a1.3 1.3 0 0 1 .2.26 1 1 0 0 0-.21-.14 1.7 1.7 0 0 0-.42-.19s.12 0 .13.07-.1.12-.1.16.43.34.42.37-.11.11-.13.1-.23-.16-.23-.14.13.13.12.15-.08.08-.06.13.24.24.24.3-.13.12-.11.16a2 2 0 0 0 .14.18 1 1 0 0 1-.17-.13s-.12-.13-.13-.12a1.2 1.2 0 0 0-.09.23s.11.1.13.21a.34.34 0 0 1 0 .21s-.15-.18-.18-.18h-.09c-.03 0-.1.19-.09.22s.15.06.15.17a.34.34 0 0 1-.1.22s-.17-.22-.19-.22a1.1 1.1 0 0 0-.2.23s.12.12.1.15-.11 0-.16 0a.5.5 0 0 1-.16.06s0-.06 0-.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path939",
    d: "M53.19 44.44a.2.2 0 0 1 0-.09s.14-.15.1-.18-.19 0-.28 0-.15 0-.42-.2a4.5 4.5 0 0 0-2.15-.67c-.41 0-.6.13-.62.21a.65.65 0 0 1 .53-.17 4.6 4.6 0 0 1 2.18.65.73.73 0 0 0 .47.22h.25c-.01 0-.07.11-.08.14a.5.5 0 0 0 0 .11Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path941",
    d: "M50.91 44.62a1 1 0 0 0-.24-.28 3.4 3.4 0 0 0-.73-.39 4.4 4.4 0 0 1 .71.41 2 2 0 0 1 .27.28Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path943",
    d: "M50.91 45.55a1 1 0 0 0-.15-.13.9.9 0 0 0-.23-.1.47.47 0 0 1 .26.07.4.4 0 0 1 .12.16",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path945",
    d: "M50.84 45.06a.44.44 0 0 0-.2-.1c-.16-.05-.19 0-.19 0a.32.32 0 0 1 .26 0 .25.25 0 0 1 .13.15Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path947",
    d: "M50.74 44.66s0-.07-.17-.12a1 1 0 0 0-.24-.06.5.5 0 0 1 .29 0c.14 0 .12.16.12.16Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path949",
    d: "m50.57 44.4-.31-.11a1.7 1.7 0 0 0-.37-.07 2 2 0 0 1 .48 0 .6.6 0 0 1 .2.17Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path951",
    d: "M50.08 44.13a1.6 1.6 0 0 0-.32-.06 4 4 0 0 0-.4 0 4 4 0 0 1 .58 0c.12 0 .14.1.14.1Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path953",
    d: "M48.59 49.76a.32.32 0 0 0 .24.15c.16 0 .28.23.28.23l-.18.18h-.42l-.13-.21.21-.36Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path955",
    d: "m48.59 49.76.06.07a.26.26 0 0 0 .19.08.28.28 0 0 1 .16.09l.06.07-.17.17h-.41l-.13-.2.21-.35-.22.37.15.23h.43l.19-.18A.7.7 0 0 0 49 50a.3.3 0 0 0-.21-.12.3.3 0 0 1-.18-.08Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-11",
    transform: "translate(-24.77 -33.09)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path957",
    d: "M48.6 49.62a.7.7 0 0 0-.23-.35c-.1-.05 0 .09 0 .14a.22.22 0 0 0 0 .14s.08.12 0 .18.2-.11.2-.11Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path959",
    d: "M48.6 49.62a.3.3 0 0 0 0-.07 1 1 0 0 0-.09-.16.34.34 0 0 0-.12-.12h-.05v.05a.5.5 0 0 0 0 .13.3.3 0 0 1 0 .09l.11-.07.07-.05-.09.06h-.07a.3.3 0 0 0 0-.1.1.1 0 0 1 0-.05.4.4 0 0 1 0-.12.1.1 0 0 0 0-.08.46.46 0 0 1 .14.16l.05.11v.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-11",
    transform: "translate(-24.77 -33.09)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M23.88 16.96a.4.4 0 0 0 .12-.08l-.25.06a.2.2 0 0 0 .13.02",
    className: "nn-icon-flags-MX-delivery_svg__cls-10"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path963",
    d: "M48.52 50a.2.2 0 0 0 .1 0 .6.6 0 0 0 .12-.08.23.23 0 0 1-.1.07h-.12Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-11",
    transform: "translate(-24.77 -33.09)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path965",
    d: "M48.44 49.92s.24-.17.22-.26-.07-.09-.1-.08a.7.7 0 0 0-.18.16.8.8 0 0 0 .06.18",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path967",
    d: "m48.44 49.92.11-.09.08-.08a.16.16 0 0 0 0-.09.15.15 0 0 0 0-.08h-.13l-.09.08v.14-.08a.14.14 0 0 1 0-.06l.08-.08h.06a.2.2 0 0 1 0 .06.1.1 0 0 1 0 .07.7.7 0 0 1-.11.12Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-11",
    transform: "translate(-24.77 -33.09)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path969",
    d: "M48.28 50s0 .12.12.12a.26.26 0 0 0 .19-.11s-.08-.13-.13-.15-.17 0-.17 0Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path971",
    d: "M48.28 50v.06a.12.12 0 0 0 .1.06.3.3 0 0 0 .13 0 .14.14 0 0 0-.05-.09.3.3 0 0 0-.09-.08h-.1v.11-.11a.2.2 0 0 1 .12 0 .16.16 0 0 1 .08.06s0 .06 0 .08a.3.3 0 0 1-.16.07s-.06 0-.08-.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-11",
    transform: "translate(-24.77 -33.09)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path973",
    d: "M48.49 49.89a.5.5 0 0 1-.21.11c-.05 0-.15-.13-.11-.14h.13s.05-.07.07-.07a.12.12 0 0 1 .1 0s0 .05 0 .09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path975",
    d: "m48.49 49.89-.09.05h-.08a.1.1 0 0 1 0-.05s.09 0 .13 0h.05-.08l-.05.06h-.13v.11a.1.1 0 0 0 .06 0 .3.3 0 0 0 .13 0h.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-11",
    transform: "translate(-24.77 -33.09)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path977",
    d: "M48.34 50s-.23.31-.33.3 0-.45 0-.45h.11c.08 0 .16 0 .18.1Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path979",
    d: "M48.34 50v.05a1 1 0 0 1-.14.15.5.5 0 0 1-.07.07h-.06A.9.9 0 0 1 48 50v-.1h.23a.1.1 0 0 1 .06.05.11.11 0 0 0-.07-.06h-.2a1.8 1.8 0 0 0-.08.37s0 0 0 .06a.2.2 0 0 0 .1 0 1.7 1.7 0 0 0 .23-.26Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-11",
    transform: "translate(-24.77 -33.09)"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path981",
    d: "M47.92 49.76s.3.06.32.1-.15.14-.24.14-.09-.22-.09-.22Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path983",
    d: "M47.92 49.76h.23A.47.47 0 0 1 48 50a.2.2 0 0 1 0-.11v-.07a1 1 0 0 0 0 .11V50a.5.5 0 0 0 .15 0h.06v-.05h-.3Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-11",
    transform: "translate(-24.77 -33.09)"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path985",
    d: "M47.18 50.22a.21.21 0 0 0 .17.15c.13 0 .25-.14.25-.14l-.31-.12z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path987",
    d: "M47.18 50.22a.2.2 0 0 0 0 .07.2.2 0 0 0 .14.09.4.4 0 0 0 .25-.14l-.32-.12-.12.1.11-.1.31.12a.36.36 0 0 1-.22.11.2.2 0 0 1-.13-.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-31",
    transform: "translate(-24.77 -33.09)"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path989",
    d: "M47.27 50.18a.23.23 0 0 0 .22.11.46.46 0 0 0 .3-.14l-.27-.21z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path991",
    d: "M47.27 50.18a.26.26 0 0 0 .23.12.46.46 0 0 0 .3-.14l-.28-.22-.26.24.25-.23.27.21a.43.43 0 0 1-.29.13.28.28 0 0 1-.17-.05Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-31",
    transform: "translate(-24.77 -33.09)"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path993",
    d: "M47.29 50.2a.33.33 0 0 0 .16.07h.2-.35Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-31",
    transform: "translate(-24.77 -33.09)"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path995",
    d: "M47.49 50.05s.07.19.23.17.16-.11.16-.11l-.18-.26z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path997",
    d: "m47.49 50.05.05.08a.24.24 0 0 0 .17.09c.08 0 .12 0 .14-.06l-.19-.26-.22.21.21-.2.18.25s0 .08-.15.1a.23.23 0 0 1-.16-.08v-.05Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-31",
    transform: "translate(-24.77 -33.09)"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path999",
    d: "M47.51 50.09s.09.11.18.11a.3.3 0 0 0 .13 0h-.21Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-31",
    transform: "translate(-24.77 -33.09)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1001",
    d: "M47.21 50.27a.24.24 0 0 0 .14.08.5.5 0 0 0 .17-.05h-.22Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-31",
    transform: "translate(-24.77 -33.09)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1003",
    d: "M47.91 49.75c.07 0 .22.19.22.29s-.05.25-.12.25a.7.7 0 0 1-.28-.23c0-.08-.07-.13 0-.17a1 1 0 0 1 .18-.14",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1005",
    d: "M47.91 49.75h.06a.6.6 0 0 1 .1.12.5.5 0 0 1 0 .13.4.4 0 0 1 0 .15.2.2 0 0 1 0 .06h-.06a.8.8 0 0 1-.21-.2.4.4 0 0 1-.05-.13l.11-.07h.06-.1l-.08.05a.4.4 0 0 0 .06.14.6.6 0 0 0 .13.15l.08.06h.14a.4.4 0 0 0 .07-.23.33.33 0 0 0-.09-.19.3.3 0 0 0-.07-.08h-.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-11",
    transform: "translate(-24.77 -33.09)"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1007",
    d: "M47.17 49.76s-.12-.09-.16 0A.23.23 0 0 0 47 50s.17-.08.17-.08v-.12Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1009",
    d: "M47.17 49.76a.14.14 0 0 0-.09 0 .17.17 0 0 0 0 .12v.08A.16.16 0 0 0 47 50l.12-.06v-.13.12h-.06L47 50a.2.2 0 0 1 0-.08.3.3 0 0 1 0-.1.1.1 0 0 1 .08 0Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-11",
    transform: "translate(-24.77 -33.09)"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1011",
    d: "M47.16 49.88s-.16 0-.16.09a.27.27 0 0 0 .09.16s.16-.06.16-.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1013",
    d: "M47.16 49.88h-.15A.08.08 0 0 0 47 50a.25.25 0 0 0 0 .11v.06h.06l.11-.05-.1-.21.09.19h-.06l-.05-.06A.2.2 0 0 1 47 50a.2.2 0 0 1 .08 0Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-11",
    transform: "translate(-24.77 -33.09)"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1015",
    d: "M47.22 50s-.16.05-.16.1.07.16.12.16.09-.1.11-.12-.07-.14-.07-.14",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1017",
    d: "M47.22 50h-.14a.16.16 0 0 0 .05.11v.05l.05-.06v-.05l-.06-.1v.06a.2.2 0 0 1 0 .06l-.06-.07a.2.2 0 0 1 0-.07h.08Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-11",
    transform: "translate(-24.77 -33.09)"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1019",
    d: "M47.3 49.54h-.1a.18.18 0 0 0-.13.2.5.5 0 0 0 0 .18l.24-.08-.06-.29Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1021",
    d: "M47.3 49.54a.08.08 0 0 0-.07 0h-.05l-.09.07a.18.18 0 0 0 0 .13.5.5 0 0 0 0 .18l.27-.09-.07-.29.06.28-.23.08a.4.4 0 0 1-.05-.17.14.14 0 0 1 0-.11.16.16 0 0 1 .08-.06h.1Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-11",
    transform: "translate(-24.77 -33.09)"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1023",
    d: "M47.32 49.73s-.21.07-.22.15a.16.16 0 0 0 .1.17c.06 0 .23-.15.23-.15z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1025",
    d: "M47.32 49.73h-.1l-.08.05a.1.1 0 0 0 0 .07.2.2 0 0 0 0 .11s.05.06.08.06h.07l.16-.13-.13-.19.12.16-.1.09h-.07a.17.17 0 0 1 0-.1v-.05a.3.3 0 0 1 .12-.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-11",
    transform: "translate(-24.77 -33.09)"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1027",
    d: "M47.5 50.06a2 2 0 0 1-.23.14.19.19 0 0 1-.09-.18c0-.07.15-.13.21-.15s.11.19.11.19",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1029",
    d: "m47.5 50.06-.1.07-.08.05h-.05a.3.3 0 0 1-.05-.13.15.15 0 0 1 .08-.08l.12-.06s0 .06.05.1a1 1 0 0 0 0-.1.3.3 0 0 0 0-.07l-.12.06a.16.16 0 0 0-.09.09.2.2 0 0 0 0 .11l.13-.07.08-.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-11",
    transform: "translate(-24.77 -33.09)"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1031",
    d: "M47.68 49.32a.27.27 0 0 0-.19 0c-.13 0-.22.17-.23.25s0 .24 0 .26.31-.18.31-.18l.07-.28Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1033",
    d: "M47.68 49.32a.3.3 0 0 0-.17-.05.27.27 0 0 0-.17.1.35.35 0 0 0-.07.16.2.2 0 0 0 0 .08.5.5 0 0 0 0 .12v.07h.08l.22-.16.07-.3-.08.29-.13.1h-.07v-.06a.4.4 0 0 1 0-.11v-.07a.4.4 0 0 1 .07-.15.25.25 0 0 1 .15-.1.16.16 0 0 1 .11 0Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-11",
    transform: "translate(-24.77 -33.09)"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1035",
    d: "M47.43 49.93a.19.19 0 0 1-.15-.2.31.31 0 0 1 .27-.19c.09 0 .07.23.07.23s-.11.17-.19.16",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1037",
    d: "M47.43 49.93a.15.15 0 0 1-.1-.06.2.2 0 0 1 0-.11.1.1 0 0 1 0-.06.4.4 0 0 1 .1-.08.2.2 0 0 1 .12 0 .4.4 0 0 1 0 .16.3.3 0 0 1-.07.08.14.14 0 0 1-.09.05.23.23 0 0 0 .14-.08l.06-.08a.5.5 0 0 0 0-.12.14.14 0 0 0 0-.06h-.05a.28.28 0 0 0-.17.07l-.07.07a.1.1 0 0 0 0 .06.2.2 0 0 0 .05.13.15.15 0 0 0 .11.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-11",
    transform: "translate(-24.77 -33.09)"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1039",
    d: "M47.7 49.91a.33.33 0 0 1-.13.15c-.09 0-.14 0-.19-.07s0-.1.06-.14a.7.7 0 0 1 .16-.06z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1041",
    d: "M47.7 49.91a.3.3 0 0 1-.13.14h-.07a.07.07 0 0 1-.06 0s0 0 0-.05h.19l.1.12-.11-.13h-.16a.1.1 0 0 0 0 .06l.06.06a.1.1 0 0 0 .07 0h.07a.32.32 0 0 0 .14-.15Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-11",
    transform: "translate(-24.77 -33.09)"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1043",
    d: "M47.56 49.65s-.1.08 0 .17a.21.21 0 0 0 .17.13c.07 0 .11 0 .17-.08s.13-.1.13-.18a.2.2 0 0 0-.09-.17.4.4 0 0 0-.34.13Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1045",
    d: "M47.56 49.65a.18.18 0 0 0-.06.12.14.14 0 0 0 0 .06.3.3 0 0 0 .08.1.13.13 0 0 0 .1 0c.06 0 .1 0 .15-.09l.17-.04a.14.14 0 0 0 0-.1.22.22 0 0 0-.1-.18.5.5 0 0 0-.3.14.43.43 0 0 1 .28-.13.18.18 0 0 1 .08.16.09.09 0 0 1 0 .08l-.08.08c-.05.06-.08.08-.13.08a.2.2 0 0 1-.08 0 .24.24 0 0 1-.08-.09s0 0 0-.05a.15.15 0 0 1 0-.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-11",
    transform: "translate(-24.77 -33.09)"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1047",
    d: "M47.84 49.26a.28.28 0 0 0-.18 0 .27.27 0 0 0-.13.22 1 1 0 0 0 0 .2.6.6 0 0 0 .17-.08c.07-.06.1-.08.09-.11a.11.11 0 0 1 0-.1c0-.13.08-.14.08-.14Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1049",
    d: "M47.84 49.26a.24.24 0 0 0-.3.19v.09a.3.3 0 0 1 0-.12.21.21 0 0 1 .14-.16.4.4 0 0 1 .16 0",
    className: "nn-icon-flags-MX-delivery_svg__cls-31",
    transform: "translate(-24.77 -33.09)"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon1051",
    d: "m26.78 17.31-.03-.5-1.35.42.54.5z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1053",
    d: "m49 49.53-.11-.09-.13-.07h-.1l.13.15.2.1.08.07-.1-.25Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon1055",
    d: "m24.12 16.67.08-.01.04-.01.08.01.08.09.04.09.07.13.02.07-.15-.03-.44-.14.04-.1.07-.07z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon1057",
    d: "m24.65 16.27-.35-.42-.08.25.11.42.08.26.12.23h.07l.05-.05-.02-.16z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1059",
    d: "M49 49.15v.18a2.2 2.2 0 0 0 .21.65c.12.21-.12-.16-.12-.16a1.9 1.9 0 0 1-.16-.75c0-.32.07.08.07.08",
    className: "nn-icon-flags-MX-delivery_svg__cls-27",
    transform: "translate(-24.77 -33.09)"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1061",
    d: "M49.29 49.41a.5.5 0 0 0-.08.17 1.4 1.4 0 0 0 0 .21s0-.1.07-.12.07.21.07.24v-.43l-.11-.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-27",
    transform: "translate(-24.77 -33.09)"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1063",
    d: "M49.34 50.29a1.2 1.2 0 0 1-.41-.09c-.2-.09-.31-.16-.31-.21S49 50 49 50a1.4 1.4 0 0 1 .22.09h.09l.17-.07v.18l-.21.08Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-27",
    transform: "translate(-24.77 -33.09)"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1065",
    d: "M48.67 50.21s.1.08 0 .11a.5.5 0 0 1-.21 0l.38.09.08-.07-.3-.15Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-27",
    transform: "translate(-24.77 -33.09)"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1067",
    d: "M48.56 50.11s0 .06.17.07a.33.33 0 0 0 .2 0h.13l-.07.11-.25-.08-.13-.07v-.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon1069",
    d: "m24.81 16.48-.15-.09.03.44.08.11.04-.23z",
    className: "nn-icon-flags-MX-delivery_svg__cls-27"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1071",
    d: "m49.06 49.55-.12-.19-.15-.29.09-.16.12.17a.6.6 0 0 0 0 .22 2 2 0 0 0 .07.25Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1073",
    d: "M48.25 50.27a.22.22 0 0 1 .17-.09.7.7 0 0 1 .22 0l.24.12v.08l-.46-.06-.22-.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1075",
    d: "M49.45 49.46v.36c0 .09.06.17.05.21s0 0-.08.07a.5.5 0 0 1-.18 0s.12 0 .12 0v-.42a.1.1 0 0 0-.07 0 1.2 1.2 0 0 1 .07-.38s.14.15.14.15Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1077",
    d: "M48.61 50.18v-.07a.37.37 0 0 0 .31.13h.36v.12l-.2.13h-.06v-.2l-.22-.08h-.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-27",
    transform: "translate(-24.77 -33.09)"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1079",
    d: "M49.06 49.55a3 3 0 0 1-.39-.5.85.85 0 0 1 0-.48l.28.36a.35.35 0 0 0 0 .19 3 3 0 0 0 .18.43Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1081",
    d: "M48.87 50.66a.16.16 0 0 1 0-.16 1.6 1.6 0 0 1 .61-.37v.26l-.56.27Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-27",
    transform: "translate(-24.77 -33.09)"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1083",
    d: "M48.91 50.46s.12-.09.12-.13-.06 0-.19-.06a.9.9 0 0 1-.23-.09 1.2 1.2 0 0 0 .21.15c.07 0 .06.05 0 .06s0 .07 0 .07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1085",
    d: "M49.66 50.52a1 1 0 0 1-.1-.2v-.19a.3.3 0 0 1-.09 0l-.17.07s.18 0 .18.06-.27.09-.27.1.21 0 .2 0-.11.06-.23.11l-.21.09h-.06a.24.24 0 0 0 .14 0 1.5 1.5 0 0 0 .26 0l.35-.13Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1087",
    d: "M49.66 50.52s-.09 0-.16-.44a2 2 0 0 1 0-.52l.16.12.15.27-.1.57Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-27",
    transform: "translate(-24.77 -33.09)"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1089",
    d: "M49.71 49.84a1.7 1.7 0 0 0-.07.36 1 1 0 0 0 0 .32.9.9 0 0 0 .17.21l.06-.06v-.49l-.22-.34Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1091",
    d: "M50 50.15s0 .58-.11.59-.18-.21-.18-.22.13.21.18.19.06-.6.06-.6H50Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1093",
    d: "m49.66 50.52-.06-.08c-.06-.08 0 .06-.31.17s-.42 0-.42 0 .1.08.41 0a1.2 1.2 0 0 0 .32-.12Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1095",
    d: "M49.09 49.79a.5.5 0 0 1 .11.15l.09.19a2 2 0 0 0-.09-.2l-.2-.28.07.15Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-27",
    transform: "translate(-24.77 -33.09)"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1097",
    d: "M48.91 50.5v-.13c0-.02-.06 0-.27 0a4 4 0 0 1-.39-.08 1.2 1.2 0 0 0 .28.13l.31.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1099",
    d: "M48.91 50.5s-.07 0-.32-.06a1.2 1.2 0 0 1-.32-.12.8.8 0 0 0 .31.14l.35.09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1101",
    d: "M49 49.75a.6.6 0 0 0-.25 0 1 1 0 0 0-.15.19h.13v-.17a.38.38 0 0 1 .23-.08Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-27",
    transform: "translate(-24.77 -33.09)"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1103",
    d: "M48.66 49.38a.6.6 0 0 0 .16.14.5.5 0 0 1 .19.1.6.6 0 0 1 .08.17 1.6 1.6 0 0 1-.32-.18.7.7 0 0 1-.11-.23",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1105",
    d: "M48.93 49.44a.3.3 0 0 0-.1-.07.2.2 0 0 0-.16 0l.1.15h.06s-.15-.1-.12-.13.23 0 .23 0Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon1107",
    d: "m24.79 16.39.11-.39 1.54-.79.73 1.01-1.33.36-.7.06z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1109",
    d: "m50.8 51.45.14-.07.19-.11v.21l-.13.12h-.14l-.09-.06v-.09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1111",
    d: "m50.8 51.45.14-.07.18-.11v.2l-.15.12h-.13l-.07-.06v-.08.09l.08.06H51l.16-.12v-.2h-.07l-.11.07-.09.05h-.05Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-11",
    transform: "translate(-24.77 -33.09)"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1113",
    d: "M50.58 51.47h.22c.01 0 .05.11.05.11v.06l-.14.09-.12-.07v-.16Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1115",
    d: "M50.58 51.47h.19a.2.2 0 0 0 0 .05v.07l-.13.07-.1-.06v-.14.18l.12.06.14-.07v-.12h-.25Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-11",
    transform: "translate(-24.77 -33.09)"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1117",
    d: "m51.69 51.4-.09-.09-.19-.17v.45h.2l.1-.14Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1119",
    d: "M51.69 51.4a.4.4 0 0 0-.09-.1s-.07-.07-.12-.1l-.07-.07v.45h.23l.1-.14-.09.13h-.19v-.43l.2.17.06.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-11",
    transform: "translate(-24.77 -33.09)"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1121",
    d: "M50.58 51.47a.12.12 0 0 0-.12 0 .23.23 0 0 0-.19.15v.26a.22.22 0 0 0 .2 0 5 5 0 0 0 .58-.32h-.12a.24.24 0 0 1-.13 0 .3.3 0 0 1-.14.09.11.11 0 0 1-.12-.07.6.6 0 0 1 0-.11Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1123",
    d: "M50.58 51.47a.13.13 0 0 0-.1 0 .4.4 0 0 0-.13.06.15.15 0 0 0-.07.09v.06a.6.6 0 0 0 0 .13v.09a.2.2 0 0 0 .13 0h.08l.14-.06c.17-.09.44-.26.44-.26h-.26s-.08.07-.13.08 0 0 0-.06v.12a.1.1 0 0 0 .07 0 .3.3 0 0 0 .15-.09.24.24 0 0 0 .1 0h.12-.07l-.28.17-.14.07h-.16a.14.14 0 0 1-.11 0s0 0 0-.08v-.12a.07.07 0 0 1 0-.05.09.09 0 0 1 .06-.08.16.16 0 0 1 .11 0 .08.08 0 0 1 .06 0Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-11",
    transform: "translate(-24.77 -33.09)"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1125",
    d: "M50.11 52s-.08-.13 0-.17.14 0 .19 0 0-.13 0-.16a1 1 0 0 0-.07-.11s-.31 0-.31.22a.22.22 0 0 0 .15.22Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1127",
    d: "m50.9 51.62-.1.05a.5.5 0 0 1-.12 0v.15l.2.05.13-.1v-.15Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1129",
    d: "M50.9 51.62h-.13v.14l.2.06.13-.1v-.15h-.15.14v.13l-.12.1h-.19v-.14h.18Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-11",
    transform: "translate(-24.77 -33.09)"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1131",
    d: "m51.86 51.52-.07-.07a.17.17 0 0 0-.1-.05 1 1 0 0 0-.11.14v.09l.11.06h.08l.11-.07v-.12Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1133",
    d: "m51.86 51.52-.05-.05a.15.15 0 0 0-.1 0l-.1.13v.09l.12.06h.08l.1-.07v-.12.11l-.1.07h-.07l-.11-.06v-.14a.1.1 0 0 1 .08.05l.07.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-11",
    transform: "translate(-24.77 -33.09)"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1135",
    d: "M51.15 51.45a.6.6 0 0 0-.13.08l-.12.09.11.13h.1l.23-.16v-.15Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1137",
    d: "M51.15 51.45a1 1 0 0 0-.14.08l-.07.06.08.09h.12l.23-.16v-.15.13l-.22.16H51v-.06l.09-.07h.09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-11",
    transform: "translate(-24.77 -33.09)"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1139",
    d: "M52 51.64a.2.2 0 0 0-.06-.07.2.2 0 0 0-.1 0s-.12.14-.12.14l.08.1h.15l.1-.1v-.08Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1141",
    d: "M52 51.64v-.08a.16.16 0 0 0-.11-.05.3.3 0 0 0-.07.08l.08.1h.15l.1-.1v-.09.08l-.08.09h-.14l-.07-.09v-.11a.16.16 0 0 1 .1 0Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-11",
    transform: "translate(-24.77 -33.09)"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M26.06 19.1a.15.15 0 0 0 .09-.18s0 0 .07 0a2 2 0 0 1 .23-.15h.53a.37.37 0 0 0 .13.19s.13 0 .19 0h.06l.18-.22v-.05s0-.14-.09-.17a.35.35 0 0 0-.21 0s-.09.16-.15.14h-.06l-.07-.08a.1.1 0 0 1-.08 0 .4.4 0 0 1-.08-.1.3.3 0 0 1-.09 0 .2.2 0 0 1-.05-.07l-.17.12s0 .05-.11.13a.3.3 0 0 1-.15.07s0 .15-.14.12a.35.35 0 0 1-.19-.15.15.15 0 0 0-.13.06c0 .07-.07.09-.07.16a.33.33 0 0 0 .08.2.23.23 0 0 0 .28-.02",
    className: "nn-icon-flags-MX-delivery_svg__cls-10"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1145",
    d: "M51.64 51.81h.1v.06a.3.3 0 0 0 .13.19h.2l.18-.23a.1.1 0 0 0 0-.08.09.09 0 0 0-.08-.06h-.09a.3.3 0 0 0-.13 0l-.05.07h-.06v-.06h-.05l-.06-.06h-.06l-.17.12s0 .05-.1.12l-.12.06v.07a.1.1 0 0 1-.08 0 .3.3 0 0 1-.13-.08.17.17 0 0 0-.13.06v.08a.15.15 0 0 0 0 .09.5.5 0 0 0 0 .12l.06.09a.3.3 0 0 0 .18.08.23.23 0 0 0 .11 0 .17.17 0 0 0 .1-.15L51 52c.08 0 .17-.13.22-.15A2 2 0 0 0 51 52h-.06a.17.17 0 0 1-.09.13.2.2 0 0 1-.1 0 .3.3 0 0 1-.17-.07 1 1 0 0 1 0-.08.3.3 0 0 1 0-.11.14.14 0 0 1 0-.07.4.4 0 0 1 .05-.08.13.13 0 0 1 .11 0l.06.07a.27.27 0 0 0 .14.08.11.11 0 0 0 .1-.07v-.07a.3.3 0 0 0 .16-.07c.1-.08.11-.13.11-.14l.17-.12a.2.2 0 0 0 0 .08h.06a.25.25 0 0 0 .08.11.12.12 0 0 0 .07 0l.07.09a.13.13 0 0 0 .07 0 .4.4 0 0 0 .1-.13h.21a.1.1 0 0 1 .06 0 .14.14 0 0 1 0 .07l-.18.23h-.25a.25.25 0 0 1-.1-.12h-.12Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-11",
    transform: "translate(-24.77 -33.09)"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1147",
    d: "M51.44 50.89v.63a.23.23 0 0 1-.29 0 1 1 0 0 1 0-.3l.32-.33Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1149",
    d: "M51.44 50.89v.29a.5.5 0 0 1 0 .12.3.3 0 0 1 0 .16s-.07.05-.13.05h-.09v-.17a1 1 0 0 1 0-.12l.33-.33-.33.34v.3a.1.1 0 0 0 .06 0h.1a.2.2 0 0 0 .15-.06.3.3 0 0 0 0-.18 2 2 0 0 0 0-.17v-.32Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-11",
    transform: "translate(-24.77 -33.09)"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1151",
    d: "M50.57 52.48s-.1-.13 0-.21.09 0 .12 0 0-.06 0-.15-.09-.13-.12-.13a.27.27 0 0 0-.18.29.32.32 0 0 0 .24.24Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1153",
    d: "M52.22 52.32s.32.13.34-.19a.29.29 0 0 0-.19-.29s-.06 0-.12.09-.1.12-.07.14.11 0 .16.08-.12.17-.12.17",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M26.64 18.66v.01zM26.64 18.68s0 .1.11.1a.12.12 0 0 0 .12-.13h-.23ZM26.53 18.77h.08a.1.1 0 0 0 0-.06h-.2s-.01.05.12.06",
    className: "nn-icon-flags-MX-delivery_svg__cls-10"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1157",
    d: "M51.2 51.77a.2.2 0 0 0 0 .05h.17a.1.1 0 0 0 0-.07.1.1 0 0 0 0 .07s0 .05.1.05a.1.1 0 0 0 .1-.05.13.13 0 0 0 0-.08.08.08 0 0 1 0 .06s0 0-.08 0h-.08a.07.07 0 0 1 0-.06.06.06 0 0 1-.06 0h-.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-11",
    transform: "translate(-24.77 -33.09)"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1159",
    d: "M50.57 52.48a.31.31 0 0 1-.25-.3c0-.16.18-.23.18-.23a.34.34 0 0 0-.17.23.31.31 0 0 0 .24.3",
    className: "nn-icon-flags-MX-delivery_svg__cls-31",
    transform: "translate(-24.77 -33.09)"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1161",
    d: "M50.11 52s-.11 0-.11-.23.33-.2.33-.2-.33 0-.31.22.09.21.09.21",
    className: "nn-icon-flags-MX-delivery_svg__cls-31",
    transform: "translate(-24.77 -33.09)"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1163",
    d: "M52.22 52.32a.4.4 0 0 0 .14 0 .19.19 0 0 0 .19-.15.27.27 0 0 0-.06-.28c-.06-.08-.11-.08-.11-.08a.2.2 0 0 1 .1.08.31.31 0 0 1 .06.28.21.21 0 0 1-.22.14h-.1Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-31",
    transform: "translate(-24.77 -33.09)"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon1165",
    d: "m26.94 16.85.02-.41 1.92 1.66-.21.15-.45-.13-.93-.92z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1167",
    d: "m54.19 50.86-1.1-.86-1.38-1v.5l1.59 1.45.52.25.26-.08.14-.14-.06-.11Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1169",
    d: "M51.72 49.69a9.4 9.4 0 0 0 1 .94c.42.32.82.67.9.62s.06-.1.06-.1l-1.95-1.59v.13Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon1171",
    d: "m26.94 16.85 1.38 1.34-.2.15-.22-.09-1.18-1.2.06-.23z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1173",
    d: "M54.19 50.86s-.15.35-.46.27a17 17 0 0 1-2-1.69v.17a14.4 14.4 0 0 0 2.05 1.63c.33.06.6-.22.56-.26z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1175",
    d: "M51.54 49.94a10 10 0 0 0 .83 1c.29.26.54.46.66.44s-.07-.16-.07-.16l-.83-.81-.42-.43s-.17-.07-.17 0Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1177",
    d: "M51.67 49.94s1.39 1.42 1.5 1.45.56-.17.56-.17l-.12-.07s-.06.14-.36.08a9 9 0 0 1-1.52-1.38Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon1179",
    d: "m26.92 17.62-.11-.19-.03-.25 1.01 1.02-.14.09-.13-.04-.09-.05z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1181",
    d: "M53.11 51.32s-.12.18-.29.14a.5.5 0 0 1-.26-.16l-1-.94v-.15a10.4 10.4 0 0 0 1.25 1.17c.14 0 .24-.13.24-.13v.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1183",
    d: "M52.57 51.29a.19.19 0 0 1-.19.12.32.32 0 0 1-.18-.08l-.6-.71v-.18a6 6 0 0 0 .76.9.14.14 0 0 0 .18-.1Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1185",
    d: "M51.94 49.44s.57.49.62.52.25 0 .26 0h-.14c-.01 0 .29.28.33.29s.29 0 .29 0h-.17a.9.9 0 0 0 .3.25s.36 0 .36 0-.25 0-.24.05.42.31.4.34-.5-.32-.51-.3 0 .13-.06.15 0-.15 0-.22-.3-.29-.33-.26 0 .15 0 .15v-.21a1.2 1.2 0 0 0-.33-.27s0 .11 0 .13 0-.13-.06-.18-.63-.59-.61-.63Z",
    style: {
      fill: "#b07229"
    },
    transform: "translate(-24.77 -33.09)"
  }), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1187",
    d: "M51 51s0 .22-.1.25-.28-.4-.28-.4v-.4l.28.27z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1189",
    d: "M51.72 50.92a.4.4 0 0 0 0-.12v-.35l-.06-.15v-.09h-.06l-.15.11v.14l.08.27.07.25h.11l.14-.1Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1191",
    d: "M51.53 51.3v-.31l-.18-.44v-.15l-.14-.06-.1.11v.17a4 4 0 0 0 .21.4c.07.1.21.3.27.28Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1193",
    d: "M51.37 50.37a.4.4 0 0 1 .12.23 1.6 1.6 0 0 1 .1.36s-.08 0-.08 0 .15.17.2.15 0-.18 0-.22-.06 0-.08-.05a1.5 1.5 0 0 1-.09-.38 1.3 1.3 0 0 1 0-.24s.14.26.14.42v.06-.29c0-.07-.07-.18-.07-.2a1 1 0 0 0 0-.14.3.3 0 0 0 0-.09h.09s.06 0 .07-.18a4 4 0 0 0 0-.54l-.62.81.19.23Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1195",
    d: "M51.37 50.3a1 1 0 0 0 .05.44 1.2 1.2 0 0 0 .12.26.6.6 0 0 1 0 .3s-.16-.4-.21-.6-.07-.27-.1-.29a.14.14 0 0 0-.07 0l.22-.09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1197",
    d: "M51.31 51.46v-.3l-.21-.45-.24-.21-.13-.19v.36a2.2 2.2 0 0 0 .28.47 3 3 0 0 0 .33.32Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1199",
    d: "M50.43 50.46a.7.7 0 0 1 0 .16v.13l.17.31c.08.14.15.28.22.25a.19.19 0 0 0 .09-.14s-.07.11-.11.09a3 3 0 0 1-.21-.6l-.09-.08-.1-.12Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1201",
    d: "M51.07 51s-.12-.2-.16-.29a.32.32 0 0 0-.13-.16s0-.18 0-.18a.4.4 0 0 0 .14.16c.09 0 .14.08.18.06a1 1 0 0 1 0 .18V51Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1203",
    d: "M50.68 50.66a1 1 0 0 0 .12.25 3 3 0 0 0 .21.26 3 3 0 0 1-.22-.25 1.4 1.4 0 0 1-.13-.26Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-33",
    transform: "translate(-24.77 -33.09)"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1205",
    d: "M51.1 50.51s0-.1.07-.11h.1a.2.2 0 0 1-.11-.07 1 1 0 0 1-.11-.12s0 .12 0 .18a1 1 0 0 1 0 .15Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1207",
    d: "M51.06 50.55s.17.37.22.5a1.3 1.3 0 0 1 0 .31 2 2 0 0 0-.07-.24c0-.11-.19-.41-.21-.45a.3.3 0 0 1 0-.12Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1209",
    d: "M51.3 50.3v-.74l-.25-.56s0 .08-.08.07a.6.6 0 0 1-.28-.16 1 1 0 0 1 0 .25 1 1 0 0 1 0 .19l.48.9h.14Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1211",
    d: "M50.34 50.67s.08.09.12.08 0-.19 0-.29a8 8 0 0 0-.72-.92 10 10 0 0 0 .63 1.13Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1213",
    d: "M50.74 50.34s.06.29 0 .31-.78-.85-.88-1-.41-.25-.41-.32.43.09.43.09l.86.82a.3.3 0 0 1 0 .07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1215",
    d: "M50.74 50.34a.4.4 0 0 1 0 .15c0 .07 0 .14-.06.15a.4.4 0 0 1-.19-.13c-.24-.25-.61-.75-.68-.84h-.07l-.21-.15c-.07-.05-.13-.11-.13-.13a1 1 0 0 1 .24 0l.16.05.86.82v.05a.3.3 0 0 0 0-.07l-.86-.82a2 2 0 0 0-.4-.11.2.2 0 0 0 .07.08c.12.1.34.24.34.24l.42.53a3 3 0 0 0 .27.31c.08.08.15.14.19.14s.06-.09.06-.16a.5.5 0 0 0 0-.16Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-33",
    transform: "translate(-24.77 -33.09)"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1217",
    d: "M50.34 50.67a.6.6 0 0 1-.07-.22v-.17c0-.03-.48-.7-.52-.75l-.21-.13a1 1 0 0 1 0 .16v.06a3.5 3.5 0 0 0 .36.53l.46.52Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1219",
    d: "M51.06 50.55c.06 0 0-.25 0-.32s-.41-.86-.41-.86h-.11l-.22-.17-.12-.13a2 2 0 0 1 0 .28 1 1 0 0 1 0 .15l.3.53.52.48Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1221",
    d: "m51.49 50.07.09-.12v-.4l-.25-.86a.17.17 0 0 1-.13 0 1 1 0 0 1-.13-.12l.07.52.26.72V50l.13.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1223",
    d: "M50.7 50.27a5 5 0 0 1-.34-.41l-.15-.27a.2.2 0 0 1-.16 0 1 1 0 0 1-.21-.16s-.07.14.3.51.56.34.56.34Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1225",
    d: "M51.31 50.36c.11 0 .11-.49 0-.79a3 3 0 0 0-.26-.56s.2.48.25.68 0 .34 0 .33 0-.12-.11-.31a1 1 0 0 0-.14-.24s.29.8.21.78a5.6 5.6 0 0 1-.51-.92s.36 1.11.63 1Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1227",
    d: "m51.55 48.2.18.38.05.41v.34s0 .67-.07.68a.11.11 0 0 1-.13-.08l-.15-.75-.16-.77.06-.06v-.11h.18Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1229",
    d: "M51.06 50.55c.07 0 0-.19 0-.19s-.06.08-.11 0a1.2 1.2 0 0 1-.12-.28v-.13s-.05.15-.12.15a3.5 3.5 0 0 1-.41-.59v.06s.49 1 .85 1Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1231",
    d: "M50.83 50.1a.6.6 0 0 0 0-.27 3 3 0 0 0-.21-.46.2.2 0 0 1-.12 0 1.2 1.2 0 0 1-.21-.11 5 5 0 0 0 .2.43c.11.17.3.43.3.43Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1233",
    d: "M51.11 49.9a2.2 2.2 0 0 0-.18-.6 1.7 1.7 0 0 0-.24-.38 1 1 0 0 1 0 .18v.14a.52.52 0 0 1 .23.22 5 5 0 0 1 .18.44Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1235",
    d: "M51.5 49.37a3.6 3.6 0 0 0-.07-.53c-.06-.19-.11-.45-.11-.45h.06c.07 0 .1.2.1.2v-.29h-.13a.17.17 0 0 1 0 .12s0 0-.07 0a.7.7 0 0 1 0 .18.4.4 0 0 1 0 .15 2.3 2.3 0 0 0 .11.33 2.4 2.4 0 0 1 .12.36Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1237",
    d: "M51.8 49.33a2.1 2.1 0 0 0 0-.79 1.2 1.2 0 0 0-.2-.4v.07a1.9 1.9 0 0 1 .21.5c0 .26.09.62.09.62Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1239",
    d: "M51.31 49.57a5 5 0 0 0-.12-.62 2.3 2.3 0 0 1-.08-.33l-.11-.1a3 3 0 0 1 .06.34L51 49a1.6 1.6 0 0 0 .12.24 2 2 0 0 1 .15.35Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1241",
    d: "M51.57 50.17c.09 0 0-.55 0-.68s-.27-.8-.27-.8.27.93.25 1-.14-.28-.15-.28.2.63.12.64-.12-.13-.12-.13V50a.21.21 0 0 0 .19.14Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1243",
    d: "M51.68 49.89c.07 0 0-.51-.06-.74l-.18-.68a4.4 4.4 0 0 1 .21.68c.07.36.12.83.05.84a.12.12 0 0 1-.1-.07v-.09a.11.11 0 0 0 .09.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1245",
    d: "M50.8 50.5s0 .21-.09.2a.54.54 0 0 1-.3-.28s.2.23.27.23.07-.23.06-.29.06.14.06.14",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1247",
    d: "M51.29 48a.23.23 0 0 0 .22 0 .37.37 0 0 0 .16-.27.4.4 0 0 0-.07-.22c-.06-.07.1.07.09.22s0 .39-.22.44-.13 0-.13 0z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1249",
    d: "M51.1 47.6a2.1 2.1 0 0 1 .21.45v.31c0 .01 0 0-.06-.08s-.16-.68-.16-.68Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon1251",
    d: "m23.79 14.8.96 1.4 1.21-1.36-.77-.79z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon1253",
    d: "m25.5 14.9.05-.18.06-.2.06-.02.15.06.1-.15.15-.28-.03-.11-.04-.07-.24-.43-.08.16-.08.05-.14-.08-.17.22-.21-.1-.08.17-.05.22.12.37.2.21z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1255",
    d: "M50.27 48a.23.23 0 0 0 .06-.14 3 3 0 0 0 0-.58 1.2 1.2 0 0 0-.14-.39 2.2 2.2 0 0 1 .12.63c0 .33 0 .43-.09.46s.06 0 .06 0Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1257",
    d: "M50.32 47.43s.16.23.24.15 0-.37 0-.49a3 3 0 0 1-.1-.28v-.05s0 .2.09.32.11.47 0 .53-.26-.13-.26-.13Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1259",
    d: "M49.81 47.59a.2.2 0 0 1 .12-.09h.09l.07.18.11.2.09.09-.06.06h-.07l-.24-.13-.06-.08v-.27Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1261",
    d: "M50.19 49.57c-.08 0-.25 0-.35-.13s-.61-.61-.61-.61l-.07-.29.2.05.35-.15.06-.12.42-.22.23-.13h.51l.12-.24a2.6 2.6 0 0 1 .2.41 1.1 1.1 0 0 1 0 .52s-.21-.11-.23-.12.12.52 0 .54-.33-.2-.33-.2.08.48 0 .48a1 1 0 0 1-.46-.23s.12.39 0 .45Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1263",
    d: "m50.09 49 .1.16a.6.6 0 0 1 0 .3c0 .08-.14-.1-.21-.27 0 0-.18-.31-.19-.35s.32.16.32.16Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1265",
    d: "M51.08 47.78s.18.74.09.77-.33-.23-.36-.27l-.37-.59-.07-.07.14.06.55.14Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1267",
    d: "M49.81 49.21s-.12-.1-.15-.13-.16-.18-.28-.3a.8.8 0 0 1-.2-.24s-.07-.09-.07-.09l.06-.08h.08a6 6 0 0 1 .52.45 1 1 0 0 1 0 .41Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1269",
    d: "M50.54 49.21a1.4 1.4 0 0 1-.48-.41 3 3 0 0 1-.31-.45 1 1 0 0 1-.06-.17h.1a11 11 0 0 1 .75 1Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1271",
    d: "M50.66 48.87s-.16-.08-.25-.2a.32.32 0 0 1 0-.25 3.5 3.5 0 0 1 .29.45Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1273",
    d: "M50.84 48.83s-.23-.21-.38-.46-.15-.22-.17-.23a.3.3 0 0 0-.12 0h.08l.06-.07.1-.13.39.78s.09.17.06.19Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1275",
    d: "M49.84 49.44s0 .06-.1.05a2 2 0 0 1-.9-.71c-.25-.4-.28-.46-.28-.46l.11-.12.87 1 .3.25Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-27",
    transform: "translate(-24.77 -33.09)"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1277",
    d: "M49.84 49.44c0 .05 0 .06-.1 0a1.43 1.43 0 0 1-.62-.48 2.9 2.9 0 0 1-.49-.67v-.16l.1-.05.6.92.52.4Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1279",
    d: "M50.42 49.05a1.7 1.7 0 0 1-.29-.27 2 2 0 0 1-.34-.52c0-.06.1-.06.1-.06v-.25l.17.07.21.26.08.11s.14.33.11.36-.22-.19-.24-.16.22.4.18.43Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1281",
    d: "M50.09 49s.06.09 0 .15 0 .1-.14 0-.2-.28-.21-.26 0 .2 0 .2-.18-.17-.27-.3l-.23-.35a.45.45 0 0 0 0-.19v-.23a1 1 0 0 1 0 .08v.06l.33.38.09-.06.19.37.18.19Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1283",
    d: "M48.85 48.4a5 5 0 0 0 .49.69 1.6 1.6 0 0 0 .5.35l-.76-.9z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1285",
    d: "M50.78 48.66a1.2 1.2 0 0 1-.26-.31.94.94 0 0 1-.17-.45v-.32a2 2 0 0 1 .31.4c.05.12.16.29.13.32s-.19-.12-.22-.09.21.43.18.45Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1287",
    d: "M51.08 48.38s-.16-.14-.2-.24a1 1 0 0 1-.05-.28l-.11-.27v-.31h.11l.18.24a.74.74 0 0 1 .06.34 3 3 0 0 1 0 .53Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1289",
    d: "M49 49.12a3.5 3.5 0 0 1-.38-.56l-.07-.26a1.56 1.56 0 0 0 .43.65 2.2 2.2 0 0 0 .44.38s.07.2 0 .27a4.6 4.6 0 0 1-.49-.52Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1291",
    d: "M49.42 49.53a5 5 0 0 1-.55-.58 3.5 3.5 0 0 1-.4-.6l.1-.1a5 5 0 0 0 .35.66z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1293",
    d: "m49.84 49.44-.54-.55a2 2 0 0 1-.28-.41l.15.06a1.3 1.3 0 0 0 .19.32z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1295",
    d: "M49.77 48.8a4 4 0 0 1-.28-.38 3 3 0 0 1-.19-.34s.26.3.34.32.07 0 .07 0a.4.4 0 0 0 0 .2c0 .09.06.21.06.21Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1297",
    d: "M49.85 47.84a1 1 0 0 1 0 .27c0 .09-.07.09-.07.09a1 1 0 0 0 .37.37s-.12-.16-.17-.25a.4.4 0 0 1-.09-.26c0-.08.19.06.24.1s.23.26.23.26a1 1 0 0 0-.16-.32c-.09-.08-.36-.26-.36-.26Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1299",
    d: "m50.64 48.34-.16-.34a4 4 0 0 1-.14-.47s0 .15 0 .26a.46.46 0 0 1-.09.3h-.15.19c.03 0 0-.14.09-.13s.09.16.12.22l.15.21Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1301",
    d: "M50.33 47.48s.19.21.27.12 0-.36 0-.36h.15c.04 0 0-.13 0-.13a4 4 0 0 1 .3.48 2 2 0 0 1 .15.53 3.4 3.4 0 0 1-.2-.52c-.08-.23-.19-.34-.21-.32a.55.55 0 0 0 0 .28c0 .08.1.19.14.31a3 3 0 0 1 .1.31l-.18-.18a.7.7 0 0 0-.15-.15 1 1 0 0 0-.15-.13c-.06 0-.17-.08-.17 0v-.17Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1303",
    d: "M49.71 48.38a3 3 0 0 0 .18.32l.2.26a2 2 0 0 1-.25-.27 1.4 1.4 0 0 1-.13-.31",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1305",
    d: "M50.93 48.44h-.13a.5.5 0 0 0 .12.22c.06.06.09.06.1 0s0-.06 0-.13a1 1 0 0 1 0-.15s-.07 0-.07 0Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1307",
    d: "m48.72 47.12-.11.07-.13.26v.48l.19.28c.07.11.32.38.38.37s.13-.21.14-.31 0-.3 0-.3a1.5 1.5 0 0 0 .17.22c.1.11.19.21.23.2s.19-.29.2-.32-.36-.92-.36-.92l-.16-.08h-.6Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1309",
    d: "M49.52 47.85s.06.22.1.33 0 .21 0 .21a.74.74 0 0 0 .21-.36 2.4 2.4 0 0 0 0-.58c-.05-.35 0-.45 0-.45l-.11-.08-.18.37v.56Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-27",
    transform: "translate(-24.77 -33.09)"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1311",
    d: "M48.89 47.65s0 .34.07.45.09.3.12.3a.9.9 0 0 0 .15-.4 1.3 1.3 0 0 1-.07-.51v-.4l-.23.56Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-27",
    transform: "translate(-24.77 -33.09)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1313",
    d: "M48.41 47a1.55 1.55 0 0 0-.28.64c0 .22 0 .17.11.38a3.3 3.3 0 0 1 .1.53s0-1.51 0-1.51Z",
    style: {
      fill: "#45392d"
    },
    transform: "translate(-24.77 -33.09)"
  }), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1315",
    d: "M48.4 47a1.5 1.5 0 0 0-.23.59 1 1 0 0 0 .13.4 1.8 1.8 0 0 1 .07.5.5.5 0 0 0 .17-.09.7.7 0 0 0 .17-.19l-.09-.21a.5.5 0 0 1-.06-.17l-.07-.11v-.37l.06-.26V47Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-27",
    transform: "translate(-24.77 -33.09)"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1317",
    d: "M49.75 47.66a1 1 0 0 1-.18-.06.2.2 0 0 1-.07-.1v-.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-35",
    transform: "translate(-24.77 -33.09)"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1319",
    d: "M48.46 47a1.7 1.7 0 0 0-.16.65 1.8 1.8 0 0 0 .18.61s0 0 0-.08v-.8l.09-.26V47Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-29",
    transform: "translate(-24.77 -33.09)"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1321",
    d: "M48.89 47.13a.6.6 0 0 1 0 .16c0 .05-.11.11-.15.18s-.1.26-.1.26a2 2 0 0 1 .1-.17c.06-.06.09-.11.1-.07a1 1 0 0 1 0 .22.5.5 0 0 0-.09.18.4.4 0 0 0 0 .21 2 2 0 0 1 0-.19.2.2 0 0 1 .07-.09L49 48a2 2 0 0 1 0-.18c0-.07.1-.18.13-.18s.07 0 0-.06a.8.8 0 0 1 0-.41s.17 0 .15-.07a.9.9 0 0 0-.14-.2s-.23.2-.23.2Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1323",
    d: "M49.73 47.91h-.14l-.05-.06.11.06.07.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-35",
    transform: "translate(-24.77 -33.09)"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1325",
    d: "M48.58 48a.5.5 0 0 1 0 .14 1 1 0 0 0 0 .15v-.31a.8.8 0 0 0 0-.21s-.06.06-.06.06a.7.7 0 0 1 0-.21c0-.06.05-.16 0-.18s-.07 0-.09.07a.6.6 0 0 0-.07.11.7.7 0 0 1 .06-.16 3 3 0 0 0 .18-.27.3.3 0 0 0 0-.12h.09s.1.08.1.15-.09.07-.09.08-.08 0-.1.3.06.29 0 .41Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1327",
    d: "M49.43 47.16a1.3 1.3 0 0 1 0 .22 1 1 0 0 1-.11.16.8.8 0 0 0 0 .23.6.6 0 0 1 .05-.13s0-.09.06-.09a.27.27 0 0 1 .07.15l.07.23v-.11h.08l.09.07a.3.3 0 0 0-.06-.1c-.06-.06-.09-.06-.11-.14a.5.5 0 0 1 0-.19s.05 0 .08.06l.14.13a1 1 0 0 1-.06-.1 2 2 0 0 1 0-.27v-.19a.26.26 0 0 0 0-.17 2 2 0 0 0-.33.22Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1329",
    d: "M50.42 46.82a2 2 0 0 0 0 .3c0 .11.09.35.09.35a3 3 0 0 1-.14-.33c0-.16-.08-.32-.12-.34s-.08.08-.08.14a1.2 1.2 0 0 0 .09.39 1.2 1.2 0 0 1-.12-.21l-.06-.2a.35.35 0 0 0 0 .19.8.8 0 0 0 .09.23l-.08-.08-.09-.07a.7.7 0 0 0 0 .2l.11.15-.12-.1v-.06a1.4 1.4 0 0 0 .06.29c0 .1.13.27.13.27a.9.9 0 0 1-.18-.25 2.4 2.4 0 0 1-.09-.75l.11-.17a2 2 0 0 0 .11-.42 1.5 1.5 0 0 0 .14.38.3.3 0 0 0 .11.09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1331",
    d: "M49.64 46.72a1 1 0 0 0 .07.13.5.5 0 0 1 0 .09 2 2 0 0 1-.21.18c-.1.09-.25.18-.28.13a.2.2 0 0 1 0-.09 1.2 1.2 0 0 0 .21-.16.6.6 0 0 0 .15-.2 1 1 0 0 1 0-.08Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1333",
    d: "M48.64 47s0 .21.11.21.34-.27.36-.28a.2.2 0 0 0 0-.09 1 1 0 0 0 0-.07s-.28.28-.38.29a.14.14 0 0 1-.11-.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1335",
    d: "M48.65 46.78a.7.7 0 0 0 0 .18.2.2 0 0 0 0 .07s-.19.07-.23 0a.23.23 0 0 1 0-.14.5.5 0 0 0 .14 0c.05 0 .11-.1.11-.1Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1337",
    d: "M50.5 46.49a1.7 1.7 0 0 0 .14.29l.13.26a3 3 0 0 0-.18-.19l-.1-.09a.3.3 0 0 0 0-.1v-.17Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1339",
    d: "M48.37 46.9h.12a.1.1 0 0 0 .07 0l.08-.11a.5.5 0 0 0 0 .23c0 .09.08.11.1.11a.4.4 0 0 0 .2-.11 2 2 0 0 1 .2-.17.5.5 0 0 0 0 .24c0 .12.11.12.21 0a1.7 1.7 0 0 0 .23-.26l.07-.09.1-.08.09-.5-.05-.06-.13.06-.15-.06v-.06l-.08.15-.1.06h-.11l-.05-.09v-.08l-.22.22h-.12l-.13.19-.09.13-.09.22Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-35",
    transform: "translate(-24.77 -33.09)"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1341",
    d: "M49.44 46.4a.8.8 0 0 1 0 .33 1.7 1.7 0 0 1-.15.35.9.9 0 0 0 .33-.38 1.3 1.3 0 0 0 .08-.52l-.22.22Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1343",
    d: "M49.71 46.17v.22c0 .22-.06.37-.06.37l.05.1c0 .06.11.17.16.15a.37.37 0 0 0 .19-.2 1.4 1.4 0 0 1 .13-.26s0 .11.08.16.12.11.15.09.07-.08.06-.11l-.12-.37-.1-.32-.09-.14h-.26z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1345",
    d: "M50.16 45.84a1 1 0 0 1 .08.32 2 2 0 0 1 0 .35 2 2 0 0 0 0-.34 1.3 1.3 0 0 1-.06-.24.3.3 0 0 1-.02-.09",
    className: "nn-icon-flags-MX-delivery_svg__cls-27",
    transform: "translate(-24.77 -33.09)"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1347",
    d: "M50.51 46.49a2 2 0 0 1 0 .22c0 .07-.12-.05-.18-.27a3 3 0 0 0-.1-.4l-.07-.2h.13l.22.67Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1349",
    d: "M49.88 46.92a.69.69 0 0 0 .27-.56 1.5 1.5 0 0 0-.11-.52 1.8 1.8 0 0 1-.09.56c-.09.22-.17.37-.17.37a.4.4 0 0 0 .09-.06l.07-.1a.23.23 0 0 1 0 .14 1.4 1.4 0 0 1 0 .17Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1351",
    d: "M49.66 46.18a.32.32 0 0 1-.11.18 2 2 0 0 1-.29.17 1.1 1.1 0 0 0 .19-.23.23.23 0 0 0 0-.19.3.3 0 0 1-.08.11.4.4 0 0 1-.14.05.17.17 0 0 1 .06-.11s0 0 0-.07a1 1 0 0 1 .11-.21.8.8 0 0 0 .12.19l.12.11Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1353",
    d: "M50.43 45.68a1.4 1.4 0 0 1 .08.36 2 2 0 0 1 0 .45 2 2 0 0 1-.16-.27c0-.08 0-.2-.06-.26s-.06-.07-.09-.1h-.09a.12.12 0 0 0 .07-.1.3.3 0 0 0 0-.1.4.4 0 0 0 .13 0 .23.23 0 0 0 .12 0Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1355",
    d: "M49.88 46.57a1.2 1.2 0 0 0 .17-.42.6.6 0 0 0 0-.31.3.3 0 0 1-.1-.05l-.11-.16a.8.8 0 0 1 0 .26.7.7 0 0 1-.16.29.2.2 0 0 0 .13 0 .26.26 0 0 0 .13-.23s0 0 0 .2a2 2 0 0 1-.06.43Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1357",
    d: "M48.29 46.89s.09-.18.17-.31l.19-.3a.06.06 0 0 0 .06 0 .3.3 0 0 0 .22-.15 2 2 0 0 0 .1-.22.5.5 0 0 0 .08.27c.09.1.09.09.13.08a2 2 0 0 1 0 .26 3 3 0 0 0-.07.3.9.9 0 0 0 0-.3c0-.07-.06 0-.09.09a.3.3 0 0 1-.1.14 2 2 0 0 0 .09-.21v-.11h-.06a.17.17 0 0 1-.08.06.24.24 0 0 0 .07-.1.4.4 0 0 1 .08-.16.15.15 0 0 0 .05-.08s0-.07 0-.07l-.13.11c-.13.11-.1.08-.11.11a1 1 0 0 0-.08.24.9.9 0 0 1-.1.25s0-.09.08-.21a1.7 1.7 0 0 0 .09-.32s-.06 0-.07 0-.1.13-.18.26a1.3 1.3 0 0 0-.11.29Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1359",
    d: "M50.52 45.55s0 .1-.09.13a.36.36 0 0 1-.22 0 .6.6 0 0 1 0-.13Z",
    style: {
      fill: "#874f20"
    },
    transform: "translate(-24.77 -33.09)"
  }), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1361",
    d: "M48.72 45.84a.6.6 0 0 1-.06.19c-.06.11-.14.2-.13.21a.2.2 0 0 0 .13.06c.08 0 .1-.44.1-.44Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1363",
    d: "M49.86 45.6s0 .58-.2.58-.24-.3-.24-.3 0 .4-.22.4-.2-.28-.2-.36a.6.6 0 0 1-.14.29c-.2.15-.32.08-.33 0a1.1 1.1 0 0 0 .19-.42s0 0 .08-.05.07-.15.12-.13a1.1 1.1 0 0 0 .28-.1l.13-.16s0 .05.1 0a.32.32 0 0 0 .12-.15l.25.2v.16Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-35",
    transform: "translate(-24.77 -33.09)"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1365",
    d: "m49.22 45 .24.35h.06v.11c0 .03-.12.21-.06.34a.25.25 0 0 1 0-.16c0-.1.06-.13.08-.13s.06.54.09.53.09-.24.09-.4.16.27.28.23.11-.25.1-.3-.08-.34-.08-.34l-.56-.35v.14c0 .1-.3 0-.3 0Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1367",
    d: "M50 45a.5.5 0 0 1 .08.17c.06.14.06.58 0 .58a.37.37 0 0 1-.24-.14v-.35a.7.7 0 0 1-.14-.26s0-.18 0-.18h.12z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1369",
    d: "m50 44.85.23.35.21.3h.11a.25.25 0 0 1-.29 0c-.08 0 0-.19-.14-.41a.8.8 0 0 0-.29-.33l.06-.06.11.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1371",
    d: "M49.84 44.66a.9.9 0 0 1 .28.29c.08.15.12.24.21.39a.8.8 0 0 0 .19.21.11.11 0 0 1-.11 0 .4.4 0 0 1-.13-.15c0-.06-.17-.31-.22-.38a1 1 0 0 0-.21-.17s0 0 .14.2a.5.5 0 0 1 .1.28 1 1 0 0 0-.1-.19c-.08-.13-.25-.3-.26-.28a1 1 0 0 0 .13.27 1.5 1.5 0 0 1 .12.3s-.07-.12-.16-.26a.6.6 0 0 0-.15-.18l-.13-.16a.22.22 0 0 0 .17 0 .6.6 0 0 0 .13-.14Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1373",
    d: "M49.3 45.05a.8.8 0 0 0 .21 0h.1a.26.26 0 0 1 0 .13c0 .07 0 .2-.07.2s0-.11 0-.15a2 2 0 0 0-.24-.18",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1375",
    d: "M49.37 45.4a.8.8 0 0 1 0 .36.8.8 0 0 1-.18.42s0-.24 0-.36v.14-.23a1 1 0 0 1 0-.08l.15-.18h.08Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1377",
    d: "M49.11 45.56h-.16c-.06 0-.08.1-.08.1h.07c.02 0 0 0 0 .11s-.2.27-.19.28a1.6 1.6 0 0 0 .23-.23.4.4 0 0 0 .07-.17s.08-.06.09-.07 0 0 .06.07 0 .23 0 .23a.7.7 0 0 0 .07-.23 2 2 0 0 0 0-.26h-.05a.8.8 0 0 1-.14-.08.4.4 0 0 1 0 .24Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1379",
    d: "M49.84 44.51a.21.21 0 0 1-.06.24.16.16 0 0 1-.13 0 .4.4 0 0 1-.15 0l-.36-.15-.14-.05h-.09v-.1h.27l.28.11h.36a.1.1 0 0 0 .02-.05",
    className: "nn-icon-flags-MX-delivery_svg__cls-35",
    transform: "translate(-24.77 -33.09)"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1381",
    d: "M49.84 44.51a.13.13 0 0 1-.05.12.28.28 0 0 1-.18 0c-.1 0-.21-.1-.33-.13a1.3 1.3 0 0 0-.3-.06c-.09 0 0 0 0 0a1 1 0 0 1 .4.05 1.1 1.1 0 0 0 .35.11c.14 0 .16-.06.16-.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-27",
    transform: "translate(-24.77 -33.09)"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1383",
    d: "M48.88 44.4H49a.1.1 0 0 0 .06 0s0 0 0 .06a.2.2 0 0 1-.11 0s0-.05 0-.05Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1385",
    d: "M49.57 44.84s.12.12.09.22l-.24-.1-.42-.17-.21-.06a.4.4 0 0 0 .06-.08.1.1 0 0 0 0-.07h.26l.26.08.18.17Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-35",
    transform: "translate(-24.77 -33.09)"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1387",
    d: "M49.3 45s.23.29.17.38l-.47-.31-.18.3-.43-.21s.34-.27.38-.32l.05-.06h.19l.3.1v.1Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-35",
    transform: "translate(-24.77 -33.09)"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1389",
    d: "M49.19 44.59a1.4 1.4 0 0 1 .29.1 1 1 0 0 0 .28.08.3.3 0 0 1-.19.07.5.5 0 0 1-.19-.12 1.3 1.3 0 0 0-.23-.09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-27",
    transform: "translate(-24.77 -33.09)"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1391",
    d: "m48.87 44.49.21.06h.1s0 .08-.05.08a.5.5 0 0 1-.17-.05.12.12 0 0 0-.13 0v-.09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1393",
    d: "M49.59 45s.09.06.07.07a.2.2 0 0 1-.14 0 .26.26 0 0 1-.18 0c-.06 0-.09-.12-.23-.18a1.4 1.4 0 0 0-.26-.08h-.11.08l.3.06.26.07.15.08h.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-27",
    transform: "translate(-24.77 -33.09)"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1395",
    d: "M49.09 45.17v.37l-.09.06h-.07a.1.1 0 0 0 0-.1c0-.05-.19-.11-.19-.11a.4.4 0 0 1 .13-.14c.07 0 0-.11 0-.11l.17.11Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-27",
    transform: "translate(-24.77 -33.09)"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1397",
    d: "M48.79 44.69a.3.3 0 0 0 .15.05 1.4 1.4 0 0 1 .2 0h.09l.23.08a1 1 0 0 1 .18.12s-.06 0-.18-.08a2 2 0 0 0-.28-.08 3 3 0 0 0-.39 0 .2.2 0 0 0 0-.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1399",
    d: "M49.46 45.33v.09a.33.33 0 0 1-.29-.07.3.3 0 0 0 0-.11 1 1 0 0 0-.22-.15c-.07-.05 0-.05 0-.05s.24.09.33.14a2 2 0 0 1 .21.15Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-27",
    transform: "translate(-24.77 -33.09)"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1401",
    d: "M49.46 45.34A1.14 1.14 0 0 0 49 45h.1a1 1 0 0 0-.17 0h-.08c-.17-.05-.19-.05-.2-.07l-.06.08a.6.6 0 0 1 .22 0c.1 0 .1.06.09.1s-.13.18-.11.19.08-.14.17-.12a.2.2 0 0 1 .12.07.12.12 0 0 0 0-.07s-.12-.12-.09-.12a1 1 0 0 1 .3.11.7.7 0 0 1 .23.15Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1403",
    d: "M48.92 45.08a.34.34 0 0 1 .24.34c0 .27-.21.22-.23.12s0 .05.1 0 .09-.09.09-.2a.3.3 0 0 0-.09-.21l-.11-.09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-35",
    transform: "translate(-24.77 -33.09)"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1405",
    d: "M47.82 44.43v.21a.9.9 0 0 1-.22.38c-.2.23-.29.23-.27.32a.09.09 0 0 0 .12.08s.39-.54.39-.54l.08-.33v-.09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1407",
    d: "M48.74 44a.77.77 0 0 1 .07.46c0 .3-.43.57-.43.57l-.58.4h-.32s-.07-.05-.08-.05 0-.1 0-.1l.08-.09.21-.21.13-.19a.7.7 0 0 0 .07-.22.3.3 0 0 0 0-.16v.41l.15-.1.2-.09s.05 0 .09-.12a2 2 0 0 0 .08-.35V44a.35.35 0 0 1 .07.15s0 .25 0 .25l.1-.09.08-.13a.6.6 0 0 0 .05-.17Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-35",
    transform: "translate(-24.77 -33.09)"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1411",
    d: "M48.8 45.55v.14a.24.24 0 0 1-.15.18v-.16l-.13-.1h-.13l.16-.07.2.08Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1413",
    d: "M48.7 45.55a.12.12 0 0 0 .1 0 .12.12 0 0 0 .06-.16s0 .09-.06.11-.09-.1-.14-.12a.19.19 0 0 0-.17.07s.09 0 .09 0h.11Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-27",
    transform: "translate(-24.77 -33.09)"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1415",
    d: "M47.86 45.13a.4.4 0 0 0 .16 0l.28-.1a.8.8 0 0 0 .16-.12.7.7 0 0 0 .31-.47 1.2 1.2 0 0 0 0-.42.62.62 0 0 1 0 .75 1 1 0 0 1-.34.33s.3-.09.33 0a.3.3 0 0 1 0 .2s.17 0 .2.13-.2-.06-.36 0a.43.43 0 0 0-.23.13s0 0-.18 0-.2.06-.28.06a.73.73 0 0 1-.39-.13l.17-.2c.07-.14.18-.11.18-.11Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1417",
    d: "M48.52 44.42a1.5 1.5 0 0 0 .17-.22.7.7 0 0 0 .05-.16.36.36 0 0 1-.06.21 1.2 1.2 0 0 1-.16.18Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-27",
    transform: "translate(-24.77 -33.09)"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1419",
    d: "M48.49 44.14s.1.4 0 .56a2 2 0 0 1-.58.37 1.26 1.26 0 0 0 .47-.42.9.9 0 0 0 .1-.4v-.11Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1421",
    d: "M48 45.15a.6.6 0 0 0 .23-.06 1.4 1.4 0 0 0 .21-.16s-.11.1-.14.1-.06-.05 0-.09a.25.25 0 0 1-.09.13.7.7 0 0 1-.21.08",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1423",
    d: "M48.37 44.65a.55.55 0 0 0 .12-.4c0-.28-.1-.23-.1-.23s.08.06.07.27a1.2 1.2 0 0 1-.09.36",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1425",
    d: "M48.52 44.68a.33.33 0 0 0 .2-.12.6.6 0 0 0 .05-.24.7.7 0 0 1-.06.2 2 2 0 0 1-.19.16",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1427",
    d: "M48.44 45.54s.07-.13.17-.1a.13.13 0 0 1 .09.11.14.14 0 0 0-.11-.06.34.34 0 0 0-.15 0Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1429",
    d: "m48.17 45.3.33-.09.27-.1a.8.8 0 0 1-.26.21.7.7 0 0 1-.28.1 1.6 1.6 0 0 0 .32-.18 2 2 0 0 1-.38.06",
    className: "nn-icon-flags-MX-delivery_svg__cls-30",
    transform: "translate(-24.77 -33.09)"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M23.08 12.22a.24.24 0 0 0 0-.34l-.28.4a.24.24 0 0 0 .28-.06",
    className: "nn-icon-flags-MX-delivery_svg__cls-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.83 45.3a.21.21 0 0 0 0-.3l-.25.34a.21.21 0 0 0 .25-.04",
    style: {
      fill: "#f16e16"
    },
    transform: "translate(-24.77 -33.09)"
  }), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M22.94 12.19a.08.08 0 0 0 0-.16l-.08.12a.05.05 0 0 0 .08.04"
  })), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1435",
    d: "M47.74 45.22",
    style: {
      fill: "#d5d3ca"
    },
    transform: "translate(-24.77 -33.09)"
  }), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1437",
    d: "M47.89 44.82a.67.67 0 0 0 .17-.32.9.9 0 0 0 0-.28l.08.08v.36a.2.2 0 0 0 .15-.07 1.2 1.2 0 0 0 .11-.57s0 .08 0 .35a.44.44 0 0 1-.29.4.82.82 0 0 0-.35.38 1.7 1.7 0 0 1-.21.28s.1-.14.15-.25a1 1 0 0 1 .15-.25l.07-.11Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-27",
    transform: "translate(-24.77 -33.09)"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1439",
    d: "M47.82 44.93a1.2 1.2 0 0 0 .06-.28.6.6 0 0 0-.06-.22s.09 0 .1.21 0 .23-.1.29",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1441",
    d: "M48.1 44.7a.9.9 0 0 0 .07-.27.43.43 0 0 0-.1-.21s.11 0 .12.21-.02.2-.09.27",
    className: "nn-icon-flags-MX-delivery_svg__cls-28",
    transform: "translate(-24.77 -33.09)"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1443",
    d: "M47.46 45.44a.3.3 0 0 1-.05-.12s0-.06.13-.19a1.2 1.2 0 0 0 .23-.29.5.5 0 0 0 0-.41.5.5 0 0 1-.07.39 1.8 1.8 0 0 1-.3.34c-.1.08-.11.11-.11.15v.1a.3.3 0 0 0 .09 0Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-27",
    transform: "translate(-24.77 -33.09)"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1445",
    d: "M48.68 45.87a.13.13 0 0 0 0-.14.4.4 0 0 0-.16-.11h-.18a.4.4 0 0 0 .12.12s.11 0 .15 0a.34.34 0 0 1 0 .16Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-39",
    transform: "translate(-24.77 -33.09)"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1447",
    d: "M48.68 45.87a.23.23 0 0 0 .15-.18.24.24 0 0 0 0-.12.14.14 0 0 0 .08.06s-.08.26-.26.26Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-39",
    transform: "translate(-24.77 -33.09)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1449",
    d: "M47.7 45.84a.2.2 0 0 1 .08.07l.08.08.34-.09.11-.11-.1-.14H48l-.27.19Z",
    style: {
      fill: "#b36b24"
    },
    transform: "translate(-24.77 -33.09)"
  }), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1451",
    d: "m48.52 45.72-.06-.08a.14.14 0 0 0-.07-.06.8.8 0 0 0-.25 0h-.15a.11.11 0 0 1-.11 0 1.3 1.3 0 0 1-.24-.08l-.17-.07a.5.5 0 0 0-.15 0 .8.8 0 0 0-.13.12s0 .06 0 .06h-.06a.62.62 0 0 0-.3.39c0 .25.43.63.6.44 0 0-.25-.19-.2-.34a.36.36 0 0 1 .36-.27c.2 0 .21 0 .29-.09a.29.29 0 0 1 .37 0c.12.13-.45.24-.45.24l.06.09s.7-.24.64-.37Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1453",
    d: "m48.52 45.72-.07-.08a.12.12 0 0 0-.07-.07h-.41a.1.1 0 0 1-.07 0l-.15-.05h-.09l-.16-.07h-.15a.4.4 0 0 0-.1.1h-.08a.6.6 0 0 0-.13.1.55.55 0 0 0-.17.3.5.5 0 0 0 .17.31.54.54 0 0 0 .32.16.2.2 0 0 0 .14-.06l-.11-.11a.25.25 0 0 1-.08-.17.6.6 0 0 1 .12-.18.5.5 0 0 1 .23-.07h.2l.1-.07a.34.34 0 0 1 .17 0 .24.24 0 0 1 .18.08l-.1.06-.22.07h-.14l.09.12.32-.13a1 1 0 0 0 .22-.11.2.2 0 0 0 .08-.07.07.07 0 0 0 0-.06.5.5 0 0 1-.15.1L48 46h-.17l.24-.06.16-.07h.06v-.05c0-.05 0 0 0 0a.24.24 0 0 0-.2-.08.3.3 0 0 0-.18 0l-.11.07h-.18a.4.4 0 0 0-.25.08.4.4 0 0 0-.13.19.33.33 0 0 0 .11.21.6.6 0 0 0 .11.1.14.14 0 0 1-.11 0 .54.54 0 0 1-.3-.14.46.46 0 0 1-.15-.29.55.55 0 0 1 .16-.29l.09-.07h.05v-.06h.08l.17.08.24.08h.48l.07.09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1455",
    d: "M47.21 46.32A.33.33 0 0 1 47 46a.45.45 0 0 1 .3-.37s0-.14.09-.16a.22.22 0 0 1 .17 0l.13.08s-.5.22-.5.51.07.23.07.23Z",
    style: {
      fill: "#fcf3d8"
    },
    transform: "translate(-24.77 -33.09)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1457",
    d: "M48.52 45.7a.31.31 0 0 0-.28-.12c-.13 0-.21.05-.3.05h-.17c-.11 0-.32-.17-.37-.15a.1.1 0 0 0-.06.11s-.09 0-.1 0 .07-.17.16-.17c.24 0 .42.16.53.16s.15-.06.31-.06.32.06.32.19Z",
    style: {
      fill: "#fdeaaf"
    },
    transform: "translate(-24.77 -33.09)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1459",
    d: "M47.74 45.88a1 1 0 0 0 .2-.06l.2-.07-.18.11a1 1 0 0 1-.19 0Z",
    style: {
      fill: "#513625"
    },
    transform: "translate(-24.77 -33.09)"
  }), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1461",
    d: "M47.34 46.47s-.12 0-.28-.1a.53.53 0 0 1-.2-.29.39.39 0 0 1 .13-.34c.16-.18.19-.13.2-.12l-.14.11-.08.12-.07.15v.13l.07.13.23.14.13.09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1463",
    d: "M47.25 45.48a.1.1 0 0 0 0 .05h.13-.09Z",
    style: {
      fill: "#8b5122"
    },
    transform: "translate(-24.77 -33.09)"
  }), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1465",
    d: "m47.73 45.73-.34.1h.21a.4.4 0 0 1 .12 0 .2.2 0 0 0 .08 0c.13 0 .41-.15.43 0s-.37.19-.37.19l.32-.08.17-.09v-.09l-.16-.11h-.46Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1467",
    d: "M47.24 46.22a.37.37 0 0 0 .14.2s0 0-.16 0-.27-.07-.37-.38v.07l.06.12.11.11.16.1h.26l-.1-.1-.13-.2a.2.2 0 0 0 0 .08Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon1469",
    d: "M23.6 16.14v.11h-.06l.01-.14z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon1471",
    d: "m23.18 13-.11-.12-.08.01.11.16z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1473",
    d: "m48.36 49.49-.15-.08a1 1 0 0 0-.22-.06h.19l.1.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-13",
    transform: "translate(-24.77 -33.09)"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1475",
    d: "M48.35 49.21h-.25c-.08 0-.13.05-.13.06a.3.3 0 0 1 .12 0h.24Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-13",
    transform: "translate(-24.77 -33.09)"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1477",
    d: "M48.32 49a2 2 0 0 0-.23.12l-.15.11.1-.07a.5.5 0 0 1 .14-.08h.08Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-13",
    transform: "translate(-24.77 -33.09)"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1479",
    d: "M48.17 48.72a.2.2 0 0 1 0 .11l-.06.07-.14.16-.08.09L48 49l.1-.11.06-.07a.3.3 0 0 0 0-.13Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-13",
    transform: "translate(-24.77 -33.09)"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1481",
    d: "M48 48.61v.07a.3.3 0 0 1 0 .12 2 2 0 0 1-.09.2 1 1 0 0 1 0 .08 3 3 0 0 0 .15-.32.3.3 0 0 0 0-.13.4.4 0 0 0 0-.09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-13",
    transform: "translate(-24.77 -33.09)"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1483",
    d: "M47.78 48.59v.07a.7.7 0 0 1 0 .16l-.06.16v.1s.06-.16.09-.26a.5.5 0 0 0 0-.17 1 1 0 0 0 0-.11Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-13",
    transform: "translate(-24.77 -33.09)"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1485",
    d: "M47.64 48.59a1 1 0 0 1 0 .11 1 1 0 0 1 0 .17 2 2 0 0 0 0 .23v-.25a1.4 1.4 0 0 0 0-.29Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-13",
    transform: "translate(-24.77 -33.09)"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1487",
    d: "M47.48 48.61a.3.3 0 0 1 0 .1v.11a1 1 0 0 0 0 .23 1 1 0 0 1 0-.08.7.7 0 0 1 0-.14.4.4 0 0 0 0-.12 1 1 0 0 0 0-.15Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-13",
    transform: "translate(-24.77 -33.09)"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1489",
    d: "M47.35 48.63a1 1 0 0 1 0 .2 1 1 0 0 0 0 .17v.09l.08-.27a1 1 0 0 0 0-.2Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-13",
    transform: "translate(-24.77 -33.09)"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1491",
    d: "M47.22 48.63v.06a.4.4 0 0 1 0 .19.6.6 0 0 1-.13.14.6.6 0 0 0 .22-.2.43.43 0 0 0 0-.21.2.2 0 0 0 0-.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-13",
    transform: "translate(-24.77 -33.09)"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1493",
    d: "M47.13 48.6a.5.5 0 0 1-.08.17.6.6 0 0 1-.12.11h-.05a.8.8 0 0 0 .2-.16.8.8 0 0 0 .1-.2Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-13",
    transform: "translate(-24.77 -33.09)"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1495",
    d: "M47 48.54v.12a.4.4 0 0 1-.09 0h.06l.09-.06H47v-.05Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-13",
    transform: "translate(-24.77 -33.09)"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1497",
    d: "m46.93 48.45-.09.09h.06l.14-.15Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-13",
    transform: "translate(-24.77 -33.09)"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1499",
    d: "m46.9 48.39-.08.06h-.08.06a1 1 0 0 0 .13-.09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-13",
    transform: "translate(-24.77 -33.09)"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1501",
    d: "M46.87 48.33h-.07l.13-.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-13",
    transform: "translate(-24.77 -33.09)"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1503",
    d: "M46.84 48.21h-.05a.1.1 0 0 1-.08 0 .2.2 0 0 0 .11 0Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-13",
    transform: "translate(-24.77 -33.09)"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1505",
    d: "m46.85 48-.05.05a.2.2 0 0 0-.07.08s0 0 .06-.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-13",
    transform: "translate(-24.77 -33.09)"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1507",
    d: "M47.83 46.84H48h-.13Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-13",
    transform: "translate(-24.77 -33.09)"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1509",
    d: "M47.83 46.76h.06l.09-.06h-.06l-.08.06h-.08Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-13",
    transform: "translate(-24.77 -33.09)"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1511",
    d: "M47.82 46.62h.07l.11-.06a.12.12 0 0 1 .08 0h-.06l-.11.07h-.09Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-13",
    transform: "translate(-24.77 -33.09)"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1513",
    d: "M47.77 46.49a.6.6 0 0 0 .14-.1l.14-.1-.15.11-.14.1Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-13",
    transform: "translate(-24.77 -33.09)"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1515",
    d: "m47.67 46.35.3-.21-.29.21Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-13",
    transform: "translate(-24.77 -33.09)"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1517",
    d: "m47.54 46.21.17-.12.14-.09-.13.09a1.3 1.3 0 0 0-.17.12Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-13",
    transform: "translate(-24.77 -33.09)"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1519",
    d: "m47.45 46.12.14-.1.1-.07h.07-.07l-.25.17Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-13",
    transform: "translate(-24.77 -33.09)"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1521",
    d: "M47.67 45.84a1.1 1.1 0 0 1 .22.22.66.66 0 0 1 .17.38.9.9 0 0 1-.23.46 7 7 0 0 1-.64.58 1.4 1.4 0 0 0-.27.28.56.56 0 0 0-.11.32.57.57 0 0 0 .1.31.41.41 0 0 0 .29.18h.58a.48.48 0 0 1 .4.17.8.8 0 0 1 .15.52 2 2 0 0 1 0 .38v.12a2.4 2.4 0 0 0 .07-.55.8.8 0 0 0-.16-.54.53.53 0 0 0-.42-.18h-.58a.38.38 0 0 1-.26-.16.5.5 0 0 1-.1-.3.6.6 0 0 1 .18-.39 7 7 0 0 1 .63-.57 1.1 1.1 0 0 0 .43-.68.73.73 0 0 0-.22-.39 2 2 0 0 0-.21-.2Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7",
    transform: "translate(-24.77 -33.09)"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1523",
    d: "M47.69 45.81",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1525",
    d: "M47.72 45.84h-.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-26",
    transform: "translate(-24.77 -33.09)"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1527",
    d: "M48.26 49.82a.1.1 0 0 0 .06 0Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-11",
    transform: "translate(-24.77 -33.09)"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon1529",
    d: "m22.69 13.03-.03-.03-.03.01.05.04z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon1531",
    d: "m22.79 13.11-.03-.02-.01.01.02.02z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon1533",
    d: "m22.91 13.26-.02-.03-.01.01.02.03z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon1535",
    d: "m23.01 13.4-.02-.03h-.02l.03.04z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon1537",
    d: "m23.06 13.53-.01-.04v.01l-.01.03z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon1539",
    d: "M23.07 13.67v-.04l-.02-.01v.05z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon1541",
    d: "m23.06 13.76.01-.05h-.02z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1543",
    d: "M46.72 48.19a.2.2 0 0 1 0-.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7",
    transform: "translate(-24.77 -33.09)"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1545",
    d: "M46.71 48.28",
    className: "nn-icon-flags-MX-delivery_svg__cls-1",
    transform: "translate(-24.77 -33.09)"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon1547",
    d: "M21.95 15.35v-.04l-.01-.01v.07z",
    className: "nn-icon-flags-MX-delivery_svg__cls-7"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon1549",
    d: "M21.96 15.44v-.04h-.02v.04z",
    className: "nn-icon-flags-MX-delivery_svg__cls-1"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon1551",
    d: "M21.98 15.56v-.03l-.01.01.01.03z",
    className: "nn-icon-flags-MX-delivery_svg__cls-1"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon1553",
    d: "m22.02 15.7-.02-.05h-.01l.02.05z",
    className: "nn-icon-flags-MX-delivery_svg__cls-1"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon1555",
    d: "m22.11 15.87-.02-.02-.02-.01.02.04z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1557",
    d: "M47 49.1",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1559",
    d: "M47.89 49.16",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1561",
    d: "M48 49.23",
    className: "nn-icon-flags-MX-delivery_svg__cls-1",
    transform: "translate(-24.77 -33.09)"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1563",
    d: "M48 49.26s0 .01 0 0",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1565",
    d: "M48 49.38",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon1567",
    d: "m23.18 16.42.01-.03h-.01l-.01.03z",
    className: "nn-icon-flags-MX-delivery_svg__cls-1"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path1569",
    d: "M46.59 44.77",
    className: "nn-icon-flags-MX-delivery_svg__cls-1",
    transform: "translate(-24.77 -33.09)"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path7832",
    d: "M53.81 51.82c-.17.15-.25.34-.18.43s.26 0 .43-.11.25-.34.18-.42-.24-.05-.43.1",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon693",
    d: "m29.76 18.25-.38.36.16.04.26-.35z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__polygon695",
    d: "m29.81 18.3-.05-.07-.01.01.01.01-.01.01.03.04-.25.34-.13-.04.37-.34-.01-.01-.01.01.01-.01-.01-.01-.4.37.19.05z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path697",
    d: "M54.7 51.19a.13.13 0 0 0-.18.06.11.11 0 0 0 0 .17.14.14 0 0 0 .18-.05.13.13 0 0 0 0-.18",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path699",
    d: "M54.7 51.19h-.07a.14.14 0 0 0-.12.07.1.1 0 0 0 0 .08.14.14 0 0 0 .07.11h.07a.16.16 0 0 0 .13-.08.2.2 0 0 0 0-.07.13.13 0 0 0-.07-.12.11.11 0 0 1 .06.1.14.14 0 0 1 0 .06.14.14 0 0 1-.11.06h-.06a.11.11 0 0 1-.06-.09.14.14 0 0 1 0-.07.14.14 0 0 1 .11-.06h.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path701",
    d: "M54.73 51.23a.15.15 0 0 0-.19.05.09.09 0 0 0 .05.14c.06 0 0 0 0 0h-.06v-.12h.12Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path703",
    d: "M54.5 51.48a.06.06 0 0 0-.07 0l-.13.07.21-.19v.11Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path807",
    d: "M54 51.54a.2.2 0 0 0 0 .11s.06 0 .07 0a.08.08 0 0 0 .07 0 .25.25 0 0 0 .08-.1s0-.07 0-.08-.14-.1-.16-.07h-.08v.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-17",
    transform: "translate(-24.77 -33.09)"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path809",
    d: "M54.18 51.59s-.06.06-.06.08v.07a.3.3 0 0 0 .09 0h.13s-.11-.15-.13-.13h-.1Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-17",
    transform: "translate(-24.77 -33.09)"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path811",
    d: "M54.23 51.93a.2.2 0 0 0 .13 0s0-.17 0-.16h-.09a.17.17 0 0 0 0 .1Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-17",
    transform: "translate(-24.77 -33.09)"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path813",
    d: "M54.13 51.61h-.09c-.02 0 0-.1 0-.11s0 0 .06 0h.06a.1.1 0 0 1 0 .06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path815",
    d: "M54.22 51.62a.14.14 0 0 0 0 .09s.11 0 .12 0-.06-.06-.08-.06Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MX-delivery_svg__path817",
    d: "M54.32 51.8v.06c0 .06.07 0 .08 0v-.07Z",
    className: "nn-icon-flags-MX-delivery_svg__cls-10",
    transform: "translate(-24.77 -33.09)"
  })));
};
export default SvgNnIconFlagsMxDelivery;